const CBOs = [
    {
        "code": "010105",
        "name": "Oficial general da aeron\u00e1utica"
    },
    {
        "code": "010110",
        "name": "Oficial general do ex\u00e9rcito"
    },
    {
        "code": "010115",
        "name": "Oficial general da marinha"
    },
    {
        "code": "010215",
        "name": "Oficial da marinha"
    },
    {
        "code": "010210",
        "name": "Oficial do ex\u00e9rcito"
    },
    {
        "code": "010205",
        "name": "Oficial da aeron\u00e1utica"
    },
    {
        "code": "010310",
        "name": "Pra\u00e7a do ex\u00e9rcito"
    },
    {
        "code": "010315",
        "name": "Pra\u00e7a da marinha"
    },
    {
        "code": "010305",
        "name": "Pra\u00e7a da aeron\u00e1utica"
    },
    {
        "code": "020115",
        "name": "Major da pol\u00edcia militar"
    },
    {
        "code": "020105",
        "name": "Coronel da pol\u00edcia militar"
    },
    {
        "code": "020110",
        "name": "Tenente-coronel da pol\u00edcia militar"
    },
    {
        "code": "020205",
        "name": "Capit\u00e3o da pol\u00edcia militar"
    },
    {
        "code": "020305",
        "name": "Primeiro tenente de pol\u00edcia militar"
    },
    {
        "code": "020310",
        "name": "Segundo tenente de pol\u00edcia militar"
    },
    {
        "code": "021105",
        "name": "Subtenente da policia militar"
    },
    {
        "code": "021110",
        "name": "Sargento da policia militar"
    },
    {
        "code": "021205",
        "name": "Cabo da pol\u00edcia militar"
    },
    {
        "code": "021210",
        "name": "Soldado da pol\u00edcia militar"
    },
    {
        "code": "030115",
        "name": "Tenente-coronel bombeiro militar"
    },
    {
        "code": "030105",
        "name": "Coronel bombeiro militar"
    },
    {
        "code": "030110",
        "name": "Major bombeiro militar"
    },
    {
        "code": "030205",
        "name": "Capit\u00e3o bombeiro militar"
    },
    {
        "code": "030305",
        "name": "Tenente do corpo de bombeiros militar"
    },
    {
        "code": "031105",
        "name": "Subtenente bombeiro militar"
    },
    {
        "code": "031110",
        "name": "Sargento bombeiro militar"
    },
    {
        "code": "031210",
        "name": "Soldado bombeiro militar"
    },
    {
        "code": "031205",
        "name": "Cabo bombeiro militar"
    },
    {
        "code": "111120",
        "name": "Vereador"
    },
    {
        "code": "111115",
        "name": "Deputado estadual e distrital"
    },
    {
        "code": "111110",
        "name": "Deputado federal"
    },
    {
        "code": "111105",
        "name": "Senador"
    },
    {
        "code": "111220",
        "name": "Secret\u00e1rio - executivo"
    },
    {
        "code": "111215",
        "name": "Ministro de estado"
    },
    {
        "code": "111255",
        "name": "Vice-prefeito"
    },
    {
        "code": "111250",
        "name": "Prefeito"
    },
    {
        "code": "111245",
        "name": "Vice-governador do distrito federal"
    },
    {
        "code": "111205",
        "name": "Presidente da rep\u00fablica"
    },
    {
        "code": "111225",
        "name": "Membro superior do poder executivo"
    },
    {
        "code": "111230",
        "name": "Governador de estado"
    },
    {
        "code": "111210",
        "name": "Vice-presidente da rep\u00fablica"
    },
    {
        "code": "111240",
        "name": "Vice-governador de estado"
    },
    {
        "code": "111235",
        "name": "Governador do distrito federal"
    },
    {
        "code": "111345",
        "name": "Juiz do trabalho"
    },
    {
        "code": "111340",
        "name": "Juiz auditor estadual - justi\u00e7a militar"
    },
    {
        "code": "111335",
        "name": "Juiz auditor federal - justi\u00e7a militar"
    },
    {
        "code": "111330",
        "name": "Juiz federal"
    },
    {
        "code": "111325",
        "name": "Juiz de direito"
    },
    {
        "code": "111320",
        "name": "Ministro do  superior tribunal do trabalho"
    },
    {
        "code": "111310",
        "name": "Ministro do superior tribunal de justi\u00e7a"
    },
    {
        "code": "111315",
        "name": "Ministro do  superior tribunal militar"
    },
    {
        "code": "111305",
        "name": "Ministro do supremo tribunal federal"
    },
    {
        "code": "111405",
        "name": "Dirigente do servi\u00e7o p\u00fablico federal"
    },
    {
        "code": "111410",
        "name": "Dirigente do servi\u00e7o p\u00fablico estadual e distrital"
    },
    {
        "code": "111415",
        "name": "Dirigente do servi\u00e7o p\u00fablico municipal"
    },
    {
        "code": "111505",
        "name": "Especialista de pol\u00edticas p\u00fablicas e gest\u00e3o governamental - eppgg"
    },
    {
        "code": "111510",
        "name": "Analista de planejamento e or\u00e7amento - apo"
    },
    {
        "code": "113015",
        "name": "Membro de lideran\u00e7a quilombola"
    },
    {
        "code": "113005",
        "name": "Cacique"
    },
    {
        "code": "113010",
        "name": "L\u00edder de comunidade cai\u00e7ara"
    },
    {
        "code": "114105",
        "name": "Dirigente de partido pol\u00edtico"
    },
    {
        "code": "114210",
        "name": "Dirigentes de entidades patronais"
    },
    {
        "code": "114205",
        "name": "Dirigentes de entidades de trabalhadores"
    },
    {
        "code": "114305",
        "name": "Dirigente e administrador de organiza\u00e7\u00e3o religiosa"
    },
    {
        "code": "114405",
        "name": "Dirigente e administrador de organiza\u00e7\u00e3o da sociedade civil sem fins lucrativos"
    },
    {
        "code": "121005",
        "name": "Diretor de planejamento estrat\u00e9gico"
    },
    {
        "code": "121010",
        "name": "Diretor geral de empresa e organiza\u00e7\u00f5es (exceto de interesse p\u00fablico)"
    },
    {
        "code": "122120",
        "name": "Diretor de produ\u00e7\u00e3o e opera\u00e7\u00f5es em empresa pesqueira"
    },
    {
        "code": "122115",
        "name": "Diretor de produ\u00e7\u00e3o e opera\u00e7\u00f5es em empresa florestal"
    },
    {
        "code": "122105",
        "name": "Diretor de produ\u00e7\u00e3o e opera\u00e7\u00f5es em empresa agropecu\u00e1ria"
    },
    {
        "code": "122110",
        "name": "Diretor de produ\u00e7\u00e3o e opera\u00e7\u00f5es em empresa aq\u00fc\u00edcola"
    },
    {
        "code": "122205",
        "name": "Diretor de produ\u00e7\u00e3o e opera\u00e7\u00f5es da ind\u00fastria de transforma\u00e7\u00e3o, extra\u00e7\u00e3o mineral e utilidades"
    },
    {
        "code": "122305",
        "name": "Diretor de opera\u00e7\u00f5es de obras p\u00fablica e civil"
    },
    {
        "code": "122405",
        "name": "Diretor de opera\u00e7\u00f5es comerciais (com\u00e9rcio atacadista e varejista)"
    },
    {
        "code": "122515",
        "name": "Diretor de  produ\u00e7\u00e3o e opera\u00e7\u00f5es de turismo"
    },
    {
        "code": "122520",
        "name": "Turism\u00f3logo"
    },
    {
        "code": "122505",
        "name": "Diretor de  produ\u00e7\u00e3o e opera\u00e7\u00f5es de alimenta\u00e7\u00e3o"
    },
    {
        "code": "122510",
        "name": "Diretor de  produ\u00e7\u00e3o e opera\u00e7\u00f5es de hotel"
    },
    {
        "code": "122620",
        "name": "Diretor de opera\u00e7\u00f5es de servi\u00e7os de transporte"
    },
    {
        "code": "122615",
        "name": "Diretor de opera\u00e7\u00f5es de servi\u00e7os de telecomunica\u00e7\u00f5es"
    },
    {
        "code": "122605",
        "name": "Diretor de opera\u00e7\u00f5es de correios"
    },
    {
        "code": "122610",
        "name": "Diretor de opera\u00e7\u00f5es de servi\u00e7os de armazenamento"
    },
    {
        "code": "122705",
        "name": "Diretor comercial em opera\u00e7\u00f5es de intermedia\u00e7\u00e3o financeira"
    },
    {
        "code": "122710",
        "name": "Diretor de produtos banc\u00e1rios"
    },
    {
        "code": "122715",
        "name": "Diretor de cr\u00e9dito rural"
    },
    {
        "code": "122720",
        "name": "Diretor de c\u00e2mbio e com\u00e9rcio exterior"
    },
    {
        "code": "122725",
        "name": "Diretor de compliance"
    },
    {
        "code": "122730",
        "name": "Diretor de cr\u00e9dito (exceto cr\u00e9dito imobili\u00e1rio)"
    },
    {
        "code": "122735",
        "name": "Diretor de cr\u00e9dito imobili\u00e1rio"
    },
    {
        "code": "122740",
        "name": "Diretor de leasing"
    },
    {
        "code": "122745",
        "name": "Diretor de mercado de capitais"
    },
    {
        "code": "122750",
        "name": "Diretor de recupera\u00e7\u00e3o de cr\u00e9ditos em opera\u00e7\u00f5es de intermedia\u00e7\u00e3o financeira"
    },
    {
        "code": "122755",
        "name": "Diretor de riscos de mercado"
    },
    {
        "code": "123105",
        "name": "Diretor administrativo"
    },
    {
        "code": "123110",
        "name": "Diretor administrativo e financeiro"
    },
    {
        "code": "123115",
        "name": "Diretor financeiro"
    },
    {
        "code": "123205",
        "name": "Diretor de recursos humanos"
    },
    {
        "code": "123210",
        "name": "Diretor de rela\u00e7\u00f5es de trabalho"
    },
    {
        "code": "123305",
        "name": "Diretor comercial"
    },
    {
        "code": "123310",
        "name": "Diretor de marketing"
    },
    {
        "code": "123405",
        "name": "Diretor de suprimentos"
    },
    {
        "code": "123410",
        "name": "Diretor de suprimentos no servi\u00e7o p\u00fablico"
    },
    {
        "code": "123605",
        "name": "Diretor de servi\u00e7os de inform\u00e1tica"
    },
    {
        "code": "123705",
        "name": "Diretor de pesquisa e desenvolvimento (p&d)"
    },
    {
        "code": "123805",
        "name": "Diretor de manuten\u00e7\u00e3o"
    },
    {
        "code": "131105",
        "name": "Diretor de servi\u00e7os culturais"
    },
    {
        "code": "131120",
        "name": "Gerente de servi\u00e7os sociais"
    },
    {
        "code": "131115",
        "name": "Gerente de servi\u00e7os culturais"
    },
    {
        "code": "131110",
        "name": "Diretor de servi\u00e7os sociais"
    },
    {
        "code": "131205",
        "name": "Diretor de servi\u00e7os de sa\u00fade"
    },
    {
        "code": "131210",
        "name": "Gerente de servi\u00e7os de sa\u00fade"
    },
    {
        "code": "131215",
        "name": "Tecn\u00f3logo em gest\u00e3o hospitalar"
    },
    {
        "code": "131225",
        "name": "Sanitarista"
    },
    {
        "code": "131220",
        "name": "Geront\u00f3logo"
    },
    {
        "code": "131320",
        "name": "Gerente de servi\u00e7os educacionais da \u00e1rea p\u00fablica"
    },
    {
        "code": "131310",
        "name": "Diretor de institui\u00e7\u00e3o educacional p\u00fablica"
    },
    {
        "code": "131315",
        "name": "Gerente de institui\u00e7\u00e3o educacional da \u00e1rea privada"
    },
    {
        "code": "131305",
        "name": "Diretor de institui\u00e7\u00e3o educacional da \u00e1rea privada"
    },
    {
        "code": "141105",
        "name": "Gerente de produ\u00e7\u00e3o e opera\u00e7\u00f5es  aq\u00fc\u00edcolas"
    },
    {
        "code": "141120",
        "name": "Gerente de produ\u00e7\u00e3o e opera\u00e7\u00f5es pesqueiras"
    },
    {
        "code": "141115",
        "name": "Gerente de produ\u00e7\u00e3o e opera\u00e7\u00f5es agropecu\u00e1rias"
    },
    {
        "code": "141110",
        "name": "Gerente de produ\u00e7\u00e3o e opera\u00e7\u00f5es  florestais"
    },
    {
        "code": "141205",
        "name": "Gerente de produ\u00e7\u00e3o e opera\u00e7\u00f5es"
    },
    {
        "code": "141305",
        "name": "Gerente de produ\u00e7\u00e3o e opera\u00e7\u00f5es da constru\u00e7\u00e3o civil e obras p\u00fablicas"
    },
    {
        "code": "141405",
        "name": "Comerciante atacadista"
    },
    {
        "code": "141410",
        "name": "Comerciante varejista"
    },
    {
        "code": "141415",
        "name": "Gerente de loja e supermercado"
    },
    {
        "code": "141420",
        "name": "Gerente de opera\u00e7\u00f5es de servi\u00e7os de assist\u00eancia t\u00e9cnica"
    },
    {
        "code": "141505",
        "name": "Gerente de hotel"
    },
    {
        "code": "141525",
        "name": "Gerente de turismo"
    },
    {
        "code": "141510",
        "name": "Gerente de restaurante"
    },
    {
        "code": "141520",
        "name": "Gerente de pens\u00e3o"
    },
    {
        "code": "141515",
        "name": "Gerente de bar"
    },
    {
        "code": "141615",
        "name": "Gerente de log\u00edstica (armazenagem e distribui\u00e7\u00e3o)"
    },
    {
        "code": "141605",
        "name": "Gerente de opera\u00e7\u00f5es de transportes"
    },
    {
        "code": "141610",
        "name": "Gerente de opera\u00e7\u00f5es de correios e telecomunica\u00e7\u00f5es"
    },
    {
        "code": "141720",
        "name": "Gerente de cr\u00e9dito e cobran\u00e7a"
    },
    {
        "code": "141705",
        "name": "Gerente de produtos banc\u00e1rios"
    },
    {
        "code": "141710",
        "name": "Gerente de ag\u00eancia"
    },
    {
        "code": "141735",
        "name": "Gerente de recupera\u00e7\u00e3o de cr\u00e9dito"
    },
    {
        "code": "141730",
        "name": "Gerente de cr\u00e9dito rural"
    },
    {
        "code": "141725",
        "name": "Gerente de cr\u00e9dito imobili\u00e1rio"
    },
    {
        "code": "141715",
        "name": "Gerente de c\u00e2mbio e com\u00e9rcio exterior"
    },
    {
        "code": "142110",
        "name": "Gerente de riscos"
    },
    {
        "code": "142120",
        "name": "Tecn\u00f3logo em gest\u00e3o administrativo- financeira"
    },
    {
        "code": "142105",
        "name": "Gerente administrativo"
    },
    {
        "code": "142115",
        "name": "Gerente financeiro"
    },
    {
        "code": "142205",
        "name": "Gerente de recursos humanos"
    },
    {
        "code": "142210",
        "name": "Gerente de departamento pessoal"
    },
    {
        "code": "142330",
        "name": "Analista de neg\u00f3cios"
    },
    {
        "code": "142325",
        "name": "Rela\u00e7\u00f5es p\u00fablicas"
    },
    {
        "code": "142340",
        "name": "Ouvidor"
    },
    {
        "code": "142335",
        "name": "Analista de pesquisa de mercado"
    },
    {
        "code": "142320",
        "name": "Gerente de vendas"
    },
    {
        "code": "142315",
        "name": "Gerente de marketing"
    },
    {
        "code": "142310",
        "name": "Gerente de comunica\u00e7\u00e3o"
    },
    {
        "code": "142305",
        "name": "Gerente comercial"
    },
    {
        "code": "142415",
        "name": "Gerente de almoxarifado"
    },
    {
        "code": "142405",
        "name": "Gerente de compras"
    },
    {
        "code": "142410",
        "name": "Gerente de suprimentos"
    },
    {
        "code": "142530",
        "name": "Gerente de suporte t\u00e9cnico de tecnologia da informa\u00e7\u00e3o"
    },
    {
        "code": "142505",
        "name": "Gerente de rede"
    },
    {
        "code": "142520",
        "name": "Gerente de projetos de tecnologia da informa\u00e7\u00e3o"
    },
    {
        "code": "142515",
        "name": "Gerente de produ\u00e7\u00e3o de tecnologia da informa\u00e7\u00e3o"
    },
    {
        "code": "142535",
        "name": "Tecn\u00f3logo em gest\u00e3o da tecnologia da informa\u00e7\u00e3o"
    },
    {
        "code": "142525",
        "name": "Gerente de seguran\u00e7a de tecnologia da informa\u00e7\u00e3o"
    },
    {
        "code": "142510",
        "name": "Gerente de desenvolvimento de sistemas"
    },
    {
        "code": "142605",
        "name": "Gerente de pesquisa e desenvolvimento (p&d)"
    },
    {
        "code": "142610",
        "name": "Especialista em desenvolvimento de cigarros"
    },
    {
        "code": "142710",
        "name": "Tecn\u00f3logo em sistemas biom\u00e9dicos"
    },
    {
        "code": "142705",
        "name": "Gerente de projetos e servi\u00e7os de manuten\u00e7\u00e3o"
    },
    {
        "code": "201105",
        "name": "Bioengenheiro"
    },
    {
        "code": "201110",
        "name": "Biotecnologista"
    },
    {
        "code": "201115",
        "name": "Geneticista"
    },
    {
        "code": "201220",
        "name": "Especialista em instrumenta\u00e7\u00e3o metrol\u00f3gica"
    },
    {
        "code": "201215",
        "name": "Especialista em ensaios metrol\u00f3gicos"
    },
    {
        "code": "201210",
        "name": "Especialista em calibra\u00e7\u00f5es metrol\u00f3gicas"
    },
    {
        "code": "201225",
        "name": "Especialista em materiais de refer\u00eancia metrol\u00f3gica"
    },
    {
        "code": "201205",
        "name": "Pesquisador em metrologia"
    },
    {
        "code": "202115",
        "name": "Tecn\u00f3logo em mecatr\u00f4nica"
    },
    {
        "code": "202120",
        "name": "Tecn\u00f3logo em automa\u00e7\u00e3o industrial"
    },
    {
        "code": "202110",
        "name": "Engenheiro de controle e automa\u00e7\u00e3o"
    },
    {
        "code": "202105",
        "name": "Engenheiro mecatr\u00f4nico"
    },
    {
        "code": "203005",
        "name": "Pesquisador em biologia ambiental"
    },
    {
        "code": "203010",
        "name": "Pesquisador em biologia animal"
    },
    {
        "code": "203015",
        "name": "Pesquisador em biologia de microorganismos e parasitas"
    },
    {
        "code": "203020",
        "name": "Pesquisador em biologia humana"
    },
    {
        "code": "203025",
        "name": "Pesquisador em biologia vegetal"
    },
    {
        "code": "203115",
        "name": "Pesquisador em f\u00edsica"
    },
    {
        "code": "203110",
        "name": "Pesquisador em ci\u00eancias da terra e meio ambiente"
    },
    {
        "code": "203105",
        "name": "Pesquisador em ci\u00eancias da computa\u00e7\u00e3o e inform\u00e1tica"
    },
    {
        "code": "203120",
        "name": "Pesquisador em matem\u00e1tica"
    },
    {
        "code": "203125",
        "name": "Pesquisador em qu\u00edmica"
    },
    {
        "code": "203215",
        "name": "Pesquisador de engenharia el\u00e9trica e eletr\u00f4nica"
    },
    {
        "code": "203210",
        "name": "Pesquisador de engenharia e tecnologia (outras \u00e1reas da engenharia)"
    },
    {
        "code": "203205",
        "name": "Pesquisador de engenharia civil"
    },
    {
        "code": "203220",
        "name": "Pesquisador de engenharia mec\u00e2nica"
    },
    {
        "code": "203225",
        "name": "Pesquisador de engenharia metal\u00fargica, de minas e de materiais"
    },
    {
        "code": "203230",
        "name": "Pesquisador de engenharia qu\u00edmica"
    },
    {
        "code": "203315",
        "name": "Pesquisador em medicina veterin\u00e1ria"
    },
    {
        "code": "203310",
        "name": "Pesquisador de medicina b\u00e1sica"
    },
    {
        "code": "203305",
        "name": "Pesquisador de cl\u00ednica m\u00e9dica"
    },
    {
        "code": "203320",
        "name": "Pesquisador em sa\u00fade coletiva"
    },
    {
        "code": "203405",
        "name": "Pesquisador em ci\u00eancias agron\u00f4micas"
    },
    {
        "code": "203410",
        "name": "Pesquisador em ci\u00eancias da pesca e aq\u00fcicultura"
    },
    {
        "code": "203415",
        "name": "Pesquisador em ci\u00eancias da zootecnia"
    },
    {
        "code": "203420",
        "name": "Pesquisador em ci\u00eancias florestais"
    },
    {
        "code": "203505",
        "name": "Pesquisador em ci\u00eancias sociais e humanas"
    },
    {
        "code": "203510",
        "name": "Pesquisador em economia"
    },
    {
        "code": "203515",
        "name": "Pesquisador em ci\u00eancias da educa\u00e7\u00e3o"
    },
    {
        "code": "203520",
        "name": "Pesquisador em hist\u00f3ria"
    },
    {
        "code": "203525",
        "name": "Pesquisador em psicologia"
    },
    {
        "code": "204105",
        "name": "Perito criminal"
    },
    {
        "code": "211120",
        "name": "Matem\u00e1tico aplicado"
    },
    {
        "code": "211105",
        "name": "Atu\u00e1rio"
    },
    {
        "code": "211110",
        "name": "Especialista em pesquisa operacional"
    },
    {
        "code": "211115",
        "name": "Matem\u00e1tico"
    },
    {
        "code": "211215",
        "name": "Estat\u00edstico te\u00f3rico"
    },
    {
        "code": "211205",
        "name": "Estat\u00edstico"
    },
    {
        "code": "211210",
        "name": "Estat\u00edstico (estat\u00edstica aplicada)"
    },
    {
        "code": "212210",
        "name": "Engenheiro de equipamentos em computa\u00e7\u00e3o"
    },
    {
        "code": "212205",
        "name": "Engenheiro de aplicativos em computa\u00e7\u00e3o"
    },
    {
        "code": "212215",
        "name": "Engenheiros de sistemas operacionais em computa\u00e7\u00e3o"
    },
    {
        "code": "212320",
        "name": "Administrador em seguran\u00e7a da informa\u00e7\u00e3o"
    },
    {
        "code": "212310",
        "name": "Administrador de redes"
    },
    {
        "code": "212305",
        "name": "Administrador de banco de dados"
    },
    {
        "code": "212315",
        "name": "Administrador de sistemas operacionais"
    },
    {
        "code": "212415",
        "name": "Analista de sistemas de automa\u00e7\u00e3o"
    },
    {
        "code": "212420",
        "name": "Analista de suporte computacional"
    },
    {
        "code": "212410",
        "name": "Analista de redes e de comunica\u00e7\u00e3o de dados"
    },
    {
        "code": "212405",
        "name": "Analista de desenvolvimento de sistemas"
    },
    {
        "code": "213110",
        "name": "F\u00edsico (ac\u00fastica)"
    },
    {
        "code": "213170",
        "name": "F\u00edsico (plasma)"
    },
    {
        "code": "213175",
        "name": "F\u00edsico (t\u00e9rmica)"
    },
    {
        "code": "213165",
        "name": "F\u00edsico (part\u00edculas e campos)"
    },
    {
        "code": "213160",
        "name": "F\u00edsico (\u00f3ptica)"
    },
    {
        "code": "213155",
        "name": "F\u00edsico (nuclear e reatores)"
    },
    {
        "code": "213150",
        "name": "F\u00edsico (medicina)"
    },
    {
        "code": "213145",
        "name": "F\u00edsico (materiais)"
    },
    {
        "code": "213125",
        "name": "F\u00edsico (estat\u00edstica e matem\u00e1tica)"
    },
    {
        "code": "213140",
        "name": "F\u00edsico (mat\u00e9ria condensada)"
    },
    {
        "code": "213105",
        "name": "F\u00edsico"
    },
    {
        "code": "213115",
        "name": "F\u00edsico (at\u00f4mica e molecular)"
    },
    {
        "code": "213120",
        "name": "F\u00edsico (cosmologia)"
    },
    {
        "code": "213130",
        "name": "F\u00edsico (fluidos)"
    },
    {
        "code": "213135",
        "name": "F\u00edsico (instrumenta\u00e7\u00e3o)"
    },
    {
        "code": "213215",
        "name": "Tecn\u00f3logo em processos qu\u00edmicos"
    },
    {
        "code": "213210",
        "name": "Qu\u00edmico industrial"
    },
    {
        "code": "213205",
        "name": "Qu\u00edmico"
    },
    {
        "code": "213305",
        "name": "Astr\u00f4nomo"
    },
    {
        "code": "213315",
        "name": "Meteorologista"
    },
    {
        "code": "213310",
        "name": "Geof\u00edsico espacial"
    },
    {
        "code": "213440",
        "name": "Ocean\u00f3grafo"
    },
    {
        "code": "213425",
        "name": "Hidroge\u00f3logo"
    },
    {
        "code": "213420",
        "name": "Geoqu\u00edmico"
    },
    {
        "code": "213415",
        "name": "Geof\u00edsico"
    },
    {
        "code": "213410",
        "name": "Ge\u00f3logo de engenharia"
    },
    {
        "code": "213435",
        "name": "Petr\u00f3grafo"
    },
    {
        "code": "213430",
        "name": "Paleont\u00f3logo"
    },
    {
        "code": "213405",
        "name": "Ge\u00f3logo"
    },
    {
        "code": "214010",
        "name": "Tecn\u00f3logo em meio ambiente"
    },
    {
        "code": "214005",
        "name": "Engenheiro ambiental"
    },
    {
        "code": "214105",
        "name": "Arquiteto de edifica\u00e7\u00f5es"
    },
    {
        "code": "214120",
        "name": "Arquiteto paisagista"
    },
    {
        "code": "214115",
        "name": "Arquiteto de patrim\u00f4nio"
    },
    {
        "code": "214110",
        "name": "Arquiteto de interiores"
    },
    {
        "code": "214130",
        "name": "Urbanista"
    },
    {
        "code": "214125",
        "name": "Arquiteto urbanista"
    },
    {
        "code": "214205",
        "name": "Engenheiro civil"
    },
    {
        "code": "214210",
        "name": "Engenheiro civil (aeroportos)"
    },
    {
        "code": "214215",
        "name": "Engenheiro civil (edifica\u00e7\u00f5es)"
    },
    {
        "code": "214220",
        "name": "Engenheiro civil (estruturas met\u00e1licas)"
    },
    {
        "code": "214225",
        "name": "Engenheiro civil (ferrovias e metrovias)"
    },
    {
        "code": "214230",
        "name": "Engenheiro civil (geot\u00e9cnia)"
    },
    {
        "code": "214235",
        "name": "Engenheiro civil (hidrologia)"
    },
    {
        "code": "214240",
        "name": "Engenheiro civil (hidr\u00e1ulica)"
    },
    {
        "code": "214245",
        "name": "Engenheiro civil (pontes e viadutos)"
    },
    {
        "code": "214250",
        "name": "Engenheiro civil (portos e vias naveg\u00e1veis)"
    },
    {
        "code": "214255",
        "name": "Engenheiro civil (rodovias)"
    },
    {
        "code": "214260",
        "name": "Engenheiro civil (saneamento)"
    },
    {
        "code": "214265",
        "name": "Engenheiro civil (t\u00faneis)"
    },
    {
        "code": "214270",
        "name": "Engenheiro civil (transportes e tr\u00e2nsito)"
    },
    {
        "code": "214280",
        "name": "Tecn\u00f3logo em constru\u00e7\u00e3o civil"
    },
    {
        "code": "214330",
        "name": "Engenheiro eletr\u00f4nico de projetos"
    },
    {
        "code": "214315",
        "name": "Engenheiro eletricista de manuten\u00e7\u00e3o"
    },
    {
        "code": "214320",
        "name": "Engenheiro eletricista de projetos"
    },
    {
        "code": "214325",
        "name": "Engenheiro eletr\u00f4nico de manuten\u00e7\u00e3o"
    },
    {
        "code": "214335",
        "name": "Engenheiro de manuten\u00e7\u00e3o de telecomunica\u00e7\u00f5es"
    },
    {
        "code": "214340",
        "name": "Engenheiro de telecomunica\u00e7\u00f5es"
    },
    {
        "code": "214345",
        "name": "Engenheiro projetista de telecomunica\u00e7\u00f5es"
    },
    {
        "code": "214350",
        "name": "Engenheiro de redes de comunica\u00e7\u00e3o"
    },
    {
        "code": "214360",
        "name": "Tecn\u00f3logo em eletricidade"
    },
    {
        "code": "214365",
        "name": "Tecn\u00f3logo em eletr\u00f4nica"
    },
    {
        "code": "214310",
        "name": "Engenheiro eletr\u00f4nico"
    },
    {
        "code": "214305",
        "name": "Engenheiro eletricista"
    },
    {
        "code": "214370",
        "name": "Tecn\u00f3logo em telecomunica\u00e7\u00f5es"
    },
    {
        "code": "214425",
        "name": "Engenheiro aeron\u00e1utico"
    },
    {
        "code": "214420",
        "name": "Engenheiro mec\u00e2nico industrial"
    },
    {
        "code": "214415",
        "name": "Engenheiro mec\u00e2nico (energia nuclear)"
    },
    {
        "code": "214410",
        "name": "Engenheiro mec\u00e2nico automotivo"
    },
    {
        "code": "214405",
        "name": "Engenheiro mec\u00e2nico"
    },
    {
        "code": "214430",
        "name": "Engenheiro naval"
    },
    {
        "code": "214435",
        "name": "Tecn\u00f3logo em fabrica\u00e7\u00e3o mec\u00e2nica"
    },
    {
        "code": "214535",
        "name": "Tecn\u00f3logo em produ\u00e7\u00e3o sulcroalcooleira"
    },
    {
        "code": "214520",
        "name": "Engenheiro qu\u00edmico (papel e celulose)"
    },
    {
        "code": "214525",
        "name": "Engenheiro qu\u00edmico (petr\u00f3leo e borracha)"
    },
    {
        "code": "214530",
        "name": "Engenheiro qu\u00edmico (utilidades e meio ambiente)"
    },
    {
        "code": "214515",
        "name": "Engenheiro qu\u00edmico (minera\u00e7\u00e3o, metalurgia, siderurgia, cimenteira e cer\u00e2mica)"
    },
    {
        "code": "214510",
        "name": "Engenheiro qu\u00edmico (ind\u00fastria qu\u00edmica)"
    },
    {
        "code": "214505",
        "name": "Engenheiro qu\u00edmico"
    },
    {
        "code": "214605",
        "name": "Engenheiro de materiais"
    },
    {
        "code": "214615",
        "name": "Tecn\u00f3logo em metalurgia"
    },
    {
        "code": "214610",
        "name": "Engenheiro metalurgista"
    },
    {
        "code": "214730",
        "name": "Engenheiro de minas (planejamento)"
    },
    {
        "code": "214735",
        "name": "Engenheiro de minas (processo)"
    },
    {
        "code": "214750",
        "name": "Tecn\u00f3logo em rochas ornamentais"
    },
    {
        "code": "214745",
        "name": "Tecn\u00f3logo em petr\u00f3leo e g\u00e1s"
    },
    {
        "code": "214740",
        "name": "Engenheiro de minas (projeto)"
    },
    {
        "code": "214705",
        "name": "Engenheiro de minas"
    },
    {
        "code": "214710",
        "name": "Engenheiro de minas (beneficiamento)"
    },
    {
        "code": "214715",
        "name": "Engenheiro de minas (lavra a c\u00e9u aberto)"
    },
    {
        "code": "214720",
        "name": "Engenheiro de minas (lavra subterr\u00e2nea)"
    },
    {
        "code": "214725",
        "name": "Engenheiro de minas (pesquisa mineral)"
    },
    {
        "code": "214810",
        "name": "Engenheiro cart\u00f3grafo"
    },
    {
        "code": "214805",
        "name": "Engenheiro agrimensor"
    },
    {
        "code": "214935",
        "name": "Tecn\u00f3logo em seguran\u00e7a do trabalho"
    },
    {
        "code": "214930",
        "name": "Tecn\u00f3logo em produ\u00e7\u00e3o industrial"
    },
    {
        "code": "214925",
        "name": "Engenheiro de tempos e movimentos"
    },
    {
        "code": "214905",
        "name": "Engenheiro de produ\u00e7\u00e3o"
    },
    {
        "code": "214910",
        "name": "Engenheiro de controle de qualidade"
    },
    {
        "code": "214940",
        "name": "Higienista ocupacional"
    },
    {
        "code": "214920",
        "name": "Engenheiro de riscos"
    },
    {
        "code": "214915",
        "name": "Engenheiro de seguran\u00e7a do trabalho"
    },
    {
        "code": "215105",
        "name": "Agente de manobra e docagem"
    },
    {
        "code": "215110",
        "name": "Capit\u00e3o de manobra da marinha mercante"
    },
    {
        "code": "215150",
        "name": "Vistoriador naval"
    },
    {
        "code": "215145",
        "name": "Pr\u00e1tico de portos da marinha mercante"
    },
    {
        "code": "215140",
        "name": "Oficial de quarto de navega\u00e7\u00e3o da marinha mercante"
    },
    {
        "code": "215135",
        "name": "Inspetor naval"
    },
    {
        "code": "215130",
        "name": "Inspetor de terminal"
    },
    {
        "code": "215125",
        "name": "Imediato da marinha mercante"
    },
    {
        "code": "215115",
        "name": "Comandante da marinha mercante"
    },
    {
        "code": "215120",
        "name": "Coordenador de opera\u00e7\u00f5es de combate \u00e0 polui\u00e7\u00e3o no meio aquavi\u00e1rio"
    },
    {
        "code": "215220",
        "name": "Superintendente t\u00e9cnico no transporte aquavi\u00e1rio"
    },
    {
        "code": "215215",
        "name": "Segundo oficial de m\u00e1quinas da marinha mercante"
    },
    {
        "code": "215210",
        "name": "Primeiro oficial de m\u00e1quinas da marinha mercante"
    },
    {
        "code": "215205",
        "name": "Oficial superior de m\u00e1quinas da marinha mercante"
    },
    {
        "code": "215310",
        "name": "Piloto de ensaios em v\u00f4o"
    },
    {
        "code": "215305",
        "name": "Piloto de aeronaves"
    },
    {
        "code": "215315",
        "name": "Instrutor de v\u00f4o"
    },
    {
        "code": "221105",
        "name": "Bi\u00f3logo"
    },
    {
        "code": "221205",
        "name": "Biom\u00e9dico"
    },
    {
        "code": "222105",
        "name": "Engenheiro agr\u00edcola"
    },
    {
        "code": "222110",
        "name": "Engenheiro agr\u00f4nomo"
    },
    {
        "code": "222115",
        "name": "Engenheiro de pesca"
    },
    {
        "code": "222120",
        "name": "Engenheiro florestal"
    },
    {
        "code": "222205",
        "name": "Engenheiro de alimentos"
    },
    {
        "code": "222215",
        "name": "Tecn\u00f3logo em alimentos"
    },
    {
        "code": "223264",
        "name": "Cirurgi\u00e3o dentista - reabilitador oral"
    },
    {
        "code": "223268",
        "name": "Cirurgi\u00e3o dentista - traumatologista bucomaxilofacial"
    },
    {
        "code": "223272",
        "name": "Cirurgi\u00e3o dentista de sa\u00fade coletiva"
    },
    {
        "code": "223276",
        "name": "Cirurgi\u00e3o dentista - odontologia do trabalho"
    },
    {
        "code": "223280",
        "name": "Cirurgi\u00e3o dentista - dent\u00edstica"
    },
    {
        "code": "223284",
        "name": "Cirurgi\u00e3o dentista - disfun\u00e7\u00e3o temporomandibular e dor orofacial"
    },
    {
        "code": "223288",
        "name": "Cirurgi\u00e3o dentista - odontologia para pacientes com necessidades especiais"
    },
    {
        "code": "223293",
        "name": "Cirurgi\u00e3o-dentista da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        "code": "223260",
        "name": "Cirurgi\u00e3o dentista - radiologista"
    },
    {
        "code": "223256",
        "name": "Cirurgi\u00e3o dentista - protesista"
    },
    {
        "code": "223252",
        "name": "Cirurgi\u00e3o dentista - protesi\u00f3logo bucomaxilofacial"
    },
    {
        "code": "223248",
        "name": "Cirurgi\u00e3o dentista - periodontista"
    },
    {
        "code": "223244",
        "name": "Cirurgi\u00e3o dentista - patologista bucal"
    },
    {
        "code": "223240",
        "name": "Cirurgi\u00e3o dentista - ortopedista e ortodontista"
    },
    {
        "code": "223236",
        "name": "Cirurgi\u00e3o dentista - odontopediatra"
    },
    {
        "code": "223228",
        "name": "Cirurgi\u00e3o dentista - odontogeriatra"
    },
    {
        "code": "223232",
        "name": "Cirurgi\u00e3o dentista - odontologista legal"
    },
    {
        "code": "223224",
        "name": "Cirurgi\u00e3o dentista - implantodontista"
    },
    {
        "code": "223220",
        "name": "Cirurgi\u00e3o dentista - estomatologista"
    },
    {
        "code": "223216",
        "name": "Cirurgi\u00e3o dentista - epidemiologista"
    },
    {
        "code": "223212",
        "name": "Cirurgi\u00e3o dentista - endodontista"
    },
    {
        "code": "223208",
        "name": "Cirurgi\u00e3o dentista - cl\u00ednico geral"
    },
    {
        "code": "223204",
        "name": "Cirurgi\u00e3o dentista - auditor"
    },
    {
        "code": "223305",
        "name": "M\u00e9dico veterin\u00e1rio"
    },
    {
        "code": "223310",
        "name": "Zootecnista"
    },
    {
        "code": "223415",
        "name": "Farmac\u00eautico analista cl\u00ednico"
    },
    {
        "code": "223405",
        "name": "Farmac\u00eautico"
    },
    {
        "code": "223440",
        "name": "Farmac\u00eautico toxicologista"
    },
    {
        "code": "223435",
        "name": "Farmac\u00eautico industrial"
    },
    {
        "code": "223445",
        "name": "Farmac\u00eautico hospitalar e cl\u00ednico"
    },
    {
        "code": "223425",
        "name": "Farmac\u00eautico pr\u00e1ticas integrativas e complementares"
    },
    {
        "code": "223430",
        "name": "Farmac\u00eautico em sa\u00fade p\u00fablica"
    },
    {
        "code": "223420",
        "name": "Farmac\u00eautico de alimentos"
    },
    {
        "code": "223555",
        "name": "Enfermeiro puericultor e pedi\u00e1trico"
    },
    {
        "code": "223560",
        "name": "Enfermeiro sanitarista"
    },
    {
        "code": "223565",
        "name": "Enfermeiro da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        "code": "223550",
        "name": "Enfermeiro psiqui\u00e1trico"
    },
    {
        "code": "223545",
        "name": "Enfermeiro obst\u00e9trico"
    },
    {
        "code": "223540",
        "name": "Enfermeiro neonatologista"
    },
    {
        "code": "223535",
        "name": "Enfermeiro nefrologista"
    },
    {
        "code": "223530",
        "name": "Enfermeiro do trabalho"
    },
    {
        "code": "223525",
        "name": "Enfermeiro de terapia intensiva"
    },
    {
        "code": "223520",
        "name": "Enfermeiro de centro cir\u00fargico"
    },
    {
        "code": "223570",
        "name": "Perfusionista"
    },
    {
        "code": "223505",
        "name": "Enfermeiro"
    },
    {
        "code": "223515",
        "name": "Enfermeiro de bordo"
    },
    {
        "code": "223510",
        "name": "Enfermeiro auditor"
    },
    {
        "code": "223655",
        "name": "Fisioterapeuta esportivo"
    },
    {
        "code": "223660",
        "name": "Fisioterapeuta  do trabalho"
    },
    {
        "code": "223645",
        "name": "Fisioterapeuta quiropraxista"
    },
    {
        "code": "223640",
        "name": "Fisioterapeuta osteopata"
    },
    {
        "code": "223635",
        "name": "Fisioterapeuta traumato-ortop\u00e9dica funcional"
    },
    {
        "code": "223630",
        "name": "Fisioterapeuta neurofuncional"
    },
    {
        "code": "223650",
        "name": "Fisioterapeuta acupunturista"
    },
    {
        "code": "223625",
        "name": "Fisioterapeuta respirat\u00f3ria"
    },
    {
        "code": "223605",
        "name": "Fisioterapeuta geral"
    },
    {
        "code": "223705",
        "name": "Dietista"
    },
    {
        "code": "223710",
        "name": "Nutricionista"
    },
    {
        "code": "223810",
        "name": "Fonoaudi\u00f3logo geral"
    },
    {
        "code": "223825",
        "name": "Fonoaudi\u00f3logo em disfagia"
    },
    {
        "code": "223830",
        "name": "Fonoaudi\u00f3logo em linguagem"
    },
    {
        "code": "223835",
        "name": "Fonoaudi\u00f3logo em motricidade orofacial"
    },
    {
        "code": "223820",
        "name": "Fonoaudi\u00f3logo em audiologia"
    },
    {
        "code": "223845",
        "name": "Fonoaudi\u00f3logo em voz"
    },
    {
        "code": "223840",
        "name": "Fonoaudi\u00f3logo em sa\u00fade coletiva"
    },
    {
        "code": "223815",
        "name": "Fonoaudi\u00f3logo educacional"
    },
    {
        "code": "223910",
        "name": "Ortoptista"
    },
    {
        "code": "223905",
        "name": "Terapeuta ocupacional"
    },
    {
        "code": "224110",
        "name": "Ludomotricista"
    },
    {
        "code": "224115",
        "name": "Preparador de atleta"
    },
    {
        "code": "224120",
        "name": "Preparador f\u00edsico"
    },
    {
        "code": "224105",
        "name": "Avaliador f\u00edsico"
    },
    {
        "code": "224130",
        "name": "T\u00e9cnico de laborat\u00f3rio e fiscaliza\u00e7\u00e3o desportiva"
    },
    {
        "code": "224135",
        "name": "Treinador profissional de futebol"
    },
    {
        "code": "224125",
        "name": "T\u00e9cnico de desporto individual e coletivo (exceto futebol)"
    },
    {
        "code": "225118",
        "name": "M\u00e9dico nutrologista"
    },
    {
        "code": "225185",
        "name": "M\u00e9dico hematologista"
    },
    {
        "code": "225180",
        "name": "M\u00e9dico geriatra"
    },
    {
        "code": "225175",
        "name": "M\u00e9dico geneticista"
    },
    {
        "code": "225170",
        "name": "M\u00e9dico generalista"
    },
    {
        "code": "225165",
        "name": "M\u00e9dico gastroenterologista"
    },
    {
        "code": "225160",
        "name": "M\u00e9dico fisiatra"
    },
    {
        "code": "225155",
        "name": "M\u00e9dico endocrinologista e metabologista"
    },
    {
        "code": "225154",
        "name": "M\u00e9dico antropos\u00f3fico"
    },
    {
        "code": "225151",
        "name": "M\u00e9dico anestesiologista"
    },
    {
        "code": "225150",
        "name": "M\u00e9dico em medicina intensiva"
    },
    {
        "code": "225148",
        "name": "M\u00e9dico anatomopatologista"
    },
    {
        "code": "225145",
        "name": "M\u00e9dico em medicina de tr\u00e1fego"
    },
    {
        "code": "225142",
        "name": "M\u00e9dico da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        "code": "225140",
        "name": "M\u00e9dico do trabalho"
    },
    {
        "code": "225139",
        "name": "M\u00e9dico sanitarista"
    },
    {
        "code": "225136",
        "name": "M\u00e9dico reumatologista"
    },
    {
        "code": "225135",
        "name": "M\u00e9dico dermatologista"
    },
    {
        "code": "225103",
        "name": "M\u00e9dico infectologista"
    },
    {
        "code": "225105",
        "name": "M\u00e9dico acupunturista"
    },
    {
        "code": "225106",
        "name": "M\u00e9dico legista"
    },
    {
        "code": "225109",
        "name": "M\u00e9dico nefrologista"
    },
    {
        "code": "225110",
        "name": "M\u00e9dico alergista e imunologista"
    },
    {
        "code": "225112",
        "name": "M\u00e9dico neurologista"
    },
    {
        "code": "225115",
        "name": "M\u00e9dico angiologista"
    },
    {
        "code": "225195",
        "name": "M\u00e9dico homeopata"
    },
    {
        "code": "225120",
        "name": "M\u00e9dico cardiologista"
    },
    {
        "code": "225121",
        "name": "M\u00e9dico oncologista cl\u00ednico"
    },
    {
        "code": "225122",
        "name": "M\u00e9dico cancerologista pedi\u00e1trico"
    },
    {
        "code": "225124",
        "name": "M\u00e9dico pediatra"
    },
    {
        "code": "225125",
        "name": "M\u00e9dico cl\u00ednico"
    },
    {
        "code": "225127",
        "name": "M\u00e9dico pneumologista"
    },
    {
        "code": "225130",
        "name": "M\u00e9dico de fam\u00edlia e comunidade"
    },
    {
        "code": "225133",
        "name": "M\u00e9dico psiquiatra"
    },
    {
        "code": "225220",
        "name": "M\u00e9dico cirurgi\u00e3o do aparelho digestivo"
    },
    {
        "code": "225225",
        "name": "M\u00e9dico cirurgi\u00e3o geral"
    },
    {
        "code": "225210",
        "name": "M\u00e9dico cirurgi\u00e3o cardiovascular"
    },
    {
        "code": "225203",
        "name": "M\u00e9dico em cirurgia vascular"
    },
    {
        "code": "225295",
        "name": "M\u00e9dico cirurgi\u00e3o da m\u00e3o"
    },
    {
        "code": "225290",
        "name": "M\u00e9dico cancerologista cirurg\u00edco"
    },
    {
        "code": "225285",
        "name": "M\u00e9dico urologista"
    },
    {
        "code": "225280",
        "name": "M\u00e9dico coloproctologista"
    },
    {
        "code": "225275",
        "name": "M\u00e9dico otorrinolaringologista"
    },
    {
        "code": "225270",
        "name": "M\u00e9dico ortopedista e traumatologista"
    },
    {
        "code": "225265",
        "name": "M\u00e9dico oftalmologista"
    },
    {
        "code": "225260",
        "name": "M\u00e9dico neurocirurgi\u00e3o"
    },
    {
        "code": "225255",
        "name": "M\u00e9dico mastologista"
    },
    {
        "code": "225250",
        "name": "M\u00e9dico ginecologista e obstetra"
    },
    {
        "code": "225240",
        "name": "M\u00e9dico cirurgi\u00e3o tor\u00e1cico"
    },
    {
        "code": "225235",
        "name": "M\u00e9dico cirurgi\u00e3o pl\u00e1stico"
    },
    {
        "code": "225230",
        "name": "M\u00e9dico cirurgi\u00e3o pedi\u00e1trico"
    },
    {
        "code": "225215",
        "name": "M\u00e9dico cirurgi\u00e3o de cabe\u00e7a e pesco\u00e7o"
    },
    {
        "code": "225305",
        "name": "M\u00e9dico citopatologista"
    },
    {
        "code": "225310",
        "name": "M\u00e9dico em endoscopia"
    },
    {
        "code": "225315",
        "name": "M\u00e9dico em medicina nuclear"
    },
    {
        "code": "225320",
        "name": "M\u00e9dico em radiologia e diagn\u00f3stico por imagem"
    },
    {
        "code": "225325",
        "name": "M\u00e9dico patologista"
    },
    {
        "code": "225330",
        "name": "M\u00e9dico radioterapeuta"
    },
    {
        "code": "225335",
        "name": "M\u00e9dico patologista cl\u00ednico \/ medicina laboratorial"
    },
    {
        "code": "225340",
        "name": "M\u00e9dico hemoterapeuta"
    },
    {
        "code": "225345",
        "name": "M\u00e9dico hiperbarista"
    },
    {
        "code": "225350",
        "name": "M\u00e9dico neurofisiologista cl\u00ednico"
    },
    {
        "code": "226105",
        "name": "Quiropraxista"
    },
    {
        "code": "226110",
        "name": "Osteopata"
    },
    {
        "code": "226315",
        "name": "Equoterapeuta"
    },
    {
        "code": "226305",
        "name": "Musicoterapeuta"
    },
    {
        "code": "226320",
        "name": "Natur\u00f3logo"
    },
    {
        "code": "226310",
        "name": "Arteterapeuta"
    },
    {
        "code": "231110",
        "name": "Professor de n\u00edvel superior na educa\u00e7\u00e3o infantil (zero a tr\u00eas anos)"
    },
    {
        "code": "231105",
        "name": "Professor de n\u00edvel superior na educa\u00e7\u00e3o infantil (quatro a seis anos)"
    },
    {
        "code": "231205",
        "name": "Professor da  educa\u00e7\u00e3o de jovens e adultos do ensino fundamental (primeira a quarta s\u00e9rie)"
    },
    {
        "code": "231210",
        "name": "Professor de n\u00edvel superior do ensino fundamental (primeira a quarta s\u00e9rie)"
    },
    {
        "code": "231320",
        "name": "Professor de geografia do ensino fundamental"
    },
    {
        "code": "231325",
        "name": "Professor de hist\u00f3ria do ensino fundamental"
    },
    {
        "code": "231330",
        "name": "Professor de l\u00edngua estrangeira moderna do ensino fundamental"
    },
    {
        "code": "231315",
        "name": "Professor de educa\u00e7\u00e3o f\u00edsica do ensino fundamental"
    },
    {
        "code": "231310",
        "name": "Professor de educa\u00e7\u00e3o art\u00edstica do ensino fundamental"
    },
    {
        "code": "231335",
        "name": "Professor de l\u00edngua portuguesa do ensino fundamental"
    },
    {
        "code": "231340",
        "name": "Professor de matem\u00e1tica do ensino fundamental"
    },
    {
        "code": "231305",
        "name": "Professor de ci\u00eancias exatas e naturais do ensino fundamental"
    },
    {
        "code": "232105",
        "name": "Professor de artes no ensino m\u00e9dio"
    },
    {
        "code": "232120",
        "name": "Professor de educa\u00e7\u00e3o f\u00edsica no ensino m\u00e9dio"
    },
    {
        "code": "232125",
        "name": "Professor de filosofia no ensino m\u00e9dio"
    },
    {
        "code": "232130",
        "name": "Professor de f\u00edsica no ensino m\u00e9dio"
    },
    {
        "code": "232135",
        "name": "Professor de geografia no ensino m\u00e9dio"
    },
    {
        "code": "232145",
        "name": "Professor de l\u00edngua e literatura brasileira no ensino m\u00e9dio"
    },
    {
        "code": "232165",
        "name": "Professor de qu\u00edmica no ensino m\u00e9dio"
    },
    {
        "code": "232170",
        "name": "Professor de sociologia no ensino m\u00e9dio"
    },
    {
        "code": "232110",
        "name": "Professor de biologia no ensino m\u00e9dio"
    },
    {
        "code": "232115",
        "name": "Professor de disciplinas pedag\u00f3gicas no ensino m\u00e9dio"
    },
    {
        "code": "232140",
        "name": "Professor de hist\u00f3ria no ensino m\u00e9dio"
    },
    {
        "code": "232150",
        "name": "Professor de l\u00edngua estrangeira moderna no ensino m\u00e9dio"
    },
    {
        "code": "232160",
        "name": "Professor de psicologia no ensino m\u00e9dio"
    },
    {
        "code": "232155",
        "name": "Professor de matem\u00e1tica no ensino m\u00e9dio"
    },
    {
        "code": "233105",
        "name": "Professor da \u00e1rea de meio ambiente"
    },
    {
        "code": "233110",
        "name": "Professor de desenho t\u00e9cnico"
    },
    {
        "code": "233115",
        "name": "Professor de t\u00e9cnicas agr\u00edcolas"
    },
    {
        "code": "233120",
        "name": "Professor de t\u00e9cnicas comerciais e secretariais"
    },
    {
        "code": "233125",
        "name": "Professor de t\u00e9cnicas de enfermagem"
    },
    {
        "code": "233130",
        "name": "Professor de t\u00e9cnicas industriais"
    },
    {
        "code": "233135",
        "name": "Professor de tecnologia e c\u00e1lculo t\u00e9cnico"
    },
    {
        "code": "233205",
        "name": "Instrutor de aprendizagem e treinamento agropecu\u00e1rio"
    },
    {
        "code": "233210",
        "name": "Instrutor de aprendizagem e treinamento industrial"
    },
    {
        "code": "233215",
        "name": "Instrutor de aprendizagem e treinamento comercial"
    },
    {
        "code": "233220",
        "name": "Professor instrutor de ensino e aprendizagem agroflorestal"
    },
    {
        "code": "233225",
        "name": "Professor instrutor de ensino e aprendizagem em servi\u00e7os"
    },
    {
        "code": "234105",
        "name": "Professor de matem\u00e1tica aplicada (no ensino superior)"
    },
    {
        "code": "234110",
        "name": "Professor de matem\u00e1tica pura (no ensino superior)"
    },
    {
        "code": "234115",
        "name": "Professor de estat\u00edstica (no ensino superior)"
    },
    {
        "code": "234120",
        "name": "Professor de computa\u00e7\u00e3o (no ensino superior)"
    },
    {
        "code": "234125",
        "name": "Professor de pesquisa operacional (no ensino superior)"
    },
    {
        "code": "234205",
        "name": "Professor de f\u00edsica (ensino superior)"
    },
    {
        "code": "234215",
        "name": "Professor de astronomia (ensino superior)"
    },
    {
        "code": "234210",
        "name": "Professor de qu\u00edmica (ensino superior)"
    },
    {
        "code": "234305",
        "name": "Professor de arquitetura"
    },
    {
        "code": "234315",
        "name": "Professor de geof\u00edsica"
    },
    {
        "code": "234310",
        "name": "Professor de engenharia"
    },
    {
        "code": "234320",
        "name": "Professor de geologia"
    },
    {
        "code": "234405",
        "name": "Professor de ci\u00eancias biol\u00f3gicas do ensino superior"
    },
    {
        "code": "234415",
        "name": "Professor de enfermagem do ensino superior"
    },
    {
        "code": "234450",
        "name": "Professor de odontologia"
    },
    {
        "code": "234445",
        "name": "Professor de nutri\u00e7\u00e3o"
    },
    {
        "code": "234440",
        "name": "Professor de medicina veterin\u00e1ria"
    },
    {
        "code": "234410",
        "name": "Professor de educa\u00e7\u00e3o f\u00edsica no ensino superior"
    },
    {
        "code": "234455",
        "name": "Professor de terapia ocupacional"
    },
    {
        "code": "234460",
        "name": "Professor de zootecnia do ensino superior"
    },
    {
        "code": "234420",
        "name": "Professor de farm\u00e1cia e bioqu\u00edmica"
    },
    {
        "code": "234425",
        "name": "Professor de fisioterapia"
    },
    {
        "code": "234430",
        "name": "Professor de fonoaudiologia"
    },
    {
        "code": "234435",
        "name": "Professor de medicina"
    },
    {
        "code": "234510",
        "name": "Professor de ensino superior na \u00e1rea de orienta\u00e7\u00e3o educacional"
    },
    {
        "code": "234505",
        "name": "Professor de ensino superior na \u00e1rea de did\u00e1tica"
    },
    {
        "code": "234515",
        "name": "Professor de ensino superior na \u00e1rea de pesquisa educacional"
    },
    {
        "code": "234520",
        "name": "Professor de ensino superior na \u00e1rea de pr\u00e1tica de ensino"
    },
    {
        "code": "234628",
        "name": "Professor de literatura brasileira"
    },
    {
        "code": "234632",
        "name": "Professor de literatura portuguesa"
    },
    {
        "code": "234640",
        "name": "Professor de literatura comparada"
    },
    {
        "code": "234660",
        "name": "Professor de literatura de l\u00ednguas estrangeiras modernas"
    },
    {
        "code": "234668",
        "name": "Professor de l\u00ednguas estrangeiras modernas"
    },
    {
        "code": "234672",
        "name": "Professor de ling\u00fc\u00edstica e ling\u00fc\u00edstica aplicada"
    },
    {
        "code": "234676",
        "name": "Professor de filologia e cr\u00edtica textual"
    },
    {
        "code": "234680",
        "name": "Professor de semi\u00f3tica"
    },
    {
        "code": "234684",
        "name": "Professor de teoria da literatura"
    },
    {
        "code": "234604",
        "name": "Professor de l\u00edngua alem\u00e3"
    },
    {
        "code": "234608",
        "name": "Professor de l\u00edngua italiana"
    },
    {
        "code": "234612",
        "name": "Professor de l\u00edngua francesa"
    },
    {
        "code": "234616",
        "name": "Professor de l\u00edngua inglesa"
    },
    {
        "code": "234620",
        "name": "Professor de l\u00edngua espanhola"
    },
    {
        "code": "234636",
        "name": "Professor de literatura alem\u00e3"
    },
    {
        "code": "234644",
        "name": "Professor de literatura espanhola"
    },
    {
        "code": "234648",
        "name": "Professor de literatura francesa"
    },
    {
        "code": "234652",
        "name": "Professor de literatura inglesa"
    },
    {
        "code": "234656",
        "name": "Professor de literatura italiana"
    },
    {
        "code": "234664",
        "name": "Professor de outras l\u00ednguas e literaturas"
    },
    {
        "code": "234624",
        "name": "Professor de l\u00edngua portuguesa"
    },
    {
        "code": "234705",
        "name": "Professor de antropologia do ensino superior"
    },
    {
        "code": "234710",
        "name": "Professor de arquivologia do ensino superior"
    },
    {
        "code": "234770",
        "name": "Professor de sociologia do ensino superior"
    },
    {
        "code": "234765",
        "name": "Professor de servi\u00e7o social do ensino superior"
    },
    {
        "code": "234760",
        "name": "Professor de psicologia do ensino superior"
    },
    {
        "code": "234755",
        "name": "Professor de museologia do ensino superior"
    },
    {
        "code": "234715",
        "name": "Professor de biblioteconomia do ensino superior"
    },
    {
        "code": "234745",
        "name": "Professor de hist\u00f3ria do ensino superior"
    },
    {
        "code": "234740",
        "name": "Professor de geografia do ensino superior"
    },
    {
        "code": "234735",
        "name": "Professor de filosofia do ensino superior"
    },
    {
        "code": "234730",
        "name": "Professor de direito do ensino superior"
    },
    {
        "code": "234725",
        "name": "Professor de comunica\u00e7\u00e3o social do ensino superior"
    },
    {
        "code": "234720",
        "name": "Professor de ci\u00eancia pol\u00edtica do ensino superior"
    },
    {
        "code": "234750",
        "name": "Professor de jornalismo"
    },
    {
        "code": "234815",
        "name": "Professor de contabilidade"
    },
    {
        "code": "234805",
        "name": "Professor de economia"
    },
    {
        "code": "234810",
        "name": "Professor de administra\u00e7\u00e3o"
    },
    {
        "code": "234915",
        "name": "Professor de m\u00fasica no ensino superior"
    },
    {
        "code": "234910",
        "name": "Professor de artes visuais no ensino superior (artes pl\u00e1sticas e multim\u00eddia)"
    },
    {
        "code": "234905",
        "name": "Professor de artes do espet\u00e1culo no ensino superior"
    },
    {
        "code": "239205",
        "name": "Professor de alunos com defici\u00eancia auditiva e surdos"
    },
    {
        "code": "239210",
        "name": "Professor de alunos com defici\u00eancia f\u00edsica"
    },
    {
        "code": "239220",
        "name": "Professor de alunos com defici\u00eancia m\u00faltipla"
    },
    {
        "code": "239225",
        "name": "Professor de alunos com defici\u00eancia visual"
    },
    {
        "code": "239215",
        "name": "Professor de alunos com defici\u00eancia mental"
    },
    {
        "code": "239415",
        "name": "Pedagogo"
    },
    {
        "code": "239410",
        "name": "Orientador educacional"
    },
    {
        "code": "239405",
        "name": "Coordenador pedag\u00f3gico"
    },
    {
        "code": "239425",
        "name": "Psicopedagogo"
    },
    {
        "code": "239430",
        "name": "Supervisor de ensino"
    },
    {
        "code": "239435",
        "name": "Designer educacional"
    },
    {
        "code": "239420",
        "name": "Professor de t\u00e9cnicas e recursos audiovisuais"
    },
    {
        "code": "241040",
        "name": "Consultor jur\u00eddico"
    },
    {
        "code": "241035",
        "name": "Advogado (direito do trabalho)"
    },
    {
        "code": "241030",
        "name": "Advogado (\u00e1reas especiais)"
    },
    {
        "code": "241025",
        "name": "Advogado (direito penal)"
    },
    {
        "code": "241020",
        "name": "Advogado (direito p\u00fablico)"
    },
    {
        "code": "241015",
        "name": "Advogado (direito civil)"
    },
    {
        "code": "241010",
        "name": "Advogado de empresa"
    },
    {
        "code": "241005",
        "name": "Advogado"
    },
    {
        "code": "241225",
        "name": "Procurador do munic\u00edpio"
    },
    {
        "code": "241205",
        "name": "Advogado da uni\u00e3o"
    },
    {
        "code": "241235",
        "name": "Procurador fundacional"
    },
    {
        "code": "241230",
        "name": "Procurador federal"
    },
    {
        "code": "241210",
        "name": "Procurador aut\u00e1rquico"
    },
    {
        "code": "241220",
        "name": "Procurador do estado"
    },
    {
        "code": "241215",
        "name": "Procurador da fazenda nacional"
    },
    {
        "code": "241315",
        "name": "Oficial do registro civil de pessoas naturais"
    },
    {
        "code": "241340",
        "name": "Tabeli\u00e3o de protestos"
    },
    {
        "code": "241320",
        "name": "Oficial do registro de distribui\u00e7\u00f5es"
    },
    {
        "code": "241325",
        "name": "Oficial do registro de im\u00f3veis"
    },
    {
        "code": "241330",
        "name": "Oficial do registro de t\u00edtulos e documentos"
    },
    {
        "code": "241305",
        "name": "Oficial de registro de contratos mar\u00edtimos"
    },
    {
        "code": "241310",
        "name": "Oficial do registro civil de pessoas jur\u00eddicas"
    },
    {
        "code": "241335",
        "name": "Tabeli\u00e3o de notas"
    },
    {
        "code": "242220",
        "name": "Procurador do trabalho"
    },
    {
        "code": "242250",
        "name": "Subprocurador-geral do trabalho"
    },
    {
        "code": "242235",
        "name": "Promotor de justi\u00e7a"
    },
    {
        "code": "242210",
        "name": "Procurador de justi\u00e7a"
    },
    {
        "code": "242245",
        "name": "Subprocurador-geral da rep\u00fablica"
    },
    {
        "code": "242240",
        "name": "Subprocurador de justi\u00e7a militar"
    },
    {
        "code": "242205",
        "name": "Procurador da rep\u00fablica"
    },
    {
        "code": "242230",
        "name": "Procurador regional do trabalho"
    },
    {
        "code": "242225",
        "name": "Procurador regional da rep\u00fablica"
    },
    {
        "code": "242215",
        "name": "Procurador de justi\u00e7a militar"
    },
    {
        "code": "242305",
        "name": "Delegado de pol\u00edcia"
    },
    {
        "code": "242410",
        "name": "Procurador da assist\u00eancia judici\u00e1ria"
    },
    {
        "code": "242405",
        "name": "Defensor p\u00fablico"
    },
    {
        "code": "242910",
        "name": "Oficial t\u00e9cnico de intelig\u00eancia"
    },
    {
        "code": "242905",
        "name": "Oficial de intelig\u00eancia"
    },
    {
        "code": "251120",
        "name": "Soci\u00f3logo"
    },
    {
        "code": "251115",
        "name": "Cientista pol\u00edtico"
    },
    {
        "code": "251105",
        "name": "Antrop\u00f3logo"
    },
    {
        "code": "251110",
        "name": "Arque\u00f3logo"
    },
    {
        "code": "251210",
        "name": "Economista agroindustrial"
    },
    {
        "code": "251205",
        "name": "Economista"
    },
    {
        "code": "251215",
        "name": "Economista financeiro"
    },
    {
        "code": "251225",
        "name": "Economista do setor p\u00fablico"
    },
    {
        "code": "251230",
        "name": "Economista ambiental"
    },
    {
        "code": "251235",
        "name": "Economista regional e urbano"
    },
    {
        "code": "251220",
        "name": "Economista industrial"
    },
    {
        "code": "251305",
        "name": "Ge\u00f3grafo"
    },
    {
        "code": "251405",
        "name": "Fil\u00f3sofo"
    },
    {
        "code": "251505",
        "name": "Psic\u00f3logo educacional"
    },
    {
        "code": "251515",
        "name": "Psic\u00f3logo do esporte"
    },
    {
        "code": "251510",
        "name": "Psic\u00f3logo cl\u00ednico"
    },
    {
        "code": "251520",
        "name": "Psic\u00f3logo hospitalar"
    },
    {
        "code": "251525",
        "name": "Psic\u00f3logo jur\u00eddico"
    },
    {
        "code": "251530",
        "name": "Psic\u00f3logo social"
    },
    {
        "code": "251535",
        "name": "Psic\u00f3logo do tr\u00e2nsito"
    },
    {
        "code": "251540",
        "name": "Psic\u00f3logo do trabalho"
    },
    {
        "code": "251555",
        "name": "Psic\u00f3logo acupunturista"
    },
    {
        "code": "251550",
        "name": "Psicanalista"
    },
    {
        "code": "251545",
        "name": "Neuropsic\u00f3logo"
    },
    {
        "code": "251610",
        "name": "Economista dom\u00e9stico"
    },
    {
        "code": "251605",
        "name": "Assistente social"
    },
    {
        "code": "252105",
        "name": "Administrador"
    },
    {
        "code": "252205",
        "name": "Auditor (contadores e afins)"
    },
    {
        "code": "252210",
        "name": "Contador"
    },
    {
        "code": "252215",
        "name": "Perito cont\u00e1bil"
    },
    {
        "code": "252320",
        "name": "Tecn\u00f3logo em secretariado escolar"
    },
    {
        "code": "252310",
        "name": "Secret\u00e1rio  bil\u00edng\u00fce"
    },
    {
        "code": "252305",
        "name": "Secret\u00e1ria(o) executiva(o)"
    },
    {
        "code": "252315",
        "name": "Secret\u00e1ria tril\u00edng\u00fce"
    },
    {
        "code": "252405",
        "name": "Analista de recursos humanos"
    },
    {
        "code": "252530",
        "name": "Analista de cr\u00e9dito rural"
    },
    {
        "code": "252525",
        "name": "Analista de cr\u00e9dito (institui\u00e7\u00f5es financeiras)"
    },
    {
        "code": "252535",
        "name": "Analista de leasing"
    },
    {
        "code": "252515",
        "name": "Analista de cobran\u00e7a (institui\u00e7\u00f5es financeiras)"
    },
    {
        "code": "252545",
        "name": "Analista financeiro (institui\u00e7\u00f5es financeiras)"
    },
    {
        "code": "252550",
        "name": "Profissional de rela\u00e7\u00f5es com investidores"
    },
    {
        "code": "252540",
        "name": "Analista de produtos banc\u00e1rios"
    },
    {
        "code": "252505",
        "name": "Administrador de fundos e carteiras de investimento"
    },
    {
        "code": "252510",
        "name": "Analista de c\u00e2mbio"
    },
    {
        "code": "252605",
        "name": "Gestor em seguran\u00e7a"
    },
    {
        "code": "252705",
        "name": "Analista de pcp (programa\u00e7\u00e3o e controle da produ\u00e7\u00e3o)"
    },
    {
        "code": "252710",
        "name": "Analista de planejamento de materias"
    },
    {
        "code": "252720",
        "name": "Analista de projetos logisticos"
    },
    {
        "code": "252725",
        "name": "Analista de gest\u00e3o de estoque"
    },
    {
        "code": "252715",
        "name": "Analista de logistica"
    },
    {
        "code": "253115",
        "name": "Publicit\u00e1rio"
    },
    {
        "code": "253120",
        "name": "Diretor de m\u00eddia (publicidade)"
    },
    {
        "code": "253125",
        "name": "Diretor de arte (publicidade)"
    },
    {
        "code": "253130",
        "name": "Diretor de cria\u00e7\u00e3o"
    },
    {
        "code": "253135",
        "name": "Diretor de contas (publicidade)"
    },
    {
        "code": "253140",
        "name": "Agenciador de propaganda"
    },
    {
        "code": "253110",
        "name": "Redator de publicidade"
    },
    {
        "code": "253215",
        "name": "Gerente de contas - pessoa f\u00edsica e jur\u00eddica"
    },
    {
        "code": "253220",
        "name": "Gerente de grandes contas (corporate)"
    },
    {
        "code": "253225",
        "name": "Operador de neg\u00f3cios"
    },
    {
        "code": "253205",
        "name": "Gerente de capta\u00e7\u00e3o (fundos e investimentos institucionais)"
    },
    {
        "code": "253210",
        "name": "Gerente de clientes especiais (private)"
    },
    {
        "code": "253305",
        "name": "Corretor de valores, ativos financeiros, mercadorias e derivativos"
    },
    {
        "code": "254105",
        "name": "Auditor-fiscal da receita federal"
    },
    {
        "code": "254110",
        "name": "T\u00e9cnico da receita federal"
    },
    {
        "code": "254205",
        "name": "Auditor-fiscal da previd\u00eancia social"
    },
    {
        "code": "254305",
        "name": "Auditor-fiscal do trabalho"
    },
    {
        "code": "254310",
        "name": "Agente de higiene e seguran\u00e7a"
    },
    {
        "code": "254405",
        "name": "Fiscal de tributos estadual"
    },
    {
        "code": "254410",
        "name": "Fiscal de tributos municipal"
    },
    {
        "code": "254415",
        "name": "T\u00e9cnico de tributos estadual"
    },
    {
        "code": "254420",
        "name": "T\u00e9cnico de tributos municipal"
    },
    {
        "code": "254505",
        "name": "Fiscal de atividades urbanas"
    },
    {
        "code": "261125",
        "name": "Jornalista"
    },
    {
        "code": "261110",
        "name": "Assessor de imprensa"
    },
    {
        "code": "261115",
        "name": "Diretor de reda\u00e7\u00e3o"
    },
    {
        "code": "261120",
        "name": "Editor"
    },
    {
        "code": "261105",
        "name": "Arquivista pesquisador (jornalismo)"
    },
    {
        "code": "261130",
        "name": "Produtor de texto"
    },
    {
        "code": "261135",
        "name": "Rep\u00f3rter (exclusive r\u00e1dio e televis\u00e3o)"
    },
    {
        "code": "261140",
        "name": "Revisor de texto"
    },
    {
        "code": "261215",
        "name": "Analista de informa\u00e7\u00f5es (pesquisador de informa\u00e7\u00f5es de rede)"
    },
    {
        "code": "261210",
        "name": "Documentalista"
    },
    {
        "code": "261205",
        "name": "Bibliotec\u00e1rio"
    },
    {
        "code": "261305",
        "name": "Arquivista"
    },
    {
        "code": "261310",
        "name": "Muse\u00f3logo"
    },
    {
        "code": "261405",
        "name": "Fil\u00f3logo"
    },
    {
        "code": "261430",
        "name": "Audiodescritor"
    },
    {
        "code": "261425",
        "name": "Int\u00e9rprete de l\u00edngua de sinais"
    },
    {
        "code": "261420",
        "name": "Tradutor"
    },
    {
        "code": "261415",
        "name": "Ling\u00fcista"
    },
    {
        "code": "261410",
        "name": "Int\u00e9rprete"
    },
    {
        "code": "261520",
        "name": "Escritor de n\u00e3o fic\u00e7\u00e3o"
    },
    {
        "code": "261515",
        "name": "Escritor de fic\u00e7\u00e3o"
    },
    {
        "code": "261530",
        "name": "Redator de textos t\u00e9cnicos"
    },
    {
        "code": "261525",
        "name": "Poeta"
    },
    {
        "code": "261510",
        "name": "Cr\u00edtico"
    },
    {
        "code": "261505",
        "name": "Autor-roteirista"
    },
    {
        "code": "261610",
        "name": "Editor de livro"
    },
    {
        "code": "261615",
        "name": "Editor de m\u00eddia eletr\u00f4nica"
    },
    {
        "code": "261625",
        "name": "Editor de revista cient\u00edfica"
    },
    {
        "code": "261620",
        "name": "Editor de revista"
    },
    {
        "code": "261605",
        "name": "Editor de jornal"
    },
    {
        "code": "261715",
        "name": "Locutor de r\u00e1dio e televis\u00e3o"
    },
    {
        "code": "261710",
        "name": "Comentarista de r\u00e1dio e televis\u00e3o"
    },
    {
        "code": "261730",
        "name": "Rep\u00f3rter de r\u00e1dio e televis\u00e3o"
    },
    {
        "code": "261725",
        "name": "Narrador em programas de r\u00e1dio e televis\u00e3o"
    },
    {
        "code": "261720",
        "name": "Locutor publicit\u00e1rio de r\u00e1dio e televis\u00e3o"
    },
    {
        "code": "261705",
        "name": "\u00c2ncora de r\u00e1dio e televis\u00e3o"
    },
    {
        "code": "261820",
        "name": "Rep\u00f3rter fotogr\u00e1fico"
    },
    {
        "code": "261815",
        "name": "Fot\u00f3grafo retratista"
    },
    {
        "code": "261805",
        "name": "Fot\u00f3grafo"
    },
    {
        "code": "261810",
        "name": "Fot\u00f3grafo publicit\u00e1rio"
    },
    {
        "code": "262130",
        "name": "Tecn\u00f3logo em produ\u00e7\u00e3o fonogr\u00e1fica"
    },
    {
        "code": "262125",
        "name": "Produtor de televis\u00e3o"
    },
    {
        "code": "262120",
        "name": "Produtor de teatro"
    },
    {
        "code": "262115",
        "name": "Produtor de r\u00e1dio"
    },
    {
        "code": "262110",
        "name": "Produtor cinematogr\u00e1fico"
    },
    {
        "code": "262135",
        "name": "Tecn\u00f3logo em produ\u00e7\u00e3o audiovisual"
    },
    {
        "code": "262105",
        "name": "Produtor cultural"
    },
    {
        "code": "262205",
        "name": "Diretor de cinema"
    },
    {
        "code": "262210",
        "name": "Diretor de programas de r\u00e1dio"
    },
    {
        "code": "262215",
        "name": "Diretor de programas de televis\u00e3o"
    },
    {
        "code": "262220",
        "name": "Diretor teatral"
    },
    {
        "code": "262305",
        "name": "Cen\u00f3grafo carnavalesco e festas populares"
    },
    {
        "code": "262310",
        "name": "Cen\u00f3grafo de cinema"
    },
    {
        "code": "262315",
        "name": "Cen\u00f3grafo de eventos"
    },
    {
        "code": "262320",
        "name": "Cen\u00f3grafo de teatro"
    },
    {
        "code": "262325",
        "name": "Cen\u00f3grafo de tv"
    },
    {
        "code": "262330",
        "name": "Diretor de arte"
    },
    {
        "code": "262420",
        "name": "Desenhista industrial de produto (designer de produto)"
    },
    {
        "code": "262425",
        "name": "Desenhista industrial de produto de moda (designer de moda)"
    },
    {
        "code": "262405",
        "name": "Artista (artes visuais)"
    },
    {
        "code": "262415",
        "name": "Conservador-restaurador de bens  culturais"
    },
    {
        "code": "262410",
        "name": "Desenhista industrial gr\u00e1fico (designer gr\u00e1fico)"
    },
    {
        "code": "262505",
        "name": "Ator"
    },
    {
        "code": "262620",
        "name": "Music\u00f3logo"
    },
    {
        "code": "262615",
        "name": "M\u00fasico regente"
    },
    {
        "code": "262610",
        "name": "M\u00fasico arranjador"
    },
    {
        "code": "262605",
        "name": "Compositor"
    },
    {
        "code": "262705",
        "name": "M\u00fasico int\u00e9rprete cantor"
    },
    {
        "code": "262710",
        "name": "M\u00fasico int\u00e9rprete instrumentista"
    },
    {
        "code": "262805",
        "name": "Assistente de coreografia"
    },
    {
        "code": "262810",
        "name": "Bailarino (exceto dan\u00e7as populares)"
    },
    {
        "code": "262815",
        "name": "Core\u00f3grafo"
    },
    {
        "code": "262820",
        "name": "Dramaturgo de dan\u00e7a"
    },
    {
        "code": "262825",
        "name": "Ensaiador de dan\u00e7a"
    },
    {
        "code": "262830",
        "name": "Professor de dan\u00e7a"
    },
    {
        "code": "262905",
        "name": "Decorador de interiores de n\u00edvel superior"
    },
    {
        "code": "263115",
        "name": "Te\u00f3logo"
    },
    {
        "code": "263110",
        "name": "Mission\u00e1rio"
    },
    {
        "code": "263105",
        "name": "Ministro de culto religioso"
    },
    {
        "code": "271110",
        "name": "Tecn\u00f3logo em gastronomia"
    },
    {
        "code": "271105",
        "name": "Chefe de cozinha"
    },
    {
        "code": "300105",
        "name": "T\u00e9cnico em mecatr\u00f4nica - automa\u00e7\u00e3o da manufatura"
    },
    {
        "code": "300110",
        "name": "T\u00e9cnico em mecatr\u00f4nica - rob\u00f3tica"
    },
    {
        "code": "300305",
        "name": "T\u00e9cnico em eletromec\u00e2nica"
    },
    {
        "code": "301105",
        "name": "T\u00e9cnico de laborat\u00f3rio industrial"
    },
    {
        "code": "301110",
        "name": "T\u00e9cnico de laborat\u00f3rio de an\u00e1lises f\u00edsico-qu\u00edmicas (materiais de constru\u00e7\u00e3o)"
    },
    {
        "code": "301115",
        "name": "T\u00e9cnico qu\u00edmico de petr\u00f3leo"
    },
    {
        "code": "301205",
        "name": "T\u00e9cnico de apoio \u00e0 bioengenharia"
    },
    {
        "code": "311115",
        "name": "T\u00e9cnico em curtimento"
    },
    {
        "code": "311110",
        "name": "T\u00e9cnico de celulose e papel"
    },
    {
        "code": "311105",
        "name": "T\u00e9cnico qu\u00edmico"
    },
    {
        "code": "311205",
        "name": "T\u00e9cnico em petroqu\u00edmica"
    },
    {
        "code": "311305",
        "name": "T\u00e9cnico em materiais, produtos cer\u00e2micos e vidros"
    },
    {
        "code": "311405",
        "name": "T\u00e9cnico em borracha"
    },
    {
        "code": "311410",
        "name": "T\u00e9cnico em pl\u00e1stico"
    },
    {
        "code": "311515",
        "name": "T\u00e9cnico de utilidade (produ\u00e7\u00e3o e distribui\u00e7\u00e3o de vapor, gases, \u00f3leos, combust\u00edveis, energia)"
    },
    {
        "code": "311510",
        "name": "T\u00e9cnico de meteorologia"
    },
    {
        "code": "311505",
        "name": "T\u00e9cnico de controle de meio ambiente"
    },
    {
        "code": "311520",
        "name": "T\u00e9cnico em tratamento de efluentes"
    },
    {
        "code": "311605",
        "name": "T\u00e9cnico t\u00eaxtil"
    },
    {
        "code": "311610",
        "name": "T\u00e9cnico t\u00eaxtil (tratamentos qu\u00edmicos)"
    },
    {
        "code": "311615",
        "name": "T\u00e9cnico t\u00eaxtil de fia\u00e7\u00e3o"
    },
    {
        "code": "311620",
        "name": "T\u00e9cnico t\u00eaxtil de malharia"
    },
    {
        "code": "311625",
        "name": "T\u00e9cnico t\u00eaxtil de tecelagem"
    },
    {
        "code": "311705",
        "name": "Colorista de papel"
    },
    {
        "code": "311710",
        "name": "Colorista t\u00eaxtil"
    },
    {
        "code": "311715",
        "name": "Preparador de tintas"
    },
    {
        "code": "311720",
        "name": "Preparador de tintas (f\u00e1brica de tecidos)"
    },
    {
        "code": "311725",
        "name": "Tingidor de couros e peles"
    },
    {
        "code": "312105",
        "name": "T\u00e9cnico de obras civis"
    },
    {
        "code": "312210",
        "name": "T\u00e9cnico de saneamento"
    },
    {
        "code": "312205",
        "name": "T\u00e9cnico de estradas"
    },
    {
        "code": "312315",
        "name": "T\u00e9cnico em hidrografia"
    },
    {
        "code": "312310",
        "name": "T\u00e9cnico em geod\u00e9sia e cartografia"
    },
    {
        "code": "312320",
        "name": "Top\u00f3grafo"
    },
    {
        "code": "312305",
        "name": "T\u00e9cnico em agrimensura"
    },
    {
        "code": "313130",
        "name": "T\u00e9cnico eletricista"
    },
    {
        "code": "313125",
        "name": "T\u00e9cnico de manuten\u00e7\u00e3o el\u00e9trica de m\u00e1quina"
    },
    {
        "code": "313120",
        "name": "T\u00e9cnico de manuten\u00e7\u00e3o el\u00e9trica"
    },
    {
        "code": "313115",
        "name": "Eletrot\u00e9cnico na fabrica\u00e7\u00e3o, montagem e instala\u00e7\u00e3o de m\u00e1quinas e equipamentos"
    },
    {
        "code": "313110",
        "name": "Eletrot\u00e9cnico (produ\u00e7\u00e3o de energia)"
    },
    {
        "code": "313105",
        "name": "Eletrot\u00e9cnico"
    },
    {
        "code": "313215",
        "name": "T\u00e9cnico eletr\u00f4nico"
    },
    {
        "code": "313220",
        "name": "T\u00e9cnico em manuten\u00e7\u00e3o de equipamentos de inform\u00e1tica"
    },
    {
        "code": "313210",
        "name": "T\u00e9cnico de manuten\u00e7\u00e3o eletr\u00f4nica (circuitos de m\u00e1quinas com comando num\u00e9rico)"
    },
    {
        "code": "313205",
        "name": "T\u00e9cnico de manuten\u00e7\u00e3o eletr\u00f4nica"
    },
    {
        "code": "313320",
        "name": "T\u00e9cnico de transmiss\u00e3o (telecomunica\u00e7\u00f5es)"
    },
    {
        "code": "313315",
        "name": "T\u00e9cnico de telecomunica\u00e7\u00f5es (telefonia)"
    },
    {
        "code": "313310",
        "name": "T\u00e9cnico de rede (telecomunica\u00e7\u00f5es)"
    },
    {
        "code": "313305",
        "name": "T\u00e9cnico de comunica\u00e7\u00e3o de dados"
    },
    {
        "code": "313405",
        "name": "T\u00e9cnico em calibra\u00e7\u00e3o"
    },
    {
        "code": "313410",
        "name": "T\u00e9cnico em instrumenta\u00e7\u00e3o"
    },
    {
        "code": "313415",
        "name": "Encarregado de manuten\u00e7\u00e3o de instrumentos de controle, medi\u00e7\u00e3o e similares"
    },
    {
        "code": "313505",
        "name": "T\u00e9cnico em fot\u00f4nica"
    },
    {
        "code": "314105",
        "name": "T\u00e9cnico em mec\u00e2nica de precis\u00e3o"
    },
    {
        "code": "314110",
        "name": "T\u00e9cnico mec\u00e2nico"
    },
    {
        "code": "314115",
        "name": "T\u00e9cnico mec\u00e2nico (calefa\u00e7\u00e3o, ventila\u00e7\u00e3o e refrigera\u00e7\u00e3o)"
    },
    {
        "code": "314120",
        "name": "T\u00e9cnico mec\u00e2nico (m\u00e1quinas)"
    },
    {
        "code": "314125",
        "name": "T\u00e9cnico mec\u00e2nico (motores)"
    },
    {
        "code": "314205",
        "name": "T\u00e9cnico mec\u00e2nico na fabrica\u00e7\u00e3o de ferramentas"
    },
    {
        "code": "314210",
        "name": "T\u00e9cnico mec\u00e2nico na manuten\u00e7\u00e3o de ferramentas"
    },
    {
        "code": "314305",
        "name": "T\u00e9cnico em automobil\u00edstica"
    },
    {
        "code": "314310",
        "name": "T\u00e9cnico mec\u00e2nico (aeronaves)"
    },
    {
        "code": "314315",
        "name": "T\u00e9cnico mec\u00e2nico (embarca\u00e7\u00f5es)"
    },
    {
        "code": "314405",
        "name": "T\u00e9cnico de manuten\u00e7\u00e3o de sistemas e instrumentos"
    },
    {
        "code": "314410",
        "name": "T\u00e9cnico em manuten\u00e7\u00e3o de m\u00e1quinas"
    },
    {
        "code": "314620",
        "name": "T\u00e9cnico em soldagem"
    },
    {
        "code": "314615",
        "name": "T\u00e9cnico em estruturas met\u00e1licas"
    },
    {
        "code": "314610",
        "name": "T\u00e9cnico em caldeiraria"
    },
    {
        "code": "314605",
        "name": "Inspetor de soldagem"
    },
    {
        "code": "314625",
        "name": "Tecn\u00f3logo em soldagem"
    },
    {
        "code": "314725",
        "name": "T\u00e9cnico de redu\u00e7\u00e3o na siderurgia (primeira fus\u00e3o)"
    },
    {
        "code": "314720",
        "name": "T\u00e9cnico de lamina\u00e7\u00e3o em siderurgia"
    },
    {
        "code": "314715",
        "name": "T\u00e9cnico de fundi\u00e7\u00e3o em siderurgia"
    },
    {
        "code": "314710",
        "name": "T\u00e9cnico de aciaria em siderurgia"
    },
    {
        "code": "314705",
        "name": "T\u00e9cnico de acabamento em siderurgia"
    },
    {
        "code": "314730",
        "name": "T\u00e9cnico de refrat\u00e1rio em siderurgia"
    },
    {
        "code": "316115",
        "name": "T\u00e9cnico em geoqu\u00edmica"
    },
    {
        "code": "316110",
        "name": "T\u00e9cnico em geologia"
    },
    {
        "code": "316105",
        "name": "T\u00e9cnico em geof\u00edsica"
    },
    {
        "code": "316120",
        "name": "T\u00e9cnico em geotecnia"
    },
    {
        "code": "316325",
        "name": "T\u00e9cnico de produ\u00e7\u00e3o em refino de petr\u00f3leo"
    },
    {
        "code": "316330",
        "name": "T\u00e9cnico em planejamento de lavra de minas"
    },
    {
        "code": "316335",
        "name": "Desincrustador (po\u00e7os de petr\u00f3leo)"
    },
    {
        "code": "316320",
        "name": "T\u00e9cnico em pesquisa mineral"
    },
    {
        "code": "316315",
        "name": "T\u00e9cnico em processamento mineral (exceto petr\u00f3leo)"
    },
    {
        "code": "316340",
        "name": "Cimentador (po\u00e7os de petr\u00f3leo)"
    },
    {
        "code": "316305",
        "name": "T\u00e9cnico de minera\u00e7\u00e3o"
    },
    {
        "code": "316310",
        "name": "T\u00e9cnico de minera\u00e7\u00e3o (\u00f3leo e petr\u00f3leo)"
    },
    {
        "code": "317105",
        "name": "Programador de internet"
    },
    {
        "code": "317110",
        "name": "Programador de sistemas de informa\u00e7\u00e3o"
    },
    {
        "code": "317115",
        "name": "Programador de m\u00e1quinas - ferramenta com comando num\u00e9rico"
    },
    {
        "code": "317120",
        "name": "Programador de multim\u00eddia"
    },
    {
        "code": "317205",
        "name": "Operador de computador (inclusive microcomputador)"
    },
    {
        "code": "317210",
        "name": "T\u00e9cnico de apoio ao usu\u00e1rio de inform\u00e1tica (helpdesk)"
    },
    {
        "code": "318005",
        "name": "Desenhista t\u00e9cnico"
    },
    {
        "code": "318015",
        "name": "Desenhista detalhista"
    },
    {
        "code": "318010",
        "name": "Desenhista copista"
    },
    {
        "code": "318105",
        "name": "Desenhista t\u00e9cnico (arquitetura)"
    },
    {
        "code": "318110",
        "name": "Desenhista t\u00e9cnico (cartografia)"
    },
    {
        "code": "318115",
        "name": "Desenhista t\u00e9cnico (constru\u00e7\u00e3o civil)"
    },
    {
        "code": "318120",
        "name": "Desenhista t\u00e9cnico (instala\u00e7\u00f5es hidrossanit\u00e1rias)"
    },
    {
        "code": "318215",
        "name": "Desenhista t\u00e9cnico naval"
    },
    {
        "code": "318210",
        "name": "Desenhista t\u00e9cnico aeron\u00e1utico"
    },
    {
        "code": "318205",
        "name": "Desenhista t\u00e9cnico mec\u00e2nico"
    },
    {
        "code": "318310",
        "name": "Desenhista t\u00e9cnico (calefa\u00e7\u00e3o, ventila\u00e7\u00e3o e refrigera\u00e7\u00e3o)"
    },
    {
        "code": "318305",
        "name": "Desenhista t\u00e9cnico (eletricidade e eletr\u00f4nica)"
    },
    {
        "code": "318425",
        "name": "Desenhista t\u00e9cnico (mobili\u00e1rio)"
    },
    {
        "code": "318420",
        "name": "Desenhista t\u00e9cnico (ind\u00fastria t\u00eaxtil)"
    },
    {
        "code": "318415",
        "name": "Desenhista t\u00e9cnico (ilustra\u00e7\u00f5es t\u00e9cnicas)"
    },
    {
        "code": "318410",
        "name": "Desenhista t\u00e9cnico (ilustra\u00e7\u00f5es art\u00edsticas)"
    },
    {
        "code": "318430",
        "name": "Desenhista t\u00e9cnico de embalagens, maquetes e leiautes"
    },
    {
        "code": "318405",
        "name": "Desenhista t\u00e9cnico (artes gr\u00e1ficas)"
    },
    {
        "code": "318505",
        "name": "Desenhista projetista de arquitetura"
    },
    {
        "code": "318510",
        "name": "Desenhista projetista de constru\u00e7\u00e3o civil"
    },
    {
        "code": "318610",
        "name": "Desenhista projetista mec\u00e2nico"
    },
    {
        "code": "318605",
        "name": "Desenhista projetista de m\u00e1quinas"
    },
    {
        "code": "318705",
        "name": "Desenhista projetista de eletricidade"
    },
    {
        "code": "318710",
        "name": "Desenhista projetista eletr\u00f4nico"
    },
    {
        "code": "318810",
        "name": "Modelista de roupas"
    },
    {
        "code": "318805",
        "name": "Projetista de m\u00f3veis"
    },
    {
        "code": "318815",
        "name": "Modelista de cal\u00e7ados"
    },
    {
        "code": "319105",
        "name": "T\u00e9cnico em cal\u00e7ados e artefatos de couro"
    },
    {
        "code": "319110",
        "name": "T\u00e9cnico em confec\u00e7\u00f5es do vestu\u00e1rio"
    },
    {
        "code": "319205",
        "name": "T\u00e9cnico do mobili\u00e1rio"
    },
    {
        "code": "320110",
        "name": "T\u00e9cnico em histologia"
    },
    {
        "code": "320105",
        "name": "T\u00e9cnico em bioterismo"
    },
    {
        "code": "321105",
        "name": "T\u00e9cnico agr\u00edcola"
    },
    {
        "code": "321110",
        "name": "T\u00e9cnico agropecu\u00e1rio"
    },
    {
        "code": "321205",
        "name": "T\u00e9cnico em madeira"
    },
    {
        "code": "321210",
        "name": "T\u00e9cnico florestal"
    },
    {
        "code": "321320",
        "name": "T\u00e9cnico em ranicultura"
    },
    {
        "code": "321315",
        "name": "T\u00e9cnico em mitilicultura"
    },
    {
        "code": "321310",
        "name": "T\u00e9cnico em carcinicultura"
    },
    {
        "code": "321305",
        "name": "T\u00e9cnico em piscicultura"
    },
    {
        "code": "322130",
        "name": "Esteticista"
    },
    {
        "code": "322135",
        "name": "Doula"
    },
    {
        "code": "322125",
        "name": "Terapeuta hol\u00edstico"
    },
    {
        "code": "322120",
        "name": "Massoterapeuta"
    },
    {
        "code": "322115",
        "name": "T\u00e9cnico em quiropraxia"
    },
    {
        "code": "322105",
        "name": "T\u00e9cnico em acupuntura"
    },
    {
        "code": "322110",
        "name": "Pod\u00f3logo"
    },
    {
        "code": "322220",
        "name": "T\u00e9cnico de enfermagem psiqui\u00e1trica"
    },
    {
        "code": "322250",
        "name": "Auxiliar de enfermagem da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        "code": "322205",
        "name": "T\u00e9cnico de enfermagem"
    },
    {
        "code": "322210",
        "name": "T\u00e9cnico de enfermagem de terapia intensiva"
    },
    {
        "code": "322215",
        "name": "T\u00e9cnico de enfermagem do trabalho"
    },
    {
        "code": "322245",
        "name": "T\u00e9cnico de enfermagem da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        "code": "322225",
        "name": "Instrumentador cir\u00fargico"
    },
    {
        "code": "322230",
        "name": "Auxiliar de enfermagem"
    },
    {
        "code": "322235",
        "name": "Auxiliar de enfermagem do trabalho"
    },
    {
        "code": "322240",
        "name": "Auxiliar de sa\u00fade (navega\u00e7\u00e3o mar\u00edtima)"
    },
    {
        "code": "322305",
        "name": "T\u00e9cnico em \u00f3ptica e optometria"
    },
    {
        "code": "322420",
        "name": "Auxiliar de pr\u00f3tese dent\u00e1ria"
    },
    {
        "code": "322425",
        "name": "T\u00e9cnico em sa\u00fade bucal da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        "code": "322430",
        "name": "Auxiliar em sa\u00fade bucal da estrat\u00e9gia de sa\u00fade da fam\u00edlia"
    },
    {
        "code": "322405",
        "name": "T\u00e9cnico em sa\u00fade bucal"
    },
    {
        "code": "322410",
        "name": "Prot\u00e9tico dent\u00e1rio"
    },
    {
        "code": "322415",
        "name": "Auxiliar em sa\u00fade bucal"
    },
    {
        "code": "322505",
        "name": "T\u00e9cnico de ortopedia"
    },
    {
        "code": "322605",
        "name": "T\u00e9cnico de imobiliza\u00e7\u00e3o ortop\u00e9dica"
    },
    {
        "code": "323105",
        "name": "T\u00e9cnico em pecu\u00e1ria"
    },
    {
        "code": "324130",
        "name": "T\u00e9cnico em espirometria"
    },
    {
        "code": "324125",
        "name": "Tecn\u00f3logo oft\u00e1lmico"
    },
    {
        "code": "324120",
        "name": "Tecn\u00f3logo em radiologia"
    },
    {
        "code": "324115",
        "name": "T\u00e9cnico em radiologia e imagenologia"
    },
    {
        "code": "324105",
        "name": "T\u00e9cnico em m\u00e9todos eletrogr\u00e1ficos em encefalografia"
    },
    {
        "code": "324110",
        "name": "T\u00e9cnico em m\u00e9todos gr\u00e1ficos em cardiologia"
    },
    {
        "code": "324205",
        "name": "T\u00e9cnico em patologia cl\u00ednica"
    },
    {
        "code": "324220",
        "name": "T\u00e9cnico em hemoterapia"
    },
    {
        "code": "324215",
        "name": "Citot\u00e9cnico"
    },
    {
        "code": "325015",
        "name": "Perfumista"
    },
    {
        "code": "325010",
        "name": "Aromista"
    },
    {
        "code": "325005",
        "name": "En\u00f3logo"
    },
    {
        "code": "325115",
        "name": "T\u00e9cnico em farm\u00e1cia"
    },
    {
        "code": "325110",
        "name": "T\u00e9cnico em laborat\u00f3rio de farm\u00e1cia"
    },
    {
        "code": "325105",
        "name": "Auxiliar t\u00e9cnico em laborat\u00f3rio de farm\u00e1cia"
    },
    {
        "code": "325205",
        "name": "T\u00e9cnico de alimentos"
    },
    {
        "code": "325210",
        "name": "T\u00e9cnico em nutri\u00e7\u00e3o e diet\u00e9tica"
    },
    {
        "code": "325310",
        "name": "T\u00e9cnico em imunobiol\u00f3gicos"
    },
    {
        "code": "325305",
        "name": "T\u00e9cnico em biotecnologia"
    },
    {
        "code": "328105",
        "name": "Embalsamador"
    },
    {
        "code": "328110",
        "name": "Taxidermista"
    },
    {
        "code": "331110",
        "name": "Auxiliar de desenvolvimento infantil"
    },
    {
        "code": "331105",
        "name": "Professor de n\u00edvel m\u00e9dio na educa\u00e7\u00e3o infantil"
    },
    {
        "code": "331205",
        "name": "Professor de n\u00edvel m\u00e9dio no ensino fundamental"
    },
    {
        "code": "331305",
        "name": "Professor de n\u00edvel m\u00e9dio no ensino profissionalizante"
    },
    {
        "code": "332105",
        "name": "Professor leigo no ensino fundamental"
    },
    {
        "code": "332205",
        "name": "Professor pr\u00e1tico no ensino profissionalizante"
    },
    {
        "code": "333105",
        "name": "Instrutor de auto-escola"
    },
    {
        "code": "333110",
        "name": "Instrutor de cursos livres"
    },
    {
        "code": "333115",
        "name": "Professores de cursos livres"
    },
    {
        "code": "334110",
        "name": "Inspetor de alunos de escola p\u00fablica"
    },
    {
        "code": "334105",
        "name": "Inspetor de alunos de escola privada"
    },
    {
        "code": "334115",
        "name": "Monitor de transporte escolar"
    },
    {
        "code": "341120",
        "name": "Piloto agr\u00edcola"
    },
    {
        "code": "341115",
        "name": "Mec\u00e2nico de v\u00f4o"
    },
    {
        "code": "341110",
        "name": "Piloto comercial de helic\u00f3ptero (exceto linhas a\u00e9reas)"
    },
    {
        "code": "341105",
        "name": "Piloto comercial (exceto linhas a\u00e9reas)"
    },
    {
        "code": "341250",
        "name": "Auxiliar t\u00e9cnico de sinaliza\u00e7\u00e3o nautica"
    },
    {
        "code": "341230",
        "name": "Piloto fluvial"
    },
    {
        "code": "341225",
        "name": "Patr\u00e3o de pesca na navega\u00e7\u00e3o interior"
    },
    {
        "code": "341220",
        "name": "Patr\u00e3o de pesca de alto-mar"
    },
    {
        "code": "341215",
        "name": "Mestre fluvial"
    },
    {
        "code": "341210",
        "name": "Mestre de cabotagem"
    },
    {
        "code": "341205",
        "name": "Contramestre de cabotagem"
    },
    {
        "code": "341235",
        "name": "T\u00e9nico em sinaliza\u00e7\u00e3o nautica"
    },
    {
        "code": "341245",
        "name": "T\u00e9cnico em sinais navais"
    },
    {
        "code": "341240",
        "name": "T\u00e9cnicos em manobras em equipamentos de conv\u00e9s"
    },
    {
        "code": "341305",
        "name": "Condutor maquinista motorista fluvial"
    },
    {
        "code": "341320",
        "name": "Condutor de m\u00e1quinas (bombeador)"
    },
    {
        "code": "341310",
        "name": "Condutor de m\u00e1quinas"
    },
    {
        "code": "341315",
        "name": "Eletricista de bordo"
    },
    {
        "code": "341325",
        "name": "Condutor de m\u00e1quinas (mec\u00e2nico)"
    },
    {
        "code": "342105",
        "name": "Analista de transporte em com\u00e9rcio exterior"
    },
    {
        "code": "342110",
        "name": "Operador de transporte multimodal"
    },
    {
        "code": "342115",
        "name": "Controlador de servi\u00e7os de m\u00e1quinas e ve\u00edculos"
    },
    {
        "code": "342120",
        "name": "Afretador"
    },
    {
        "code": "342125",
        "name": "Tecn\u00f3logo em log\u00edstica de transporte"
    },
    {
        "code": "342215",
        "name": "Analista de desembara\u00e7o aduaneiro"
    },
    {
        "code": "342205",
        "name": "Ajudante de despachante aduaneiro"
    },
    {
        "code": "342210",
        "name": "Despachante aduaneiro"
    },
    {
        "code": "342315",
        "name": "Supervisor de carga e descarga"
    },
    {
        "code": "342305",
        "name": "Chefe de servi\u00e7o de transporte rodovi\u00e1rio (passageiros e cargas)"
    },
    {
        "code": "342310",
        "name": "Inspetor de servi\u00e7os de transportes rodovi\u00e1rios (passageiros e cargas)"
    },
    {
        "code": "342405",
        "name": "Agente de esta\u00e7\u00e3o (ferrovia e metr\u00f4)"
    },
    {
        "code": "342410",
        "name": "Operador de centro de controle (ferrovia e metr\u00f4)"
    },
    {
        "code": "342515",
        "name": "Fiscal de avia\u00e7\u00e3o civil (fac)"
    },
    {
        "code": "342510",
        "name": "Despachante operacional de v\u00f4o"
    },
    {
        "code": "342505",
        "name": "Controlador de tr\u00e1fego a\u00e9reo"
    },
    {
        "code": "342550",
        "name": "Agente de prote\u00e7\u00e3o de avia\u00e7\u00e3o civil"
    },
    {
        "code": "342545",
        "name": "Supervisor de empresa a\u00e9rea em aeroportos"
    },
    {
        "code": "342540",
        "name": "Supervisor da administra\u00e7\u00e3o de aeroportos"
    },
    {
        "code": "342535",
        "name": "Operador de atendimento aerovi\u00e1rio"
    },
    {
        "code": "342520",
        "name": "Gerente da administra\u00e7\u00e3o de aeroportos"
    },
    {
        "code": "342525",
        "name": "Gerente de empresa a\u00e9rea em aeroportos"
    },
    {
        "code": "342530",
        "name": "Inspetor de avia\u00e7\u00e3o civil"
    },
    {
        "code": "342605",
        "name": "Chefe de esta\u00e7\u00e3o portu\u00e1ria"
    },
    {
        "code": "342610",
        "name": "Supervisor de opera\u00e7\u00f5es portu\u00e1rias"
    },
    {
        "code": "351105",
        "name": "T\u00e9cnico de contabilidade"
    },
    {
        "code": "351110",
        "name": "Chefe de contabilidade (t\u00e9cnico)"
    },
    {
        "code": "351115",
        "name": "Consultor cont\u00e1bil (t\u00e9cnico)"
    },
    {
        "code": "351305",
        "name": "T\u00e9cnico em administra\u00e7\u00e3o"
    },
    {
        "code": "351310",
        "name": "T\u00e9cnico em administra\u00e7\u00e3o de com\u00e9rcio exterior"
    },
    {
        "code": "351315",
        "name": "Agente de recrutamento e sele\u00e7\u00e3o"
    },
    {
        "code": "351405",
        "name": "Escrevente"
    },
    {
        "code": "351410",
        "name": "Escriv\u00e3o judicial"
    },
    {
        "code": "351430",
        "name": "Auxiliar de servi\u00e7os jur\u00eddicos"
    },
    {
        "code": "351425",
        "name": "Oficial de justi\u00e7a"
    },
    {
        "code": "351415",
        "name": "Escriv\u00e3o extra - judicial"
    },
    {
        "code": "351420",
        "name": "Escriv\u00e3o de pol\u00edcia"
    },
    {
        "code": "351510",
        "name": "Taqu\u00edgrafo"
    },
    {
        "code": "351505",
        "name": "T\u00e9cnico em secretariado"
    },
    {
        "code": "351515",
        "name": "Estenotipista"
    },
    {
        "code": "351610",
        "name": "T\u00e9cnico em higiene ocupacional"
    },
    {
        "code": "351605",
        "name": "T\u00e9cnico em seguran\u00e7a do trabalho"
    },
    {
        "code": "351705",
        "name": "Analista de seguros (t\u00e9cnico)"
    },
    {
        "code": "351725",
        "name": "Inspetor de risco"
    },
    {
        "code": "351740",
        "name": "T\u00e9cnico de seguros"
    },
    {
        "code": "351735",
        "name": "T\u00e9cnico de resseguros"
    },
    {
        "code": "351730",
        "name": "Inspetor de sinistros"
    },
    {
        "code": "351720",
        "name": "Assistente t\u00e9cnico de seguros"
    },
    {
        "code": "351715",
        "name": "Assistente comercial de seguros"
    },
    {
        "code": "351710",
        "name": "Analista de sinistros"
    },
    {
        "code": "351810",
        "name": "Investigador de pol\u00edcia"
    },
    {
        "code": "351805",
        "name": "Detetive profissional"
    },
    {
        "code": "351815",
        "name": "Papiloscopista policial"
    },
    {
        "code": "351910",
        "name": "Agente t\u00e9cnico de intelig\u00eancia"
    },
    {
        "code": "351905",
        "name": "Agente de intelig\u00eancia"
    },
    {
        "code": "352205",
        "name": "Agente de defesa ambiental"
    },
    {
        "code": "352210",
        "name": "Agente de sa\u00fade p\u00fablica"
    },
    {
        "code": "352305",
        "name": "Metrologista"
    },
    {
        "code": "352315",
        "name": "Agente fiscal metrol\u00f3gico"
    },
    {
        "code": "352310",
        "name": "Agente fiscal de qualidade"
    },
    {
        "code": "352320",
        "name": "Agente fiscal t\u00eaxtil"
    },
    {
        "code": "352410",
        "name": "Avaliador de produtos do meio de comunica\u00e7\u00e3o"
    },
    {
        "code": "352405",
        "name": "Agente de direitos autorais"
    },
    {
        "code": "352420",
        "name": "T\u00e9cnico em direitos autorais"
    },
    {
        "code": "353215",
        "name": "T\u00e9cnico de opera\u00e7\u00f5es e servi\u00e7os banc\u00e1rios - cr\u00e9dito rural"
    },
    {
        "code": "353220",
        "name": "T\u00e9cnico de opera\u00e7\u00f5es e servi\u00e7os banc\u00e1rios - leasing"
    },
    {
        "code": "353225",
        "name": "T\u00e9cnico de opera\u00e7\u00f5es e servi\u00e7os banc\u00e1rios - renda fixa e vari\u00e1vel"
    },
    {
        "code": "353210",
        "name": "T\u00e9cnico de opera\u00e7\u00f5es e servi\u00e7os banc\u00e1rios - cr\u00e9dito imobili\u00e1rio"
    },
    {
        "code": "353235",
        "name": "Chefe de servi\u00e7os banc\u00e1rios"
    },
    {
        "code": "353230",
        "name": "Tesoureiro de banco"
    },
    {
        "code": "353205",
        "name": "T\u00e9cnico de opera\u00e7\u00f5es e servi\u00e7os banc\u00e1rios - c\u00e2mbio"
    },
    {
        "code": "354140",
        "name": "T\u00e9cnico em atendimento e vendas"
    },
    {
        "code": "354135",
        "name": "T\u00e9cnico de vendas"
    },
    {
        "code": "354130",
        "name": "Promotor de vendas especializado"
    },
    {
        "code": "354125",
        "name": "Assistente de vendas"
    },
    {
        "code": "354120",
        "name": "Agente de vendas de servi\u00e7os"
    },
    {
        "code": "354145",
        "name": "Vendedor pracista"
    },
    {
        "code": "354150",
        "name": "Propagandista de produtos famac\u00eauticos"
    },
    {
        "code": "354205",
        "name": "Comprador"
    },
    {
        "code": "354210",
        "name": "Supervisor de compras"
    },
    {
        "code": "354305",
        "name": "Analista de exporta\u00e7\u00e3o e importa\u00e7\u00e3o"
    },
    {
        "code": "354410",
        "name": "Avaliador de im\u00f3veis"
    },
    {
        "code": "354415",
        "name": "Avaliador de bens m\u00f3veis"
    },
    {
        "code": "354405",
        "name": "Leiloeiro"
    },
    {
        "code": "354505",
        "name": "Corretor de seguros"
    },
    {
        "code": "354605",
        "name": "Corretor de im\u00f3veis"
    },
    {
        "code": "354705",
        "name": "Representante comercial aut\u00f4nomo"
    },
    {
        "code": "354820",
        "name": "Organizador de evento"
    },
    {
        "code": "354815",
        "name": "Agente de viagem"
    },
    {
        "code": "354810",
        "name": "Operador de turismo"
    },
    {
        "code": "354805",
        "name": "T\u00e9cnico em turismo"
    },
    {
        "code": "354825",
        "name": "Cerimonialista"
    },
    {
        "code": "371105",
        "name": "Auxiliar de biblioteca"
    },
    {
        "code": "371110",
        "name": "T\u00e9cnico em biblioteconomia"
    },
    {
        "code": "371210",
        "name": "T\u00e9cnico em museologia"
    },
    {
        "code": "371205",
        "name": "Colecionador de selos e moedas"
    },
    {
        "code": "371305",
        "name": "T\u00e9cnico em programa\u00e7\u00e3o visual"
    },
    {
        "code": "371310",
        "name": "T\u00e9cnico gr\u00e1fico"
    },
    {
        "code": "371405",
        "name": "Recreador de acantonamento"
    },
    {
        "code": "371410",
        "name": "Recreador"
    },
    {
        "code": "372105",
        "name": "Diretor de fotografia"
    },
    {
        "code": "372110",
        "name": "Iluminador (televis\u00e3o)"
    },
    {
        "code": "372115",
        "name": "Operador de c\u00e2mera de televis\u00e3o"
    },
    {
        "code": "372205",
        "name": "Operador de rede de teleprocessamento"
    },
    {
        "code": "372210",
        "name": "Radiotelegrafista"
    },
    {
        "code": "373105",
        "name": "Operador de \u00e1udio de continuidade (r\u00e1dio)"
    },
    {
        "code": "373110",
        "name": "Operador de central de r\u00e1dio"
    },
    {
        "code": "373115",
        "name": "Operador de externa (r\u00e1dio)"
    },
    {
        "code": "373120",
        "name": "Operador de grava\u00e7\u00e3o de r\u00e1dio"
    },
    {
        "code": "373125",
        "name": "Operador de transmissor de r\u00e1dio"
    },
    {
        "code": "373205",
        "name": "T\u00e9cnico em opera\u00e7\u00e3o de equipamentos de produ\u00e7\u00e3o para televis\u00e3o  e produtoras de v\u00eddeo"
    },
    {
        "code": "373210",
        "name": "T\u00e9cnico em opera\u00e7\u00e3o de equipamento de exibi\u00e7\u00e3o de televis\u00e3o"
    },
    {
        "code": "373215",
        "name": "T\u00e9cnico em opera\u00e7\u00e3o de equipamentos de transmiss\u00e3o\/recep\u00e7\u00e3o de televis\u00e3o"
    },
    {
        "code": "373220",
        "name": "Supervisor t\u00e9cnico operacional de sistemas de televis\u00e3o e produtoras de v\u00eddeo"
    },
    {
        "code": "374120",
        "name": "Projetista de som"
    },
    {
        "code": "374125",
        "name": "T\u00e9cnico em sonoriza\u00e7\u00e3o"
    },
    {
        "code": "374115",
        "name": "T\u00e9cnico em masteriza\u00e7\u00e3o de \u00e1udio"
    },
    {
        "code": "374110",
        "name": "T\u00e9cnico em instala\u00e7\u00e3o de equipamentos de \u00e1udio"
    },
    {
        "code": "374105",
        "name": "T\u00e9cnico em grava\u00e7\u00e3o de \u00e1udio"
    },
    {
        "code": "374145",
        "name": "Dj (disc jockey)"
    },
    {
        "code": "374140",
        "name": "Microfonista"
    },
    {
        "code": "374135",
        "name": "Projetista de sistemas de \u00e1udio"
    },
    {
        "code": "374130",
        "name": "T\u00e9cnico em mixagem de \u00e1udio"
    },
    {
        "code": "374205",
        "name": "Cenot\u00e9cnico (cinema, v\u00eddeo, televis\u00e3o, teatro e espet\u00e1culos)"
    },
    {
        "code": "374210",
        "name": "Maquinista de cinema e v\u00eddeo"
    },
    {
        "code": "374215",
        "name": "Maquinista de teatro e espet\u00e1culos"
    },
    {
        "code": "374310",
        "name": "Operador-mantenedor de projetor cinematogr\u00e1fico"
    },
    {
        "code": "374305",
        "name": "Operador de projetor cinematogr\u00e1fico"
    },
    {
        "code": "374415",
        "name": "Finalizador de v\u00eddeo"
    },
    {
        "code": "374410",
        "name": "Finalizador de filmes"
    },
    {
        "code": "374420",
        "name": "Montador de filmes"
    },
    {
        "code": "374405",
        "name": "Editor de tv  e v\u00eddeo"
    },
    {
        "code": "375105",
        "name": "Designer de interiores"
    },
    {
        "code": "375120",
        "name": "Decorador de eventos"
    },
    {
        "code": "375115",
        "name": "Visual merchandiser"
    },
    {
        "code": "375110",
        "name": "Designer de vitrines"
    },
    {
        "code": "376105",
        "name": "Dan\u00e7arino tradicional"
    },
    {
        "code": "376110",
        "name": "Dan\u00e7arino popular"
    },
    {
        "code": "376250",
        "name": "Titeriteiro"
    },
    {
        "code": "376255",
        "name": "Trapezista"
    },
    {
        "code": "376245",
        "name": "Palha\u00e7o"
    },
    {
        "code": "376240",
        "name": "Malabarista"
    },
    {
        "code": "376235",
        "name": "M\u00e1gico"
    },
    {
        "code": "376230",
        "name": "Equilibrista"
    },
    {
        "code": "376225",
        "name": "Domador de animais (circense)"
    },
    {
        "code": "376220",
        "name": "Contorcionista"
    },
    {
        "code": "376215",
        "name": "Artista de circo (outros)"
    },
    {
        "code": "376210",
        "name": "Artista a\u00e9reo"
    },
    {
        "code": "376205",
        "name": "Acrobata"
    },
    {
        "code": "376330",
        "name": "Mestre de cerimonias"
    },
    {
        "code": "376315",
        "name": "Apresentador de programas de r\u00e1dio"
    },
    {
        "code": "376320",
        "name": "Apresentador de programas de televis\u00e3o"
    },
    {
        "code": "376305",
        "name": "Apresentador de eventos"
    },
    {
        "code": "376310",
        "name": "Apresentador de festas populares"
    },
    {
        "code": "376325",
        "name": "Apresentador de circo"
    },
    {
        "code": "376410",
        "name": "Modelo de modas"
    },
    {
        "code": "376415",
        "name": "Modelo publicit\u00e1rio"
    },
    {
        "code": "376405",
        "name": "Modelo art\u00edstico"
    },
    {
        "code": "377135",
        "name": "Piloto de competi\u00e7\u00e3o automobil\u00edstica"
    },
    {
        "code": "377140",
        "name": "Profissional de atletismo"
    },
    {
        "code": "377145",
        "name": "Pugilista"
    },
    {
        "code": "377105",
        "name": "Atleta profissional (outras modalidades)"
    },
    {
        "code": "377110",
        "name": "Atleta profissional de futebol"
    },
    {
        "code": "377115",
        "name": "Atleta profissional de golfe"
    },
    {
        "code": "377120",
        "name": "Atleta profissional de luta"
    },
    {
        "code": "377125",
        "name": "Atleta profissional de t\u00eanis"
    },
    {
        "code": "377130",
        "name": "J\u00f3quei"
    },
    {
        "code": "377205",
        "name": "\u00c1rbitro desportivo"
    },
    {
        "code": "377210",
        "name": "\u00c1rbitro de atletismo"
    },
    {
        "code": "377215",
        "name": "\u00c1rbitro de basquete"
    },
    {
        "code": "377220",
        "name": "\u00c1rbitro de futebol"
    },
    {
        "code": "377245",
        "name": "\u00c1rbitro de v\u00f4lei"
    },
    {
        "code": "377230",
        "name": "\u00c1rbitro de jud\u00f4"
    },
    {
        "code": "377235",
        "name": "\u00c1rbitro de karat\u00ea"
    },
    {
        "code": "377240",
        "name": "\u00c1rbitro de pol\u00f3 aqu\u00e1tico"
    },
    {
        "code": "377225",
        "name": "\u00c1rbitro de futebol de sal\u00e3o"
    },
    {
        "code": "391105",
        "name": "Cronoanalista"
    },
    {
        "code": "391110",
        "name": "Cronometrista"
    },
    {
        "code": "391115",
        "name": "Controlador de entrada e sa\u00edda"
    },
    {
        "code": "391120",
        "name": "Planejista"
    },
    {
        "code": "391125",
        "name": "T\u00e9cnico de planejamento de produ\u00e7\u00e3o"
    },
    {
        "code": "391130",
        "name": "T\u00e9cnico de planejamento e programa\u00e7\u00e3o da manuten\u00e7\u00e3o"
    },
    {
        "code": "391135",
        "name": "T\u00e9cnico de mat\u00e9ria-prima e material"
    },
    {
        "code": "391225",
        "name": "Escolhedor de papel"
    },
    {
        "code": "391230",
        "name": "T\u00e9cnico operacional de servi\u00e7os de correios"
    },
    {
        "code": "391205",
        "name": "Inspetor de qualidade"
    },
    {
        "code": "391210",
        "name": "T\u00e9cnico de garantia da qualidade"
    },
    {
        "code": "391215",
        "name": "Operador de inspe\u00e7\u00e3o de qualidade"
    },
    {
        "code": "391220",
        "name": "T\u00e9cnico de painel de controle"
    },
    {
        "code": "395110",
        "name": "T\u00e9cnico de apoio em pesquisa e desenvolvimento agropecu\u00e1rio florestal"
    },
    {
        "code": "395105",
        "name": "T\u00e9cnico de apoio em pesquisa e desenvolvimento (exceto agropecu\u00e1rio e florestal)"
    },
    {
        "code": "410105",
        "name": "Supervisor administrativo"
    },
    {
        "code": "410225",
        "name": "Supervisor de cr\u00e9dito e cobran\u00e7a"
    },
    {
        "code": "410220",
        "name": "Supervisor de controle patrimonial"
    },
    {
        "code": "410215",
        "name": "Supervisor de contas a pagar"
    },
    {
        "code": "410235",
        "name": "Supervisor de tesouraria"
    },
    {
        "code": "410205",
        "name": "Supervisor de almoxarifado"
    },
    {
        "code": "410240",
        "name": "Supervisor de log\u00edstica"
    },
    {
        "code": "410230",
        "name": "Supervisor de or\u00e7amento"
    },
    {
        "code": "410210",
        "name": "Supervisor de c\u00e2mbio"
    },
    {
        "code": "411050",
        "name": "Agente de microcr\u00e9dito"
    },
    {
        "code": "411005",
        "name": "Auxiliar de escrit\u00f3rio"
    },
    {
        "code": "411010",
        "name": "Assistente administrativo"
    },
    {
        "code": "411015",
        "name": "Atendente de judici\u00e1rio"
    },
    {
        "code": "411020",
        "name": "Auxiliar de judici\u00e1rio"
    },
    {
        "code": "411025",
        "name": "Auxiliar de cart\u00f3rio"
    },
    {
        "code": "411030",
        "name": "Auxiliar de pessoal"
    },
    {
        "code": "411035",
        "name": "Auxiliar de estat\u00edstica"
    },
    {
        "code": "411040",
        "name": "Auxiliar de seguros"
    },
    {
        "code": "411045",
        "name": "Auxiliar de servi\u00e7os de importa\u00e7\u00e3o e exporta\u00e7\u00e3o"
    },
    {
        "code": "412105",
        "name": "Datil\u00f3grafo"
    },
    {
        "code": "412110",
        "name": "Digitador"
    },
    {
        "code": "412115",
        "name": "Operador de mensagens de telecomunica\u00e7\u00f5es (correios)"
    },
    {
        "code": "412120",
        "name": "Supervisor de digita\u00e7\u00e3o e opera\u00e7\u00e3o"
    },
    {
        "code": "412205",
        "name": "Cont\u00ednuo"
    },
    {
        "code": "413105",
        "name": "Analista de folha de pagamento"
    },
    {
        "code": "413110",
        "name": "Auxiliar de contabilidade"
    },
    {
        "code": "413115",
        "name": "Auxiliar de faturamento"
    },
    {
        "code": "413205",
        "name": "Atendente de ag\u00eancia"
    },
    {
        "code": "413210",
        "name": "Caixa de banco"
    },
    {
        "code": "413215",
        "name": "Compensador de banco"
    },
    {
        "code": "413220",
        "name": "Conferente de servi\u00e7os banc\u00e1rios"
    },
    {
        "code": "413225",
        "name": "Escritur\u00e1rio de banco"
    },
    {
        "code": "413230",
        "name": "Operador de cobran\u00e7a banc\u00e1ria"
    },
    {
        "code": "414125",
        "name": "Estoquista"
    },
    {
        "code": "414135",
        "name": "Expedidor de mercadorias"
    },
    {
        "code": "414140",
        "name": "Auxiliar de logistica"
    },
    {
        "code": "414105",
        "name": "Almoxarife"
    },
    {
        "code": "414110",
        "name": "Armazenista"
    },
    {
        "code": "414115",
        "name": "Balanceiro"
    },
    {
        "code": "414120",
        "name": "Conferente mercadoria (exceto carga e descarga)"
    },
    {
        "code": "414210",
        "name": "Apontador de produ\u00e7\u00e3o"
    },
    {
        "code": "414205",
        "name": "Apontador de m\u00e3o-de-obra"
    },
    {
        "code": "414215",
        "name": "Conferente de carga e descarga"
    },
    {
        "code": "415125",
        "name": "Kardexista"
    },
    {
        "code": "415130",
        "name": "Operador de m\u00e1quina copiadora (exceto operador de gr\u00e1fica r\u00e1pida)"
    },
    {
        "code": "415120",
        "name": "Fitotec\u00e1rio"
    },
    {
        "code": "415105",
        "name": "Arquivista de documentos"
    },
    {
        "code": "415115",
        "name": "Codificador de dados"
    },
    {
        "code": "415205",
        "name": "Carteiro"
    },
    {
        "code": "415215",
        "name": "Entregador de publica\u00e7\u00f5es"
    },
    {
        "code": "415210",
        "name": "Operador de triagem e transbordo"
    },
    {
        "code": "420135",
        "name": "Supervisor de telemarketing e atendimento"
    },
    {
        "code": "420130",
        "name": "Supervisor de telefonistas"
    },
    {
        "code": "420125",
        "name": "Supervisor de recepcionistas"
    },
    {
        "code": "420120",
        "name": "Supervisor de entrevistadores e recenseadores"
    },
    {
        "code": "420115",
        "name": "Supervisor de coletadores de apostas e de jogos"
    },
    {
        "code": "420105",
        "name": "Supervisor de caixas e bilheteiros (exceto caixa de banco)"
    },
    {
        "code": "420110",
        "name": "Supervisor de cobran\u00e7a"
    },
    {
        "code": "421120",
        "name": "Emissor de passagens"
    },
    {
        "code": "421125",
        "name": "Operador de caixa"
    },
    {
        "code": "421115",
        "name": "Bilheteiro no servi\u00e7o de divers\u00f5es"
    },
    {
        "code": "421110",
        "name": "Bilheteiro de transportes coletivos"
    },
    {
        "code": "421105",
        "name": "Atendente comercial (ag\u00eancia postal)"
    },
    {
        "code": "421210",
        "name": "Recebedor de apostas (turfe)"
    },
    {
        "code": "421205",
        "name": "Recebedor de apostas (loteria)"
    },
    {
        "code": "421315",
        "name": "Localizador (cobrador)"
    },
    {
        "code": "421310",
        "name": "Cobrador interno"
    },
    {
        "code": "421305",
        "name": "Cobrador externo"
    },
    {
        "code": "422125",
        "name": "Recepcionista de banco"
    },
    {
        "code": "422120",
        "name": "Recepcionista de hotel"
    },
    {
        "code": "422115",
        "name": "Recepcionista de seguro sa\u00fade"
    },
    {
        "code": "422130",
        "name": "Concierge"
    },
    {
        "code": "422105",
        "name": "Recepcionista, em geral"
    },
    {
        "code": "422110",
        "name": "Recepcionista de consult\u00f3rio m\u00e9dico ou dent\u00e1rio"
    },
    {
        "code": "422220",
        "name": "Operador de r\u00e1dio-chamada"
    },
    {
        "code": "422205",
        "name": "Telefonista"
    },
    {
        "code": "422210",
        "name": "Teleoperador"
    },
    {
        "code": "422215",
        "name": "Monitor de teleatendimento"
    },
    {
        "code": "422315",
        "name": "Operador de telemarketing receptivo"
    },
    {
        "code": "422320",
        "name": "Operador de telemarketing t\u00e9cnico"
    },
    {
        "code": "422310",
        "name": "Operador de telemarketing ativo e receptivo"
    },
    {
        "code": "422305",
        "name": "Operador de telemarketing ativo"
    },
    {
        "code": "423105",
        "name": "Despachante documentalista"
    },
    {
        "code": "423110",
        "name": "Despachante de tr\u00e2nsito"
    },
    {
        "code": "424120",
        "name": "Entrevistador de pre\u00e7os"
    },
    {
        "code": "424125",
        "name": "Escritur\u00e1rio  em  estat\u00edstica"
    },
    {
        "code": "424130",
        "name": "Entrevistador social"
    },
    {
        "code": "424105",
        "name": "Entrevistador censit\u00e1rio e de pesquisas amostrais"
    },
    {
        "code": "424110",
        "name": "Entrevistador de pesquisa de opini\u00e3o e m\u00eddia"
    },
    {
        "code": "424115",
        "name": "Entrevistador de pesquisas de mercado"
    },
    {
        "code": "424210",
        "name": "Aplicador de provas (concurso, avalia\u00e7\u00e3o,exame)"
    },
    {
        "code": "424205",
        "name": "Coordenador de provas (concurso, avalia\u00e7\u00e3o, exame)"
    },
    {
        "code": "510105",
        "name": "Supervisor de transportes"
    },
    {
        "code": "510110",
        "name": "Administrador de edif\u00edcios"
    },
    {
        "code": "510115",
        "name": "Supervisor de andar"
    },
    {
        "code": "510120",
        "name": "Chefe de portaria de hotel"
    },
    {
        "code": "510130",
        "name": "Chefe de bar"
    },
    {
        "code": "510135",
        "name": "Ma\u00eetre"
    },
    {
        "code": "510205",
        "name": "Supervisor de lavanderia"
    },
    {
        "code": "510305",
        "name": "Supervisor de bombeiros"
    },
    {
        "code": "510310",
        "name": "Supervisor de vigilantes"
    },
    {
        "code": "511115",
        "name": "Taifeiro (exceto militares)"
    },
    {
        "code": "511110",
        "name": "Comiss\u00e1rio de trem"
    },
    {
        "code": "511105",
        "name": "Comiss\u00e1rio de v\u00f4o"
    },
    {
        "code": "511220",
        "name": "Bilheteiro (esta\u00e7\u00f5es de metr\u00f4, ferrovi\u00e1rias e assemelhadas)"
    },
    {
        "code": "511205",
        "name": "Fiscal de transportes coletivos (exceto trem)"
    },
    {
        "code": "511210",
        "name": "Despachante de transportes coletivos (exceto trem)"
    },
    {
        "code": "511215",
        "name": "Cobrador de transportes coletivos (exceto trem)"
    },
    {
        "code": "511405",
        "name": "Guia de turismo"
    },
    {
        "code": "511510",
        "name": "Condutor de turismo de pesca"
    },
    {
        "code": "511505",
        "name": "Condutor de turismo de aventura"
    },
    {
        "code": "512105",
        "name": "Empregado  dom\u00e9stico  nos servi\u00e7os gerais"
    },
    {
        "code": "512120",
        "name": "Empregado dom\u00e9stico diarista"
    },
    {
        "code": "512115",
        "name": "Empregado dom\u00e9stico  faxineiro"
    },
    {
        "code": "512110",
        "name": "Empregado dom\u00e9stico  arrumador"
    },
    {
        "code": "513105",
        "name": "Mordomo de resid\u00eancia"
    },
    {
        "code": "513110",
        "name": "Mordomo de hotelaria"
    },
    {
        "code": "513115",
        "name": "Governanta de hotelaria"
    },
    {
        "code": "513205",
        "name": "Cozinheiro geral"
    },
    {
        "code": "513225",
        "name": "Cozinheiro de embarca\u00e7\u00f5es"
    },
    {
        "code": "513220",
        "name": "Cozinheiro de hospital"
    },
    {
        "code": "513215",
        "name": "Cozinheiro industrial"
    },
    {
        "code": "513210",
        "name": "Cozinheiro do servi\u00e7o dom\u00e9stico"
    },
    {
        "code": "513325",
        "name": "Guarda-roupeira de cinema"
    },
    {
        "code": "513320",
        "name": "Camareiro de embarca\u00e7\u00f5es"
    },
    {
        "code": "513315",
        "name": "Camareiro  de hotel"
    },
    {
        "code": "513310",
        "name": "Camareira de televis\u00e3o"
    },
    {
        "code": "513305",
        "name": "Camareira de teatro"
    },
    {
        "code": "513440",
        "name": "Barista"
    },
    {
        "code": "513430",
        "name": "Copeiro de hospital"
    },
    {
        "code": "513425",
        "name": "Copeiro"
    },
    {
        "code": "513420",
        "name": "Barman"
    },
    {
        "code": "513415",
        "name": "Cumim"
    },
    {
        "code": "513410",
        "name": "Gar\u00e7om (servi\u00e7os de vinhos)"
    },
    {
        "code": "513405",
        "name": "Gar\u00e7om"
    },
    {
        "code": "513435",
        "name": "Atendente de lanchonete"
    },
    {
        "code": "513505",
        "name": "Auxiliar nos servi\u00e7os de alimenta\u00e7\u00e3o"
    },
    {
        "code": "513605",
        "name": "Churrasqueiro"
    },
    {
        "code": "513610",
        "name": "Pizzaiolo"
    },
    {
        "code": "513615",
        "name": "Sushiman"
    },
    {
        "code": "514105",
        "name": "Ascensorista"
    },
    {
        "code": "514120",
        "name": "Zelador de edif\u00edcio"
    },
    {
        "code": "514115",
        "name": "Sacrist\u00e3o"
    },
    {
        "code": "514110",
        "name": "Garagista"
    },
    {
        "code": "514215",
        "name": "Varredor de rua"
    },
    {
        "code": "514225",
        "name": "Trabalhador de servi\u00e7os de limpeza e conserva\u00e7\u00e3o de \u00e1reas p\u00fablicas"
    },
    {
        "code": "514205",
        "name": "Coletor de lixo domiciliar"
    },
    {
        "code": "514230",
        "name": "Coletor de res\u00edduos s\u00f3lidos de servi\u00e7os de sa\u00fade"
    },
    {
        "code": "514305",
        "name": "Limpador de vidros"
    },
    {
        "code": "514310",
        "name": "Auxiliar de manuten\u00e7\u00e3o predial"
    },
    {
        "code": "514315",
        "name": "Limpador de fachadas"
    },
    {
        "code": "514320",
        "name": "Faxineiro"
    },
    {
        "code": "514330",
        "name": "Limpador de piscinas"
    },
    {
        "code": "514325",
        "name": "Trabalhador da manuten\u00e7\u00e3o de edifica\u00e7\u00f5es"
    },
    {
        "code": "515140",
        "name": "Agente de combate \u00e0s endemias"
    },
    {
        "code": "515105",
        "name": "Agente comunit\u00e1rio de sa\u00fade"
    },
    {
        "code": "515110",
        "name": "Atendente de enfermagem"
    },
    {
        "code": "515135",
        "name": "Socorrista (exceto m\u00e9dicos e enfermeiros)"
    },
    {
        "code": "515120",
        "name": "Visitador sanit\u00e1rio"
    },
    {
        "code": "515125",
        "name": "Agente ind\u00edgena de sa\u00fade"
    },
    {
        "code": "515130",
        "name": "Agente ind\u00edgena de saneamento"
    },
    {
        "code": "515115",
        "name": "Parteira leiga"
    },
    {
        "code": "515205",
        "name": "Auxiliar de banco de sangue"
    },
    {
        "code": "515210",
        "name": "Auxiliar de farm\u00e1cia de manipula\u00e7\u00e3o"
    },
    {
        "code": "515215",
        "name": "Auxiliar de laborat\u00f3rio de an\u00e1lises cl\u00ednicas"
    },
    {
        "code": "515220",
        "name": "Auxiliar de laborat\u00f3rio de imunobiol\u00f3gicos"
    },
    {
        "code": "515225",
        "name": "Auxiliar de produ\u00e7\u00e3o farmac\u00eautica"
    },
    {
        "code": "515310",
        "name": "Agente de a\u00e7\u00e3o social"
    },
    {
        "code": "515325",
        "name": "S\u00f3cioeducador"
    },
    {
        "code": "515320",
        "name": "Conselheiro tutelar"
    },
    {
        "code": "515315",
        "name": "Monitor de dependente qu\u00edmico"
    },
    {
        "code": "515305",
        "name": "Educador social"
    },
    {
        "code": "515330",
        "name": "Monitor de ressocializa\u00e7\u00e3o prisional"
    },
    {
        "code": "516110",
        "name": "Cabeleireiro"
    },
    {
        "code": "516140",
        "name": "Pedicure"
    },
    {
        "code": "516105",
        "name": "Barbeiro"
    },
    {
        "code": "516120",
        "name": "Manicure"
    },
    {
        "code": "516125",
        "name": "Maquiador"
    },
    {
        "code": "516130",
        "name": "Maquiador de caracteriza\u00e7\u00e3o"
    },
    {
        "code": "516220",
        "name": "Cuidador em sa\u00fade"
    },
    {
        "code": "516215",
        "name": "M\u00e3e social"
    },
    {
        "code": "516205",
        "name": "Bab\u00e1"
    },
    {
        "code": "516210",
        "name": "Cuidador de idosos"
    },
    {
        "code": "516305",
        "name": "Lavadeiro, em geral"
    },
    {
        "code": "516310",
        "name": "Lavador de roupas  a maquina"
    },
    {
        "code": "516345",
        "name": "Auxiliar de lavanderia"
    },
    {
        "code": "516340",
        "name": "Atendente de lavanderia"
    },
    {
        "code": "516335",
        "name": "Conferente-expedidor de roupas (lavanderias)"
    },
    {
        "code": "516330",
        "name": "Tingidor de roupas"
    },
    {
        "code": "516325",
        "name": "Passador de roupas em geral"
    },
    {
        "code": "516315",
        "name": "Lavador de artefatos de tape\u00e7aria"
    },
    {
        "code": "516320",
        "name": "Limpador a seco, \u00e0 m\u00e1quina"
    },
    {
        "code": "516415",
        "name": "Passador de roupas, \u00e0 m\u00e3o"
    },
    {
        "code": "516410",
        "name": "Limpador de roupas a seco, \u00e0 m\u00e3o"
    },
    {
        "code": "516405",
        "name": "Lavador de roupas"
    },
    {
        "code": "516505",
        "name": "Agente funer\u00e1rio"
    },
    {
        "code": "516605",
        "name": "Operador de forno (servi\u00e7os funer\u00e1rios)"
    },
    {
        "code": "516610",
        "name": "Sepultador"
    },
    {
        "code": "516705",
        "name": "Astr\u00f3logo"
    },
    {
        "code": "516710",
        "name": "Numer\u00f3logo"
    },
    {
        "code": "516805",
        "name": "Esot\u00e9rico"
    },
    {
        "code": "516810",
        "name": "Paranormal"
    },
    {
        "code": "517110",
        "name": "Bombeiro civil"
    },
    {
        "code": "517115",
        "name": "Salva-vidas"
    },
    {
        "code": "517105",
        "name": "Bombeiro de aer\u00f3dromo"
    },
    {
        "code": "517220",
        "name": "Agente de tr\u00e2nsito"
    },
    {
        "code": "517210",
        "name": "Policial rodovi\u00e1rio federal"
    },
    {
        "code": "517205",
        "name": "Agente de pol\u00edcia federal"
    },
    {
        "code": "517215",
        "name": "Guarda-civil municipal"
    },
    {
        "code": "517325",
        "name": "Vigia portu\u00e1rio"
    },
    {
        "code": "517335",
        "name": "Guarda portu\u00e1rio"
    },
    {
        "code": "517330",
        "name": "Vigilante"
    },
    {
        "code": "517320",
        "name": "Vigia florestal"
    },
    {
        "code": "517315",
        "name": "Agente de seguran\u00e7a penitenci\u00e1ria"
    },
    {
        "code": "517310",
        "name": "Agente de seguran\u00e7a"
    },
    {
        "code": "517305",
        "name": "Agente de prote\u00e7\u00e3o de aeroporto"
    },
    {
        "code": "517420",
        "name": "Vigia"
    },
    {
        "code": "517425",
        "name": "Fiscal de loja"
    },
    {
        "code": "517405",
        "name": "Porteiro (hotel)"
    },
    {
        "code": "517410",
        "name": "Porteiro de edif\u00edcios"
    },
    {
        "code": "517415",
        "name": "Porteiro de locais de divers\u00e3o"
    },
    {
        "code": "519115",
        "name": "Mototaxista"
    },
    {
        "code": "519105",
        "name": "Ciclista mensageiro"
    },
    {
        "code": "519110",
        "name": "Motofretista"
    },
    {
        "code": "519210",
        "name": "Selecionador de material recicl\u00e1vel"
    },
    {
        "code": "519215",
        "name": "Operador de prensa de material recicl\u00e1vel"
    },
    {
        "code": "519205",
        "name": "Catador de material recicl\u00e1vel"
    },
    {
        "code": "519305",
        "name": "Auxiliar de veterin\u00e1rio"
    },
    {
        "code": "519315",
        "name": "Banhista de animais dom\u00e9sticos"
    },
    {
        "code": "519320",
        "name": "Tosador de animais dom\u00e9sticos"
    },
    {
        "code": "519310",
        "name": "Esteticista de animais dom\u00e9sticos"
    },
    {
        "code": "519805",
        "name": "Profissional do sexo"
    },
    {
        "code": "519945",
        "name": "Recepcionista de casas de espet\u00e1culos"
    },
    {
        "code": "519940",
        "name": "Leiturista"
    },
    {
        "code": "519930",
        "name": "Lavador de garrafas, vidros e outros utens\u00edlios"
    },
    {
        "code": "519925",
        "name": "Guardador de ve\u00edculos"
    },
    {
        "code": "519920",
        "name": "Gandula"
    },
    {
        "code": "519915",
        "name": "Engraxate"
    },
    {
        "code": "519910",
        "name": "Controlador de pragas"
    },
    {
        "code": "519905",
        "name": "Cartazeiro"
    },
    {
        "code": "519935",
        "name": "Lavador de ve\u00edculos"
    },
    {
        "code": "520110",
        "name": "Supervisor de vendas comercial"
    },
    {
        "code": "520105",
        "name": "Supervisor de vendas de servi\u00e7os"
    },
    {
        "code": "521120",
        "name": "Demonstrador de mercadorias"
    },
    {
        "code": "521125",
        "name": "Repositor de mercadorias"
    },
    {
        "code": "521140",
        "name": "Atendente de lojas e mercados"
    },
    {
        "code": "521135",
        "name": "Frentista"
    },
    {
        "code": "521105",
        "name": "Vendedor em com\u00e9rcio atacadista"
    },
    {
        "code": "521115",
        "name": "Promotor de vendas"
    },
    {
        "code": "521110",
        "name": "Vendedor de com\u00e9rcio varejista"
    },
    {
        "code": "521130",
        "name": "Atendente de farm\u00e1cia - balconista"
    },
    {
        "code": "523115",
        "name": "Chaveiro"
    },
    {
        "code": "523110",
        "name": "Instalador de som e acess\u00f3rios de ve\u00edculos"
    },
    {
        "code": "523105",
        "name": "Instalador de cortinas e persianas, portas sanfonadas e boxe"
    },
    {
        "code": "524105",
        "name": "Vendedor em domic\u00edlio"
    },
    {
        "code": "524205",
        "name": "Feirante"
    },
    {
        "code": "524210",
        "name": "Jornaleiro (em banca de jornal)"
    },
    {
        "code": "524215",
        "name": "Vendedor  permission\u00e1rio"
    },
    {
        "code": "524315",
        "name": "Baiana de acaraj\u00e9"
    },
    {
        "code": "524305",
        "name": "Vendedor ambulante"
    },
    {
        "code": "524310",
        "name": "Pipoqueiro ambulante"
    },
    {
        "code": "611005",
        "name": "Produtor agropecu\u00e1rio, em geral"
    },
    {
        "code": "612005",
        "name": "Produtor agr\u00edcola polivalente"
    },
    {
        "code": "612120",
        "name": "Produtor de gram\u00edneas forrageiras"
    },
    {
        "code": "612115",
        "name": "Produtor de cereais de inverno"
    },
    {
        "code": "612105",
        "name": "Produtor de arroz"
    },
    {
        "code": "612110",
        "name": "Produtor de cana-de-a\u00e7\u00facar"
    },
    {
        "code": "612125",
        "name": "Produtor de milho e sorgo"
    },
    {
        "code": "612210",
        "name": "Produtor de curau\u00e1"
    },
    {
        "code": "612215",
        "name": "Produtor de juta"
    },
    {
        "code": "612220",
        "name": "Produtor de rami"
    },
    {
        "code": "612225",
        "name": "Produtor de sisal"
    },
    {
        "code": "612205",
        "name": "Produtor de algod\u00e3o"
    },
    {
        "code": "612315",
        "name": "Produtor na olericultura de talos, folhas e flores"
    },
    {
        "code": "612320",
        "name": "Produtor na olericultura de frutos e sementes"
    },
    {
        "code": "612310",
        "name": "Produtor na olericultura de ra\u00edzes, bulbos e tub\u00e9rculos"
    },
    {
        "code": "612305",
        "name": "Produtor na olericultura de legumes"
    },
    {
        "code": "612415",
        "name": "Produtor de forra\u00e7\u00f5es"
    },
    {
        "code": "612405",
        "name": "Produtor de flores de corte"
    },
    {
        "code": "612410",
        "name": "Produtor de flores em vaso"
    },
    {
        "code": "612420",
        "name": "Produtor de plantas ornamentais"
    },
    {
        "code": "612510",
        "name": "Produtor de esp\u00e9cies frut\u00edferas rasteiras"
    },
    {
        "code": "612505",
        "name": "Produtor de \u00e1rvores frut\u00edferas"
    },
    {
        "code": "612515",
        "name": "Produtor de esp\u00e9cies frut\u00edferas trepadeiras"
    },
    {
        "code": "612620",
        "name": "Produtor de fumo"
    },
    {
        "code": "612625",
        "name": "Produtor de guaran\u00e1"
    },
    {
        "code": "612610",
        "name": "Produtor de cacau"
    },
    {
        "code": "612615",
        "name": "Produtor de erva-mate"
    },
    {
        "code": "612605",
        "name": "Cafeicultor"
    },
    {
        "code": "612730",
        "name": "Produtor da cultura de linho"
    },
    {
        "code": "612725",
        "name": "Produtor da cultura de girassol"
    },
    {
        "code": "612705",
        "name": "Produtor da cultura de amendoim"
    },
    {
        "code": "612710",
        "name": "Produtor da cultura de canola"
    },
    {
        "code": "612715",
        "name": "Produtor da cultura de coco-da-baia"
    },
    {
        "code": "612720",
        "name": "Produtor da cultura de dend\u00ea"
    },
    {
        "code": "612735",
        "name": "Produtor da cultura de mamona"
    },
    {
        "code": "612740",
        "name": "Produtor da cultura de soja"
    },
    {
        "code": "612810",
        "name": "Produtor de plantas arom\u00e1ticas e medicinais"
    },
    {
        "code": "612805",
        "name": "Produtor de especiarias"
    },
    {
        "code": "613010",
        "name": "Criador de animais dom\u00e9sticos"
    },
    {
        "code": "613005",
        "name": "Criador em pecu\u00e1ria polivalente"
    },
    {
        "code": "613105",
        "name": "Criador de asininos e muares"
    },
    {
        "code": "613130",
        "name": "Criador de eq\u00fc\u00ednos"
    },
    {
        "code": "613125",
        "name": "Criador de bubalinos (leite)"
    },
    {
        "code": "613120",
        "name": "Criador de bubalinos (corte)"
    },
    {
        "code": "613115",
        "name": "Criador de bovinos (leite)"
    },
    {
        "code": "613110",
        "name": "Criador de bovinos (corte)"
    },
    {
        "code": "613205",
        "name": "Criador de caprinos"
    },
    {
        "code": "613215",
        "name": "Criador de su\u00ednos"
    },
    {
        "code": "613210",
        "name": "Criador de ovinos"
    },
    {
        "code": "613310",
        "name": "Cunicultor"
    },
    {
        "code": "613305",
        "name": "Avicultor"
    },
    {
        "code": "613415",
        "name": "Minhocultor"
    },
    {
        "code": "613410",
        "name": "Criador de animais produtores de veneno"
    },
    {
        "code": "613405",
        "name": "Apicultor"
    },
    {
        "code": "613420",
        "name": "Sericultor"
    },
    {
        "code": "620105",
        "name": "Supervisor de explora\u00e7\u00e3o agr\u00edcola"
    },
    {
        "code": "620110",
        "name": "Supervisor de explora\u00e7\u00e3o agropecu\u00e1ria"
    },
    {
        "code": "620115",
        "name": "Supervisor de explora\u00e7\u00e3o pecu\u00e1ria"
    },
    {
        "code": "621005",
        "name": "Trabalhador agropecu\u00e1rio em geral"
    },
    {
        "code": "622015",
        "name": "Trabalhador na produ\u00e7\u00e3o de mudas e sementes"
    },
    {
        "code": "622010",
        "name": "Jardineiro"
    },
    {
        "code": "622005",
        "name": "Caseiro (agricultura)"
    },
    {
        "code": "622020",
        "name": "Trabalhador volante da agricultura"
    },
    {
        "code": "622120",
        "name": "Trabalhador da cultura de trigo, aveia, cevada e triticale"
    },
    {
        "code": "622115",
        "name": "Trabalhador da cultura de milho e sorgo"
    },
    {
        "code": "622105",
        "name": "Trabalhador da cultura de arroz"
    },
    {
        "code": "622110",
        "name": "Trabalhador da cultura de cana-de-a\u00e7\u00facar"
    },
    {
        "code": "622210",
        "name": "Trabalhador da cultura de sisal"
    },
    {
        "code": "622205",
        "name": "Trabalhador da cultura de algod\u00e3o"
    },
    {
        "code": "622215",
        "name": "Trabalhador da cultura do rami"
    },
    {
        "code": "622310",
        "name": "Trabalhador na olericultura (legumes)"
    },
    {
        "code": "622305",
        "name": "Trabalhador na olericultura (frutos e sementes)"
    },
    {
        "code": "622315",
        "name": "Trabalhador na olericultura (ra\u00edzes, bulbos e tub\u00e9rculos)"
    },
    {
        "code": "622320",
        "name": "Trabalhador na olericultura (talos, folhas e flores)"
    },
    {
        "code": "622405",
        "name": "Trabalhador no cultivo de flores e folhagens de corte"
    },
    {
        "code": "622410",
        "name": "Trabalhador no cultivo de flores em vaso"
    },
    {
        "code": "622415",
        "name": "Trabalhador no cultivo de forra\u00e7\u00f5es"
    },
    {
        "code": "622420",
        "name": "Trabalhador no cultivo de mudas"
    },
    {
        "code": "622425",
        "name": "Trabalhador no cultivo de plantas ornamentais"
    },
    {
        "code": "622505",
        "name": "Trabalhador no cultivo de \u00e1rvores frut\u00edferas"
    },
    {
        "code": "622510",
        "name": "Trabalhador no cultivo de esp\u00e9cies frut\u00edferas rasteiras"
    },
    {
        "code": "622515",
        "name": "Trabalhador no cultivo de trepadeiras frut\u00edferas"
    },
    {
        "code": "622615",
        "name": "Trabalhador da cultura de erva-mate"
    },
    {
        "code": "622620",
        "name": "Trabalhador da cultura de fumo"
    },
    {
        "code": "622625",
        "name": "Trabalhador da cultura de guaran\u00e1"
    },
    {
        "code": "622610",
        "name": "Trabalhador da cultura de caf\u00e9"
    },
    {
        "code": "622605",
        "name": "Trabalhador da cultura de cacau"
    },
    {
        "code": "622715",
        "name": "Trabalhador na cultura de coco-da-ba\u00eda"
    },
    {
        "code": "622710",
        "name": "Trabalhador na cultura de canola"
    },
    {
        "code": "622725",
        "name": "Trabalhador na cultura de mamona"
    },
    {
        "code": "622730",
        "name": "Trabalhador na cultura de soja"
    },
    {
        "code": "622735",
        "name": "Trabalhador na cultura do girassol"
    },
    {
        "code": "622740",
        "name": "Trabalhador na cultura do linho"
    },
    {
        "code": "622705",
        "name": "Trabalhador na cultura de amendoim"
    },
    {
        "code": "622720",
        "name": "Trabalhador na cultura de dend\u00ea"
    },
    {
        "code": "622810",
        "name": "Trabalhador da cultura de plantas arom\u00e1ticas e medicinais"
    },
    {
        "code": "622805",
        "name": "Trabalhador da cultura de especiarias"
    },
    {
        "code": "623025",
        "name": "Casqueador de animais"
    },
    {
        "code": "623030",
        "name": "Ferrador de animais"
    },
    {
        "code": "623015",
        "name": "Trabalhador de pecu\u00e1ria polivalente"
    },
    {
        "code": "623010",
        "name": "Inseminador"
    },
    {
        "code": "623020",
        "name": "Tratador de animais"
    },
    {
        "code": "623005",
        "name": "Adestrador de animais"
    },
    {
        "code": "623105",
        "name": "Trabalhador da pecu\u00e1ria (asininos e muares)"
    },
    {
        "code": "623110",
        "name": "Trabalhador da pecu\u00e1ria (bovinos corte)"
    },
    {
        "code": "623120",
        "name": "Trabalhador da pecu\u00e1ria (bubalinos)"
    },
    {
        "code": "623125",
        "name": "Trabalhador da pecu\u00e1ria (eq\u00fcinos)"
    },
    {
        "code": "623115",
        "name": "Trabalhador da pecu\u00e1ria (bovinos leite)"
    },
    {
        "code": "623210",
        "name": "Trabalhador da ovinocultura"
    },
    {
        "code": "623215",
        "name": "Trabalhador da suinocultura"
    },
    {
        "code": "623205",
        "name": "Trabalhador da caprinocultura"
    },
    {
        "code": "623320",
        "name": "Trabalhador da cunicultura"
    },
    {
        "code": "623315",
        "name": "Operador de incubadora"
    },
    {
        "code": "623310",
        "name": "Trabalhador da avicultura de postura"
    },
    {
        "code": "623305",
        "name": "Trabalhador da avicultura de corte"
    },
    {
        "code": "623325",
        "name": "Sexador"
    },
    {
        "code": "623405",
        "name": "Trabalhador em criat\u00f3rios de animais produtores de veneno"
    },
    {
        "code": "623415",
        "name": "Trabalhador na minhocultura"
    },
    {
        "code": "623420",
        "name": "Trabalhador na sericicultura"
    },
    {
        "code": "623410",
        "name": "Trabalhador na apicultura"
    },
    {
        "code": "630110",
        "name": "Supervisor da \u00e1rea florestal"
    },
    {
        "code": "630105",
        "name": "Supervisor da aq\u00fcicultura"
    },
    {
        "code": "631015",
        "name": "Pescador artesanal de lagostas"
    },
    {
        "code": "631005",
        "name": "Catador de caranguejos e siris"
    },
    {
        "code": "631010",
        "name": "Catador de mariscos"
    },
    {
        "code": "631020",
        "name": "Pescador artesanal de peixes e camar\u00f5es"
    },
    {
        "code": "631105",
        "name": "Pescador artesanal de \u00e1gua doce"
    },
    {
        "code": "631205",
        "name": "Pescador industrial"
    },
    {
        "code": "631210",
        "name": "Pescador profissional"
    },
    {
        "code": "631335",
        "name": "Criador de r\u00e3s"
    },
    {
        "code": "631330",
        "name": "Criador de quel\u00f4nios"
    },
    {
        "code": "631325",
        "name": "Criador de peixes"
    },
    {
        "code": "631320",
        "name": "Criador de ostras"
    },
    {
        "code": "631315",
        "name": "Criador de mexilh\u00f5es"
    },
    {
        "code": "631310",
        "name": "Criador de jacar\u00e9s"
    },
    {
        "code": "631305",
        "name": "Criador de camar\u00f5es"
    },
    {
        "code": "631405",
        "name": "Gelador industrial"
    },
    {
        "code": "631420",
        "name": "Redeiro (pesca)"
    },
    {
        "code": "631415",
        "name": "Proeiro"
    },
    {
        "code": "631410",
        "name": "Gelador profissional"
    },
    {
        "code": "632010",
        "name": "Raizeiro"
    },
    {
        "code": "632015",
        "name": "Viveirista florestal"
    },
    {
        "code": "632005",
        "name": "Guia florestal"
    },
    {
        "code": "632115",
        "name": "Identificador florestal"
    },
    {
        "code": "632110",
        "name": "Cubador de madeira"
    },
    {
        "code": "632105",
        "name": "Classificador de toras"
    },
    {
        "code": "632120",
        "name": "Operador de motosserra"
    },
    {
        "code": "632125",
        "name": "Trabalhador de extra\u00e7\u00e3o florestal, em geral"
    },
    {
        "code": "632215",
        "name": "Trabalhador da explora\u00e7\u00e3o de resinas"
    },
    {
        "code": "632210",
        "name": "Trabalhador da explora\u00e7\u00e3o de esp\u00e9cies produtoras de gomas n\u00e3o el\u00e1sticas"
    },
    {
        "code": "632205",
        "name": "Seringueiro"
    },
    {
        "code": "632370",
        "name": "Trabalhador da explora\u00e7\u00e3o de tucum"
    },
    {
        "code": "632365",
        "name": "Trabalhador da explora\u00e7\u00e3o de pia\u00e7ava"
    },
    {
        "code": "632360",
        "name": "Trabalhador da explora\u00e7\u00e3o de pequi"
    },
    {
        "code": "632355",
        "name": "Trabalhador da explora\u00e7\u00e3o de ouricuri"
    },
    {
        "code": "632350",
        "name": "Trabalhador da explora\u00e7\u00e3o de oiticica"
    },
    {
        "code": "632345",
        "name": "Trabalhador da explora\u00e7\u00e3o de murumuru"
    },
    {
        "code": "632340",
        "name": "Trabalhador da explora\u00e7\u00e3o de malva (p\u00e3ina)"
    },
    {
        "code": "632335",
        "name": "Trabalhador da explora\u00e7\u00e3o de copa\u00edba"
    },
    {
        "code": "632330",
        "name": "Trabalhador da explora\u00e7\u00e3o de coco-da-praia"
    },
    {
        "code": "632325",
        "name": "Trabalhador da explora\u00e7\u00e3o de carna\u00faba"
    },
    {
        "code": "632320",
        "name": "Trabalhador da explora\u00e7\u00e3o de buriti"
    },
    {
        "code": "632315",
        "name": "Trabalhador da explora\u00e7\u00e3o de bacaba"
    },
    {
        "code": "632305",
        "name": "Trabalhador da explora\u00e7\u00e3o de andiroba"
    },
    {
        "code": "632310",
        "name": "Trabalhador da explora\u00e7\u00e3o de baba\u00e7u"
    },
    {
        "code": "632405",
        "name": "Trabalhador da explora\u00e7\u00e3o de a\u00e7a\u00ed"
    },
    {
        "code": "632410",
        "name": "Trabalhador da explora\u00e7\u00e3o de castanha"
    },
    {
        "code": "632415",
        "name": "Trabalhador da explora\u00e7\u00e3o de pinh\u00e3o"
    },
    {
        "code": "632420",
        "name": "Trabalhador da explora\u00e7\u00e3o de pupunha"
    },
    {
        "code": "632505",
        "name": "Trabalhador da explora\u00e7\u00e3o de \u00e1rvores e arbustos produtores de subst\u00e2ncias arom\u00e1t., Medic. E t\u00f3xicas"
    },
    {
        "code": "632510",
        "name": "Trabalhador da explora\u00e7\u00e3o de cip\u00f3s produtores de subst\u00e2ncias arom\u00e1ticas, medicinais e t\u00f3xicas"
    },
    {
        "code": "632525",
        "name": "Trabalhador da extra\u00e7\u00e3o de subst\u00e2ncias arom\u00e1ticas, medicinais e t\u00f3xicas, em geral"
    },
    {
        "code": "632520",
        "name": "Trabalhador da explora\u00e7\u00e3o de ra\u00edzes produtoras de subst\u00e2ncias arom\u00e1ticas, medicinais e t\u00f3xicas"
    },
    {
        "code": "632515",
        "name": "Trabalhador da explora\u00e7\u00e3o de madeiras tanantes"
    },
    {
        "code": "632605",
        "name": "Carvoeiro"
    },
    {
        "code": "632610",
        "name": "Carbonizador"
    },
    {
        "code": "632615",
        "name": "Ajudante de carvoaria"
    },
    {
        "code": "641010",
        "name": "Operador de m\u00e1quinas de beneficiamento de produtos agr\u00edcolas"
    },
    {
        "code": "641005",
        "name": "Operador de colheitadeira"
    },
    {
        "code": "641015",
        "name": "Tratorista agr\u00edcola"
    },
    {
        "code": "642010",
        "name": "Operador de m\u00e1quinas florestais est\u00e1ticas"
    },
    {
        "code": "642005",
        "name": "Operador de colhedor florestal"
    },
    {
        "code": "642015",
        "name": "Operador de trator florestal"
    },
    {
        "code": "643005",
        "name": "Trabalhador na opera\u00e7\u00e3o de sistema de irriga\u00e7\u00e3o localizada (microaspers\u00e3o e gotejamento)"
    },
    {
        "code": "643010",
        "name": "Trabalhador na opera\u00e7\u00e3o de sistema de irriga\u00e7\u00e3o por aspers\u00e3o (piv\u00f4 central)"
    },
    {
        "code": "643015",
        "name": "Trabalhador na opera\u00e7\u00e3o de sistemas convencionais de irriga\u00e7\u00e3o por aspers\u00e3o"
    },
    {
        "code": "643020",
        "name": "Trabalhador na opera\u00e7\u00e3o de sistemas de irriga\u00e7\u00e3o e aspers\u00e3o (alto propelido)"
    },
    {
        "code": "643025",
        "name": "Trabalhador na opera\u00e7\u00e3o de sistemas de irriga\u00e7\u00e3o por superf\u00edcie e drenagem"
    },
    {
        "code": "710125",
        "name": "Supervisor de transporte na minera\u00e7\u00e3o"
    },
    {
        "code": "710105",
        "name": "Supervisor de apoio operacional na minera\u00e7\u00e3o"
    },
    {
        "code": "710110",
        "name": "Supervisor de extra\u00e7\u00e3o de sal"
    },
    {
        "code": "710115",
        "name": "Supervisor de perfura\u00e7\u00e3o e desmonte"
    },
    {
        "code": "710120",
        "name": "Supervisor de produ\u00e7\u00e3o na minera\u00e7\u00e3o"
    },
    {
        "code": "710205",
        "name": "Mestre (constru\u00e7\u00e3o civil)"
    },
    {
        "code": "710210",
        "name": "Mestre de linhas (ferrovias)"
    },
    {
        "code": "710225",
        "name": "Fiscal de p\u00e1tio de usina de concreto"
    },
    {
        "code": "710220",
        "name": "Supervisor de usina de concreto"
    },
    {
        "code": "710215",
        "name": "Inspetor de terraplenagem"
    },
    {
        "code": "711125",
        "name": "Escorador de minas"
    },
    {
        "code": "711120",
        "name": "Detonador"
    },
    {
        "code": "711115",
        "name": "Destro\u00e7ador de pedra"
    },
    {
        "code": "711110",
        "name": "Canteiro"
    },
    {
        "code": "711105",
        "name": "Amostrador de min\u00e9rios"
    },
    {
        "code": "711130",
        "name": "Mineiro"
    },
    {
        "code": "711225",
        "name": "Operador de m\u00e1quina perfuradora (minas e pedreiras)"
    },
    {
        "code": "711220",
        "name": "Operador de m\u00e1quina de extra\u00e7\u00e3o cont\u00ednua (minas de carv\u00e3o)"
    },
    {
        "code": "711215",
        "name": "Operador de m\u00e1quina cortadora (minas e pedreiras)"
    },
    {
        "code": "711210",
        "name": "Operador de carregadeira"
    },
    {
        "code": "711205",
        "name": "Operador de caminh\u00e3o (minas e pedreiras)"
    },
    {
        "code": "711230",
        "name": "Operador de m\u00e1quina perfuratriz"
    },
    {
        "code": "711245",
        "name": "Operador de trator (minas e pedreiras)"
    },
    {
        "code": "711240",
        "name": "Operador de schutthecar"
    },
    {
        "code": "711235",
        "name": "Operador de motoniveladora (extra\u00e7\u00e3o de minerais s\u00f3lidos)"
    },
    {
        "code": "711305",
        "name": "Operador de sonda de percuss\u00e3o"
    },
    {
        "code": "711310",
        "name": "Operador de sonda rotativa"
    },
    {
        "code": "711315",
        "name": "Sondador (po\u00e7os de petr\u00f3leo e g\u00e1s)"
    },
    {
        "code": "711320",
        "name": "Sondador de po\u00e7os (exceto de petr\u00f3leo e g\u00e1s)"
    },
    {
        "code": "711330",
        "name": "Torrista (petr\u00f3leo)"
    },
    {
        "code": "711325",
        "name": "Plataformista (petr\u00f3leo)"
    },
    {
        "code": "711405",
        "name": "Garimpeiro"
    },
    {
        "code": "711410",
        "name": "Operador de salina (sal marinho)"
    },
    {
        "code": "712105",
        "name": "Moleiro de min\u00e9rios"
    },
    {
        "code": "712110",
        "name": "Operador de aparelho de flota\u00e7\u00e3o"
    },
    {
        "code": "712115",
        "name": "Operador de aparelho de precipita\u00e7\u00e3o (minas de ouro ou prata)"
    },
    {
        "code": "712120",
        "name": "Operador de britador de mand\u00edbulas"
    },
    {
        "code": "712125",
        "name": "Operador de espessador"
    },
    {
        "code": "712130",
        "name": "Operador de jig (minas)"
    },
    {
        "code": "712135",
        "name": "Operador de peneiras hidr\u00e1ulicas"
    },
    {
        "code": "712205",
        "name": "Cortador de pedras"
    },
    {
        "code": "712210",
        "name": "Gravador de inscri\u00e7\u00f5es em pedra"
    },
    {
        "code": "712215",
        "name": "Gravador de relevos em pedra"
    },
    {
        "code": "712220",
        "name": "Polidor de pedras"
    },
    {
        "code": "712225",
        "name": "Torneiro (lavra de pedra)"
    },
    {
        "code": "712230",
        "name": "Tra\u00e7ador de pedras"
    },
    {
        "code": "715115",
        "name": "Operador de escavadeira"
    },
    {
        "code": "715110",
        "name": "Operador de compactadora de solos"
    },
    {
        "code": "715105",
        "name": "Operador de bate-estacas"
    },
    {
        "code": "715145",
        "name": "Operador de trator de l\u00e2mina"
    },
    {
        "code": "715120",
        "name": "Operador de m\u00e1quina de abrir valas"
    },
    {
        "code": "715135",
        "name": "Operador de p\u00e1 carregadeira"
    },
    {
        "code": "715130",
        "name": "Operador de motoniveladora"
    },
    {
        "code": "715125",
        "name": "Operador de m\u00e1quinas de constru\u00e7\u00e3o civil e minera\u00e7\u00e3o"
    },
    {
        "code": "715140",
        "name": "Operador de pavimentadora (asfalto, concreto e materiais similares)"
    },
    {
        "code": "715230",
        "name": "Pedreiro de edifica\u00e7\u00f5es"
    },
    {
        "code": "715225",
        "name": "Pedreiro (minera\u00e7\u00e3o)"
    },
    {
        "code": "715220",
        "name": "Pedreiro (material refrat\u00e1rio)"
    },
    {
        "code": "715215",
        "name": "Pedreiro (chamin\u00e9s industriais)"
    },
    {
        "code": "715205",
        "name": "Calceteiro"
    },
    {
        "code": "715210",
        "name": "Pedreiro"
    },
    {
        "code": "715310",
        "name": "Moldador de corpos de prova em usinas de concreto"
    },
    {
        "code": "715305",
        "name": "Armador de estrutura de concreto"
    },
    {
        "code": "715315",
        "name": "Armador de estrutura de concreto armado"
    },
    {
        "code": "715405",
        "name": "Operador de betoneira"
    },
    {
        "code": "715410",
        "name": "Operador de bomba de concreto"
    },
    {
        "code": "715415",
        "name": "Operador de central de concreto"
    },
    {
        "code": "715505",
        "name": "Carpinteiro"
    },
    {
        "code": "715510",
        "name": "Carpinteiro (esquadrias)"
    },
    {
        "code": "715545",
        "name": "Montador de andaimes (edifica\u00e7\u00f5es)"
    },
    {
        "code": "715540",
        "name": "Carpinteiro de obras civis de arte (pontes, t\u00faneis, barragens)"
    },
    {
        "code": "715535",
        "name": "Carpinteiro de f\u00f4rmas para concreto"
    },
    {
        "code": "715530",
        "name": "Carpinteiro (telhados)"
    },
    {
        "code": "715525",
        "name": "Carpinteiro de obras"
    },
    {
        "code": "715520",
        "name": "Carpinteiro (minera\u00e7\u00e3o)"
    },
    {
        "code": "715515",
        "name": "Carpinteiro (cen\u00e1rios)"
    },
    {
        "code": "715610",
        "name": "Eletricista de instala\u00e7\u00f5es (edif\u00edcios)"
    },
    {
        "code": "715615",
        "name": "Eletricista de instala\u00e7\u00f5es"
    },
    {
        "code": "715605",
        "name": "Eletricista de instala\u00e7\u00f5es (cen\u00e1rios)"
    },
    {
        "code": "715730",
        "name": "Instalador de material isolante, a m\u00e1quina (edifica\u00e7\u00f5es)"
    },
    {
        "code": "715705",
        "name": "Aplicador de asfalto impermeabilizante (coberturas)"
    },
    {
        "code": "715715",
        "name": "Instalador de isolantes t\u00e9rmicos (refrigera\u00e7\u00e3o e climatiza\u00e7\u00e3o)"
    },
    {
        "code": "715720",
        "name": "Instalador de isolantes t\u00e9rmicos de caldeira e tubula\u00e7\u00f5es"
    },
    {
        "code": "715725",
        "name": "Instalador de material isolante, a m\u00e3o (edifica\u00e7\u00f5es)"
    },
    {
        "code": "715710",
        "name": "Instalador de isolantes ac\u00fasticos"
    },
    {
        "code": "716105",
        "name": "Acabador de superf\u00edcies de concreto"
    },
    {
        "code": "716110",
        "name": "Revestidor de superf\u00edcies de concreto"
    },
    {
        "code": "716205",
        "name": "Telhador (telhas de argila e materiais similares)"
    },
    {
        "code": "716210",
        "name": "Telhador (telhas de cimento-amianto)"
    },
    {
        "code": "716215",
        "name": "Telhador (telhas met\u00e1licas)"
    },
    {
        "code": "716220",
        "name": "Telhador (telhas pl\u00e1sticas)"
    },
    {
        "code": "716305",
        "name": "Vidraceiro"
    },
    {
        "code": "716310",
        "name": "Vidraceiro (edifica\u00e7\u00f5es)"
    },
    {
        "code": "716315",
        "name": "Vidraceiro (vitrais)"
    },
    {
        "code": "716405",
        "name": "Gesseiro"
    },
    {
        "code": "716520",
        "name": "Lustrador de piso"
    },
    {
        "code": "716515",
        "name": "Pastilheiro"
    },
    {
        "code": "716510",
        "name": "Ladrilheiro"
    },
    {
        "code": "716505",
        "name": "Assoalhador"
    },
    {
        "code": "716535",
        "name": "Taqueiro"
    },
    {
        "code": "716525",
        "name": "Marmorista (constru\u00e7\u00e3o)"
    },
    {
        "code": "716530",
        "name": "Mosa\u00edsta"
    },
    {
        "code": "716605",
        "name": "Calafetador"
    },
    {
        "code": "716610",
        "name": "Pintor de obras"
    },
    {
        "code": "716615",
        "name": "Revestidor de interiores (papel, material pl\u00e1stico e emborrachados)"
    },
    {
        "code": "717005",
        "name": "Demolidor de edifica\u00e7\u00f5es"
    },
    {
        "code": "717010",
        "name": "Operador de martelete"
    },
    {
        "code": "717025",
        "name": "Vibradorista"
    },
    {
        "code": "717020",
        "name": "Servente de obras"
    },
    {
        "code": "717015",
        "name": "Poceiro (edifica\u00e7\u00f5es)"
    },
    {
        "code": "720110",
        "name": "Mestre de caldeiraria"
    },
    {
        "code": "720105",
        "name": "Mestre (afiador de ferramentas)"
    },
    {
        "code": "720160",
        "name": "Supervisor de controle de tratamento t\u00e9rmico"
    },
    {
        "code": "720155",
        "name": "Mestre serralheiro"
    },
    {
        "code": "720150",
        "name": "Mestre de usinagem"
    },
    {
        "code": "720115",
        "name": "Mestre de ferramentaria"
    },
    {
        "code": "720120",
        "name": "Mestre de forjaria"
    },
    {
        "code": "720125",
        "name": "Mestre de fundi\u00e7\u00e3o"
    },
    {
        "code": "720130",
        "name": "Mestre de galvanoplastia"
    },
    {
        "code": "720135",
        "name": "Mestre de pintura (tratamento de superf\u00edcies)"
    },
    {
        "code": "720140",
        "name": "Mestre de soldagem"
    },
    {
        "code": "720145",
        "name": "Mestre de trefila\u00e7\u00e3o de metais"
    },
    {
        "code": "720210",
        "name": "Mestre (ind\u00fastria de automotores e material de transportes)"
    },
    {
        "code": "720205",
        "name": "Mestre (constru\u00e7\u00e3o naval)"
    },
    {
        "code": "720215",
        "name": "Mestre (ind\u00fastria de m\u00e1quinas e outros equipamentos mec\u00e2nicos)"
    },
    {
        "code": "720220",
        "name": "Mestre de constru\u00e7\u00e3o de fornos"
    },
    {
        "code": "721110",
        "name": "Ferramenteiro de mandris, calibradores e outros dispositivos"
    },
    {
        "code": "721105",
        "name": "Ferramenteiro"
    },
    {
        "code": "721115",
        "name": "Modelador de metais (fundi\u00e7\u00e3o)"
    },
    {
        "code": "721220",
        "name": "Operador de usinagem convencional por abras\u00e3o"
    },
    {
        "code": "721215",
        "name": "Operador de m\u00e1quinas-ferramenta convencionais"
    },
    {
        "code": "721210",
        "name": "Operador de m\u00e1quinas operatrizes"
    },
    {
        "code": "721205",
        "name": "Operador de m\u00e1quina de eletroeros\u00e3o"
    },
    {
        "code": "721225",
        "name": "Preparador de m\u00e1quinas-ferramenta"
    },
    {
        "code": "721320",
        "name": "Afiador de serras"
    },
    {
        "code": "721315",
        "name": "Afiador de ferramentas"
    },
    {
        "code": "721310",
        "name": "Afiador de cutelaria"
    },
    {
        "code": "721305",
        "name": "Afiador de cardas"
    },
    {
        "code": "721325",
        "name": "Polidor de metais"
    },
    {
        "code": "721405",
        "name": "Operador de centro de usinagem com comando num\u00e9rico"
    },
    {
        "code": "721410",
        "name": "Operador de fresadora com comando num\u00e9rico"
    },
    {
        "code": "721415",
        "name": "Operador de mandriladora com comando num\u00e9rico"
    },
    {
        "code": "721420",
        "name": "Operador de m\u00e1quina eletroeros\u00e3o, \u00e0 fio, com comando num\u00e9rico"
    },
    {
        "code": "721425",
        "name": "Operador de retificadora com comando num\u00e9rico"
    },
    {
        "code": "721430",
        "name": "Operador de torno com comando num\u00e9rico"
    },
    {
        "code": "722105",
        "name": "Forjador"
    },
    {
        "code": "722110",
        "name": "Forjador a martelo"
    },
    {
        "code": "722115",
        "name": "Forjador prensista"
    },
    {
        "code": "722215",
        "name": "Operador de acabamento de pe\u00e7as fundidas"
    },
    {
        "code": "722220",
        "name": "Operador de m\u00e1quina centrifugadora de fundi\u00e7\u00e3o"
    },
    {
        "code": "722225",
        "name": "Operador de m\u00e1quina de fundir sob press\u00e3o"
    },
    {
        "code": "722230",
        "name": "Operador de vazamento (lingotamento)"
    },
    {
        "code": "722235",
        "name": "Preparador de panelas (lingotamento)"
    },
    {
        "code": "722205",
        "name": "Fundidor de metais"
    },
    {
        "code": "722210",
        "name": "Lingotador"
    },
    {
        "code": "722305",
        "name": "Macheiro, a m\u00e3o"
    },
    {
        "code": "722310",
        "name": "Macheiro, a  m\u00e1quina"
    },
    {
        "code": "722315",
        "name": "Moldador, a  m\u00e3o"
    },
    {
        "code": "722320",
        "name": "Moldador, a  m\u00e1quina"
    },
    {
        "code": "722325",
        "name": "Operador de equipamentos de prepara\u00e7\u00e3o de areia"
    },
    {
        "code": "722330",
        "name": "Operador de m\u00e1quina de moldar automatizada"
    },
    {
        "code": "722405",
        "name": "Cableador"
    },
    {
        "code": "722410",
        "name": "Estirador de tubos de metal sem costura"
    },
    {
        "code": "722415",
        "name": "Trefilador de metais, \u00e0 m\u00e1quina"
    },
    {
        "code": "723120",
        "name": "Operador de forno de tratamento t\u00e9rmico de metais"
    },
    {
        "code": "723115",
        "name": "Operador de equipamento para resfriamento"
    },
    {
        "code": "723110",
        "name": "Normalizador de metais e de comp\u00f3sitos"
    },
    {
        "code": "723105",
        "name": "Cementador de metais"
    },
    {
        "code": "723125",
        "name": "Temperador de metais e de comp\u00f3sitos"
    },
    {
        "code": "723220",
        "name": "Metalizador a pistola"
    },
    {
        "code": "723215",
        "name": "Galvanizador"
    },
    {
        "code": "723210",
        "name": "Fosfatizador"
    },
    {
        "code": "723205",
        "name": "Decapador"
    },
    {
        "code": "723225",
        "name": "Metalizador (banho quente)"
    },
    {
        "code": "723240",
        "name": "Oxidador"
    },
    {
        "code": "723235",
        "name": "Operador de zincagem (processo eletrol\u00edtico)"
    },
    {
        "code": "723230",
        "name": "Operador de m\u00e1quina recobridora de arame"
    },
    {
        "code": "723305",
        "name": "Operador de equipamento de secagem de pintura"
    },
    {
        "code": "723310",
        "name": "Pintor a pincel e rolo (exceto obras e estruturas met\u00e1licas)"
    },
    {
        "code": "723325",
        "name": "Pintor por imers\u00e3o"
    },
    {
        "code": "723320",
        "name": "Pintor de ve\u00edculos (fabrica\u00e7\u00e3o)"
    },
    {
        "code": "723315",
        "name": "Pintor de estruturas met\u00e1licas"
    },
    {
        "code": "723330",
        "name": "Pintor, a  pistola (exceto obras e estruturas met\u00e1licas)"
    },
    {
        "code": "724135",
        "name": "Instalador de tubula\u00e7\u00f5es de vapor (produ\u00e7\u00e3o e distribui\u00e7\u00e3o)"
    },
    {
        "code": "724105",
        "name": "Assentador de canaliza\u00e7\u00e3o (edifica\u00e7\u00f5es)"
    },
    {
        "code": "724110",
        "name": "Encanador"
    },
    {
        "code": "724115",
        "name": "Instalador de tubula\u00e7\u00f5es"
    },
    {
        "code": "724120",
        "name": "Instalador de tubula\u00e7\u00f5es (aeronaves)"
    },
    {
        "code": "724130",
        "name": "Instalador de tubula\u00e7\u00f5es de g\u00e1s combust\u00edvel (produ\u00e7\u00e3o e distribui\u00e7\u00e3o)"
    },
    {
        "code": "724125",
        "name": "Instalador de tubula\u00e7\u00f5es (embarca\u00e7\u00f5es)"
    },
    {
        "code": "724230",
        "name": "Rebitador, a  m\u00e3o"
    },
    {
        "code": "724225",
        "name": "Riscador de estruturas met\u00e1licas"
    },
    {
        "code": "724220",
        "name": "Preparador de estruturas met\u00e1licas"
    },
    {
        "code": "724215",
        "name": "Rebitador a  martelo pneum\u00e1tico"
    },
    {
        "code": "724205",
        "name": "Montador de estruturas met\u00e1licas"
    },
    {
        "code": "724210",
        "name": "Montador de estruturas met\u00e1licas de embarca\u00e7\u00f5es"
    },
    {
        "code": "724305",
        "name": "Brasador"
    },
    {
        "code": "724325",
        "name": "Soldador el\u00e9trico"
    },
    {
        "code": "724320",
        "name": "Soldador a  oxig\u00e1s"
    },
    {
        "code": "724315",
        "name": "Soldador"
    },
    {
        "code": "724310",
        "name": "Oxicortador a m\u00e3o e a  m\u00e1quina"
    },
    {
        "code": "724440",
        "name": "Serralheiro"
    },
    {
        "code": "724405",
        "name": "Caldeireiro (chapas de cobre)"
    },
    {
        "code": "724435",
        "name": "Funileiro industrial"
    },
    {
        "code": "724430",
        "name": "Chapeador de aeronaves"
    },
    {
        "code": "724425",
        "name": "Chapeador naval"
    },
    {
        "code": "724410",
        "name": "Caldeireiro (chapas de ferro e a\u00e7o)"
    },
    {
        "code": "724415",
        "name": "Chapeador"
    },
    {
        "code": "724420",
        "name": "Chapeador de carrocerias met\u00e1licas (fabrica\u00e7\u00e3o)"
    },
    {
        "code": "724515",
        "name": "Prensista (operador de prensa)"
    },
    {
        "code": "724510",
        "name": "Operador de m\u00e1quina de dobrar chapas"
    },
    {
        "code": "724505",
        "name": "Operador de m\u00e1quina de cilindrar chapas"
    },
    {
        "code": "724605",
        "name": "Operador de la\u00e7os de cabos de a\u00e7o"
    },
    {
        "code": "724610",
        "name": "Tran\u00e7ador de cabos de a\u00e7o"
    },
    {
        "code": "725005",
        "name": "Ajustador ferramenteiro"
    },
    {
        "code": "725010",
        "name": "Ajustador mec\u00e2nico"
    },
    {
        "code": "725015",
        "name": "Ajustador mec\u00e2nico (usinagem em bancada e em m\u00e1quinas-ferramentas)"
    },
    {
        "code": "725020",
        "name": "Ajustador mec\u00e2nico em bancada"
    },
    {
        "code": "725025",
        "name": "Ajustador naval (reparo e constru\u00e7\u00e3o)"
    },
    {
        "code": "725105",
        "name": "Montador de m\u00e1quinas, motores e acess\u00f3rios (montagem em s\u00e9rie)"
    },
    {
        "code": "725205",
        "name": "Montador de m\u00e1quinas"
    },
    {
        "code": "725210",
        "name": "Montador de m\u00e1quinas gr\u00e1ficas"
    },
    {
        "code": "725225",
        "name": "Montador de m\u00e1quinas-ferramentas (usinagem de metais)"
    },
    {
        "code": "725220",
        "name": "Montador de m\u00e1quinas t\u00eaxteis"
    },
    {
        "code": "725215",
        "name": "Montador de m\u00e1quinas operatrizes para madeira"
    },
    {
        "code": "725315",
        "name": "Montador de m\u00e1quinas de minas e pedreiras"
    },
    {
        "code": "725310",
        "name": "Montador de m\u00e1quinas agr\u00edcolas"
    },
    {
        "code": "725320",
        "name": "Montador de m\u00e1quinas de terraplenagem"
    },
    {
        "code": "725305",
        "name": "Montador de equipamento de levantamento"
    },
    {
        "code": "725410",
        "name": "Mec\u00e2nico montador de motores de embarca\u00e7\u00f5es"
    },
    {
        "code": "725405",
        "name": "Mec\u00e2nico montador de motores de aeronaves"
    },
    {
        "code": "725415",
        "name": "Mec\u00e2nico montador de motores de explos\u00e3o e diesel"
    },
    {
        "code": "725420",
        "name": "Mec\u00e2nico montador de turboalimentadores"
    },
    {
        "code": "725505",
        "name": "Montador de ve\u00edculos (linha de montagem)"
    },
    {
        "code": "725510",
        "name": "Operador de time de montagem"
    },
    {
        "code": "725605",
        "name": "Montador de estruturas de aeronaves"
    },
    {
        "code": "725610",
        "name": "Montador de sistemas de combust\u00edvel de aeronaves"
    },
    {
        "code": "725705",
        "name": "Mec\u00e2nico de refrigera\u00e7\u00e3o"
    },
    {
        "code": "730105",
        "name": "Supervisor de montagem e instala\u00e7\u00e3o eletroeletr\u00f4nica"
    },
    {
        "code": "731115",
        "name": "Montador de equipamentos el\u00e9tricos (instrumentos de medi\u00e7\u00e3o)"
    },
    {
        "code": "731120",
        "name": "Montador de equipamentos el\u00e9tricos (aparelhos eletrodom\u00e9sticos)"
    },
    {
        "code": "731125",
        "name": "Montador de equipamentos el\u00e9tricos (centrais el\u00e9tricas)"
    },
    {
        "code": "731130",
        "name": "Montador de equipamentos el\u00e9tricos (motores e d\u00ednamos)"
    },
    {
        "code": "731135",
        "name": "Montador de equipamentos el\u00e9tricos"
    },
    {
        "code": "731140",
        "name": "Montador de equipamentos eletr\u00f4nicos (instala\u00e7\u00f5es de sinaliza\u00e7\u00e3o)"
    },
    {
        "code": "731145",
        "name": "Montador de equipamentos eletr\u00f4nicos (m\u00e1quinas industriais)"
    },
    {
        "code": "731150",
        "name": "Montador de equipamentos eletr\u00f4nicos"
    },
    {
        "code": "731155",
        "name": "Montador de equipamentos el\u00e9tricos (elevadores e equipamentos similares)"
    },
    {
        "code": "731160",
        "name": "Montador de equipamentos el\u00e9tricos (transformadores)"
    },
    {
        "code": "731165",
        "name": "Bobinador eletricista, \u00e0 m\u00e3o"
    },
    {
        "code": "731170",
        "name": "Bobinador eletricista, \u00e0 m\u00e1quina"
    },
    {
        "code": "731175",
        "name": "Operador de linha de montagem (aparelhos el\u00e9tricos)"
    },
    {
        "code": "731180",
        "name": "Operador de linha de montagem (aparelhos eletr\u00f4nicos)"
    },
    {
        "code": "731105",
        "name": "Montador de equipamentos eletr\u00f4nicos (aparelhos m\u00e9dicos)"
    },
    {
        "code": "731110",
        "name": "Montador de equipamentos eletr\u00f4nicos (computadores e equipamentos auxiliares)"
    },
    {
        "code": "731205",
        "name": "Montador de equipamentos eletr\u00f4nicos (esta\u00e7\u00e3o de r\u00e1dio, tv e equipamentos de radar)"
    },
    {
        "code": "731310",
        "name": "Instalador-reparador de equipamentos de energia em telefonia"
    },
    {
        "code": "731315",
        "name": "Instalador-reparador de equipamentos de transmiss\u00e3o em telefonia"
    },
    {
        "code": "731320",
        "name": "Instalador-reparador de linhas e aparelhos de telecomunica\u00e7\u00f5es"
    },
    {
        "code": "731325",
        "name": "Instalador-reparador de redes e cabos telef\u00f4nicos"
    },
    {
        "code": "731305",
        "name": "Instalador-reparador de equipamentos de comuta\u00e7\u00e3o em telefonia"
    },
    {
        "code": "731330",
        "name": "Reparador de aparelhos de telecomunica\u00e7\u00f5es em laborat\u00f3rio"
    },
    {
        "code": "732105",
        "name": "Eletricista de manuten\u00e7\u00e3o de linhas el\u00e9tricas, telef\u00f4nicas e de comunica\u00e7\u00e3o de dados"
    },
    {
        "code": "732110",
        "name": "Emendador de cabos el\u00e9tricos e telef\u00f4nicos (a\u00e9reos e subterr\u00e2neos)"
    },
    {
        "code": "732115",
        "name": "Examinador de cabos, linhas el\u00e9tricas e telef\u00f4nicas"
    },
    {
        "code": "732120",
        "name": "Instalador de linhas el\u00e9tricas de alta e baixa - tens\u00e3o (rede a\u00e9rea e subterr\u00e2nea)"
    },
    {
        "code": "732125",
        "name": "Instalador eletricista (tra\u00e7\u00e3o de ve\u00edculos)"
    },
    {
        "code": "732130",
        "name": "Instalador-reparador de redes telef\u00f4nicas e de comunica\u00e7\u00e3o de dados"
    },
    {
        "code": "732135",
        "name": "Ligador de linhas telef\u00f4nicas"
    },
    {
        "code": "740110",
        "name": "Supervisor de fabrica\u00e7\u00e3o de instrumentos musicais"
    },
    {
        "code": "740105",
        "name": "Supervisor da mec\u00e2nica de precis\u00e3o"
    },
    {
        "code": "741125",
        "name": "Relojoeiro (repara\u00e7\u00e3o)"
    },
    {
        "code": "741120",
        "name": "Relojoeiro (fabrica\u00e7\u00e3o)"
    },
    {
        "code": "741115",
        "name": "Montador de instrumentos de precis\u00e3o"
    },
    {
        "code": "741110",
        "name": "Montador de instrumentos de \u00f3ptica"
    },
    {
        "code": "741105",
        "name": "Ajustador de instrumentos de precis\u00e3o"
    },
    {
        "code": "742135",
        "name": "Confeccionador de \u00f3rg\u00e3o"
    },
    {
        "code": "742130",
        "name": "Confeccionador de instrumentos de sopro (metal)"
    },
    {
        "code": "742125",
        "name": "Confeccionador de instrumentos de sopro (madeira)"
    },
    {
        "code": "742120",
        "name": "Confeccionador de instrumentos de percuss\u00e3o (pele, couro ou pl\u00e1stico)"
    },
    {
        "code": "742115",
        "name": "Confeccionador de instrumentos de corda"
    },
    {
        "code": "742110",
        "name": "Confeccionador de acorde\u00e3o"
    },
    {
        "code": "742140",
        "name": "Confeccionador de piano"
    },
    {
        "code": "742105",
        "name": "Afinador de instrumentos musicais"
    },
    {
        "code": "750105",
        "name": "Supervisor de joalheria"
    },
    {
        "code": "750205",
        "name": "Supervisor da ind\u00fastria de minerais n\u00e3o met\u00e1licos (exceto os derivados de petr\u00f3leo e carv\u00e3o)"
    },
    {
        "code": "751005",
        "name": "Engastador (j\u00f3ias)"
    },
    {
        "code": "751010",
        "name": "Joalheiro"
    },
    {
        "code": "751015",
        "name": "Joalheiro (repara\u00e7\u00f5es)"
    },
    {
        "code": "751020",
        "name": "Lapidador (j\u00f3ias)"
    },
    {
        "code": "751105",
        "name": "Bate-folha a  m\u00e1quina"
    },
    {
        "code": "751110",
        "name": "Fundidor (joalheria e ourivesaria)"
    },
    {
        "code": "751130",
        "name": "Trefilador (joalheria e ourivesaria)"
    },
    {
        "code": "751125",
        "name": "Ourives"
    },
    {
        "code": "751120",
        "name": "Laminador de metais preciosos a  m\u00e3o"
    },
    {
        "code": "751115",
        "name": "Gravador (joalheria e ourivesaria)"
    },
    {
        "code": "752110",
        "name": "Moldador (vidros)"
    },
    {
        "code": "752105",
        "name": "Artes\u00e3o modelador (vidros)"
    },
    {
        "code": "752115",
        "name": "Soprador de vidro"
    },
    {
        "code": "752120",
        "name": "Transformador de tubos de vidro"
    },
    {
        "code": "752230",
        "name": "Lapidador de vidros e cristais"
    },
    {
        "code": "752235",
        "name": "Surfassagista"
    },
    {
        "code": "752205",
        "name": "Aplicador serigr\u00e1fico em vidros"
    },
    {
        "code": "752210",
        "name": "Cortador de vidro"
    },
    {
        "code": "752215",
        "name": "Gravador de vidro a  \u00e1gua-forte"
    },
    {
        "code": "752220",
        "name": "Gravador de vidro a  esmeril"
    },
    {
        "code": "752225",
        "name": "Gravador de vidro a  jato de areia"
    },
    {
        "code": "752305",
        "name": "Ceramista"
    },
    {
        "code": "752310",
        "name": "Ceramista (torno de pedal e motor)"
    },
    {
        "code": "752315",
        "name": "Ceramista (torno semi-autom\u00e1tico)"
    },
    {
        "code": "752320",
        "name": "Ceramista modelador"
    },
    {
        "code": "752325",
        "name": "Ceramista moldador"
    },
    {
        "code": "752330",
        "name": "Ceramista prensador"
    },
    {
        "code": "752405",
        "name": "Decorador de cer\u00e2mica"
    },
    {
        "code": "752410",
        "name": "Decorador de vidro"
    },
    {
        "code": "752415",
        "name": "Decorador de vidro \u00e0 pincel"
    },
    {
        "code": "752420",
        "name": "Operador de esmaltadeira"
    },
    {
        "code": "752425",
        "name": "Operador de espelhamento"
    },
    {
        "code": "752430",
        "name": "Pintor de cer\u00e2mica, a  pincel"
    },
    {
        "code": "760110",
        "name": "Contramestre de fia\u00e7\u00e3o (ind\u00fastria t\u00eaxtil)"
    },
    {
        "code": "760120",
        "name": "Contramestre de tecelagem (ind\u00fastria t\u00eaxtil)"
    },
    {
        "code": "760105",
        "name": "Contramestre de acabamento (ind\u00fastria t\u00eaxtil)"
    },
    {
        "code": "760125",
        "name": "Mestre (ind\u00fastria t\u00eaxtil e de confec\u00e7\u00f5es)"
    },
    {
        "code": "760115",
        "name": "Contramestre de malharia (ind\u00fastria t\u00eaxtil)"
    },
    {
        "code": "760205",
        "name": "Supervisor de curtimento"
    },
    {
        "code": "760310",
        "name": "Encarregado de costura na confec\u00e7\u00e3o do vestu\u00e1rio"
    },
    {
        "code": "760305",
        "name": "Encarregado de corte na confec\u00e7\u00e3o do vestu\u00e1rio"
    },
    {
        "code": "760405",
        "name": "Supervisor  (ind\u00fastria de cal\u00e7ados e artefatos de couro)"
    },
    {
        "code": "760505",
        "name": "Supervisor da confec\u00e7\u00e3o de artefatos de tecidos, couros e afins"
    },
    {
        "code": "760605",
        "name": "Supervisor das artes gr\u00e1ficas  (ind\u00fastria editorial e gr\u00e1fica)"
    },
    {
        "code": "761005",
        "name": "Operador polivalente da ind\u00fastria t\u00eaxtil"
    },
    {
        "code": "761110",
        "name": "Lavador de l\u00e3"
    },
    {
        "code": "761105",
        "name": "Classificador de fibras t\u00eaxteis"
    },
    {
        "code": "761210",
        "name": "Operador de binadeira"
    },
    {
        "code": "761260",
        "name": "Operador de retorcedeira"
    },
    {
        "code": "761255",
        "name": "Operador de penteadeira"
    },
    {
        "code": "761250",
        "name": "Operador de passador (fia\u00e7\u00e3o)"
    },
    {
        "code": "761245",
        "name": "Operador de open-end"
    },
    {
        "code": "761240",
        "name": "Operador de ma\u00e7aroqueira"
    },
    {
        "code": "761235",
        "name": "Operador de laminadeira e reunideira"
    },
    {
        "code": "761230",
        "name": "Operador de filat\u00f3rio"
    },
    {
        "code": "761225",
        "name": "Operador de conicaleira"
    },
    {
        "code": "761220",
        "name": "Operador de cardas"
    },
    {
        "code": "761215",
        "name": "Operador de bobinadeira"
    },
    {
        "code": "761205",
        "name": "Operador de abertura (fia\u00e7\u00e3o)"
    },
    {
        "code": "761312",
        "name": "Tecel\u00e3o (tear jacquard)"
    },
    {
        "code": "761321",
        "name": "Tecel\u00e3o (tear mec\u00e2nico liso)"
    },
    {
        "code": "761330",
        "name": "Tecel\u00e3o de malhas (m\u00e1quina circular)"
    },
    {
        "code": "761333",
        "name": "Tecel\u00e3o de malhas (m\u00e1quina retil\u00ednea)"
    },
    {
        "code": "761348",
        "name": "Operador de engomadeira de urdume"
    },
    {
        "code": "761351",
        "name": "Operador de espuladeira"
    },
    {
        "code": "761357",
        "name": "Operador de urdideira"
    },
    {
        "code": "761360",
        "name": "Passamaneiro a  m\u00e1quina"
    },
    {
        "code": "761363",
        "name": "Remetedor de fios"
    },
    {
        "code": "761303",
        "name": "Tecel\u00e3o (redes)"
    },
    {
        "code": "761306",
        "name": "Tecel\u00e3o (rendas e bordados)"
    },
    {
        "code": "761315",
        "name": "Tecel\u00e3o (tear mec\u00e2nico de maquineta)"
    },
    {
        "code": "761318",
        "name": "Tecel\u00e3o (tear mec\u00e2nico de xadrez)"
    },
    {
        "code": "761324",
        "name": "Tecel\u00e3o (tear mec\u00e2nico, exceto jacquard)"
    },
    {
        "code": "761327",
        "name": "Tecel\u00e3o de malhas, a  m\u00e1quina"
    },
    {
        "code": "761336",
        "name": "Tecel\u00e3o de meias, a  m\u00e1quina"
    },
    {
        "code": "761339",
        "name": "Tecel\u00e3o de meias (m\u00e1quina circular)"
    },
    {
        "code": "761342",
        "name": "Tecel\u00e3o de meias (m\u00e1quina retil\u00ednea)"
    },
    {
        "code": "761345",
        "name": "Tecel\u00e3o de tapetes, a  m\u00e1quina"
    },
    {
        "code": "761354",
        "name": "Operador de m\u00e1quina de cordoalha"
    },
    {
        "code": "761366",
        "name": "Picotador de cart\u00f5es jacquard"
    },
    {
        "code": "761309",
        "name": "Tecel\u00e3o (tear autom\u00e1tico)"
    },
    {
        "code": "761405",
        "name": "Alvejador (tecidos)"
    },
    {
        "code": "761410",
        "name": "Estampador de tecido"
    },
    {
        "code": "761415",
        "name": "Operador de calandras (tecidos)"
    },
    {
        "code": "761420",
        "name": "Operador de chamuscadeira de tecidos"
    },
    {
        "code": "761425",
        "name": "Operador de impermeabilizador de tecidos"
    },
    {
        "code": "761430",
        "name": "Operador de m\u00e1quina de lavar fios e tecidos"
    },
    {
        "code": "761435",
        "name": "Operador de rameuse"
    },
    {
        "code": "761805",
        "name": "Inspetor de estamparia (produ\u00e7\u00e3o t\u00eaxtil)"
    },
    {
        "code": "761810",
        "name": "Revisor de fios (produ\u00e7\u00e3o t\u00eaxtil)"
    },
    {
        "code": "761815",
        "name": "Revisor de tecidos acabados"
    },
    {
        "code": "761820",
        "name": "Revisor de tecidos crus"
    },
    {
        "code": "762005",
        "name": "Trabalhador polivalente do curtimento de couros e peles"
    },
    {
        "code": "762110",
        "name": "Descarnador de couros e peles, \u00e0 maquina"
    },
    {
        "code": "762105",
        "name": "Classificador de peles"
    },
    {
        "code": "762115",
        "name": "Estirador de couros e peles (prepara\u00e7\u00e3o)"
    },
    {
        "code": "762120",
        "name": "Fuloneiro"
    },
    {
        "code": "762125",
        "name": "Rachador de couros e peles"
    },
    {
        "code": "762215",
        "name": "Enxugador de couros"
    },
    {
        "code": "762210",
        "name": "Classificador de couros"
    },
    {
        "code": "762205",
        "name": "Curtidor (couros e peles)"
    },
    {
        "code": "762220",
        "name": "Rebaixador de couros"
    },
    {
        "code": "762305",
        "name": "Estirador de couros e peles (acabamento)"
    },
    {
        "code": "762310",
        "name": "Fuloneiro no acabamento de couros e peles"
    },
    {
        "code": "762315",
        "name": "Lixador de couros e peles"
    },
    {
        "code": "762320",
        "name": "Matizador de couros e peles"
    },
    {
        "code": "762345",
        "name": "Vaqueador de couros e peles"
    },
    {
        "code": "762330",
        "name": "Prensador de couros e peles"
    },
    {
        "code": "762335",
        "name": "Palecionador de couros e peles"
    },
    {
        "code": "762340",
        "name": "Preparador de couros curtidos"
    },
    {
        "code": "762325",
        "name": "Operador de m\u00e1quinas do acabamento de couros e peles"
    },
    {
        "code": "763020",
        "name": "Costureiro de roupa de couro e pele"
    },
    {
        "code": "763005",
        "name": "Alfaiate"
    },
    {
        "code": "763010",
        "name": "Costureira de pe\u00e7as sob encomenda"
    },
    {
        "code": "763015",
        "name": "Costureira de repara\u00e7\u00e3o de roupas"
    },
    {
        "code": "763125",
        "name": "Ajudante de confec\u00e7\u00e3o"
    },
    {
        "code": "763120",
        "name": "Riscador de roupas"
    },
    {
        "code": "763115",
        "name": "Enfestador de roupas"
    },
    {
        "code": "763105",
        "name": "Auxiliar de corte (prepara\u00e7\u00e3o da confec\u00e7\u00e3o de roupas)"
    },
    {
        "code": "763110",
        "name": "Cortador de roupas"
    },
    {
        "code": "763215",
        "name": "Costureiro, a  m\u00e1quina  na confec\u00e7\u00e3o em s\u00e9rie"
    },
    {
        "code": "763210",
        "name": "Costureiro na confec\u00e7\u00e3o em s\u00e9rie"
    },
    {
        "code": "763205",
        "name": "Costureiro de roupas de couro e pele, a  m\u00e1quina na  confec\u00e7\u00e3o em s\u00e9rie"
    },
    {
        "code": "763310",
        "name": "Bordador, \u00e0 m\u00e1quina"
    },
    {
        "code": "763315",
        "name": "Marcador de pe\u00e7as confeccionadas para bordar"
    },
    {
        "code": "763320",
        "name": "Operador de m\u00e1quina de costura de acabamento"
    },
    {
        "code": "763325",
        "name": "Passadeira de pe\u00e7as confeccionadas"
    },
    {
        "code": "763305",
        "name": "Arrematadeira"
    },
    {
        "code": "764005",
        "name": "Trabalhador polivalente da confec\u00e7\u00e3o de cal\u00e7ados"
    },
    {
        "code": "764110",
        "name": "Cortador de solas e palmilhas, a  m\u00e1quina"
    },
    {
        "code": "764105",
        "name": "Cortador de cal\u00e7ados, a  m\u00e1quina (exceto solas e palmilhas)"
    },
    {
        "code": "764115",
        "name": "Preparador de cal\u00e7ados"
    },
    {
        "code": "764120",
        "name": "Preparador de solas e palmilhas"
    },
    {
        "code": "764205",
        "name": "Costurador de cal\u00e7ados, a  m\u00e1quina"
    },
    {
        "code": "764210",
        "name": "Montador de cal\u00e7ados"
    },
    {
        "code": "764305",
        "name": "Acabador de cal\u00e7ados"
    },
    {
        "code": "765010",
        "name": "Chapeleiro de senhoras"
    },
    {
        "code": "765005",
        "name": "Confeccionador de artefatos de couro (exceto sapatos)"
    },
    {
        "code": "765015",
        "name": "Boneleiro"
    },
    {
        "code": "765105",
        "name": "Cortador de artefatos de couro (exceto roupas e cal\u00e7ados)"
    },
    {
        "code": "765110",
        "name": "Cortador de tape\u00e7aria"
    },
    {
        "code": "765240",
        "name": "Tapeceiro de autos"
    },
    {
        "code": "765235",
        "name": "Estofador de m\u00f3veis"
    },
    {
        "code": "765225",
        "name": "Confeccionador de velas n\u00e1uticas, barracas e toldos"
    },
    {
        "code": "765215",
        "name": "Confeccionador de brinquedos de pano"
    },
    {
        "code": "765205",
        "name": "Colchoeiro (confec\u00e7\u00e3o de colch\u00f5es)"
    },
    {
        "code": "765230",
        "name": "Estofador de avi\u00f5es"
    },
    {
        "code": "765310",
        "name": "Costurador de artefatos de couro, a  m\u00e1quina (exceto roupas e cal\u00e7ados)"
    },
    {
        "code": "765315",
        "name": "Montador de artefatos de couro (exceto roupas e cal\u00e7ados)"
    },
    {
        "code": "765405",
        "name": "Trabalhador do acabamento de artefatos de tecidos e couros"
    },
    {
        "code": "766115",
        "name": "Gravador de matriz para flexografia (clicherista)"
    },
    {
        "code": "766105",
        "name": "Copiador de chapa"
    },
    {
        "code": "766155",
        "name": "Programador visual gr\u00e1fico"
    },
    {
        "code": "766150",
        "name": "Operador de processo de tratamento de imagem"
    },
    {
        "code": "766145",
        "name": "Operador de sistemas de prova (anal\u00f3gico e digital)"
    },
    {
        "code": "766140",
        "name": "Gravador de matriz serigr\u00e1fica"
    },
    {
        "code": "766135",
        "name": "Gravador de matriz calcogr\u00e1fica"
    },
    {
        "code": "766130",
        "name": "Gravador de matriz para rotogravura (eletromec\u00e2nico e qu\u00edmico)"
    },
    {
        "code": "766125",
        "name": "Montador de fotolito (anal\u00f3gico e digital)"
    },
    {
        "code": "766120",
        "name": "Editor de texto e imagem"
    },
    {
        "code": "766230",
        "name": "Impressor digital"
    },
    {
        "code": "766225",
        "name": "Impressor de rotogravura"
    },
    {
        "code": "766220",
        "name": "Impressor de rotativa"
    },
    {
        "code": "766215",
        "name": "Impressor de ofsete (plano e rotativo)"
    },
    {
        "code": "766240",
        "name": "Impressor letterset"
    },
    {
        "code": "766205",
        "name": "Impressor (serigrafia)"
    },
    {
        "code": "766235",
        "name": "Impressor flexogr\u00e1fico"
    },
    {
        "code": "766245",
        "name": "Impressor tampogr\u00e1fico"
    },
    {
        "code": "766250",
        "name": "Impressor tipogr\u00e1fico"
    },
    {
        "code": "766210",
        "name": "Impressor calcogr\u00e1fico"
    },
    {
        "code": "766310",
        "name": "Impressor de corte e vinco"
    },
    {
        "code": "766305",
        "name": "Acabador de embalagens (flex\u00edveis e cartot\u00e9cnicas)"
    },
    {
        "code": "766320",
        "name": "Operador de guilhotina (corte de papel)"
    },
    {
        "code": "766315",
        "name": "Operador de acabamento (ind\u00fastria gr\u00e1fica)"
    },
    {
        "code": "766325",
        "name": "Preparador de matrizes de corte e vinco"
    },
    {
        "code": "766405",
        "name": "Laboratorista fotogr\u00e1fico"
    },
    {
        "code": "766410",
        "name": "Revelador de filmes fotogr\u00e1ficos, em preto e branco"
    },
    {
        "code": "766420",
        "name": "Auxiliar de radiologia (revela\u00e7\u00e3o fotogr\u00e1fica)"
    },
    {
        "code": "766415",
        "name": "Revelador de filmes fotogr\u00e1ficos, em cores"
    },
    {
        "code": "768105",
        "name": "Tecel\u00e3o (tear manual)"
    },
    {
        "code": "768130",
        "name": "Crocheteiro, a  m\u00e3o"
    },
    {
        "code": "768125",
        "name": "Chapeleiro (chap\u00e9us de palha)"
    },
    {
        "code": "768120",
        "name": "Redeiro"
    },
    {
        "code": "768115",
        "name": "Tricoteiro, \u00e0 m\u00e3o"
    },
    {
        "code": "768110",
        "name": "Tecel\u00e3o de tapetes, a  m\u00e3o"
    },
    {
        "code": "768205",
        "name": "Bordador, a  m\u00e3o"
    },
    {
        "code": "768210",
        "name": "Cerzidor"
    },
    {
        "code": "768315",
        "name": "Costurador de artefatos de couro, a  m\u00e3o (exceto roupas e cal\u00e7ados)"
    },
    {
        "code": "768320",
        "name": "Sapateiro (cal\u00e7ados sob medida)"
    },
    {
        "code": "768325",
        "name": "Seleiro"
    },
    {
        "code": "768305",
        "name": "Art\u00edfice do couro"
    },
    {
        "code": "768310",
        "name": "Cortador de cal\u00e7ados, a  m\u00e3o (exceto solas)"
    },
    {
        "code": "768605",
        "name": "Tip\u00f3grafo"
    },
    {
        "code": "768630",
        "name": "Confeccionador de carimbos de borracha"
    },
    {
        "code": "768625",
        "name": "Pintor de letreiros"
    },
    {
        "code": "768620",
        "name": "Paginador"
    },
    {
        "code": "768615",
        "name": "Monotipista"
    },
    {
        "code": "768610",
        "name": "Linotipista"
    },
    {
        "code": "768705",
        "name": "Gravador, \u00e0 m\u00e3o (encaderna\u00e7\u00e3o)"
    },
    {
        "code": "768710",
        "name": "Restaurador de livros"
    },
    {
        "code": "770105",
        "name": "Mestre (ind\u00fastria de madeira e mobili\u00e1rio)"
    },
    {
        "code": "770110",
        "name": "Mestre carpinteiro"
    },
    {
        "code": "771120",
        "name": "Tanoeiro"
    },
    {
        "code": "771115",
        "name": "Maquetista na marcenaria"
    },
    {
        "code": "771110",
        "name": "Modelador de madeira"
    },
    {
        "code": "771105",
        "name": "Marceneiro"
    },
    {
        "code": "772105",
        "name": "Classificador de madeira"
    },
    {
        "code": "772110",
        "name": "Impregnador de madeira"
    },
    {
        "code": "772115",
        "name": "Secador de madeira"
    },
    {
        "code": "773125",
        "name": "Serrador de madeira (serra circular m\u00faltipla)"
    },
    {
        "code": "773130",
        "name": "Serrador de madeira (serra de fita m\u00faltipla)"
    },
    {
        "code": "773120",
        "name": "Serrador de madeira"
    },
    {
        "code": "773115",
        "name": "Serrador de bordas no desdobramento de madeira"
    },
    {
        "code": "773105",
        "name": "Cortador de laminados de madeira"
    },
    {
        "code": "773110",
        "name": "Operador de serras no desdobramento de madeira"
    },
    {
        "code": "773220",
        "name": "Preparador de aglomerantes"
    },
    {
        "code": "773215",
        "name": "Prensista de compensados"
    },
    {
        "code": "773210",
        "name": "Prensista de aglomerados"
    },
    {
        "code": "773205",
        "name": "Operador de m\u00e1quina intercaladora e placas (compensados)"
    },
    {
        "code": "773315",
        "name": "Operador de fresadora (usinagem de madeira)"
    },
    {
        "code": "773355",
        "name": "Torneiro na usinagem convencional de madeira"
    },
    {
        "code": "773350",
        "name": "Operador de tupia (usinagem de madeira)"
    },
    {
        "code": "773345",
        "name": "Operador de torno autom\u00e1tico (usinagem de madeira)"
    },
    {
        "code": "773340",
        "name": "Operador de serras (usinagem de madeira)"
    },
    {
        "code": "773335",
        "name": "Operador de plaina desengrossadeira"
    },
    {
        "code": "773330",
        "name": "Operador de molduradora (usinagem de madeira)"
    },
    {
        "code": "773325",
        "name": "Operador de m\u00e1quina de usinagem madeira, em geral"
    },
    {
        "code": "773320",
        "name": "Operador de lixadeira (usinagem de madeira)"
    },
    {
        "code": "773310",
        "name": "Operador de entalhadeira (usinagem de madeira)"
    },
    {
        "code": "773305",
        "name": "Operador de desempenadeira na usinagem convencional de madeira"
    },
    {
        "code": "773410",
        "name": "Operador de m\u00e1quina de cortina d\u00b4\u00e1gua (produ\u00e7\u00e3o de m\u00f3veis)"
    },
    {
        "code": "773405",
        "name": "Operador de m\u00e1quina bordatriz"
    },
    {
        "code": "773415",
        "name": "Operador de m\u00e1quina de usinagem de madeira (produ\u00e7\u00e3o em s\u00e9rie)"
    },
    {
        "code": "773420",
        "name": "Operador de prensa de alta freq\u00fc\u00eancia na usinagem de madeira"
    },
    {
        "code": "773505",
        "name": "Operador de centro de usinagem de madeira (cnc)"
    },
    {
        "code": "773510",
        "name": "Operador de m\u00e1quinas de usinar madeira (cnc)"
    },
    {
        "code": "774105",
        "name": "Montador de m\u00f3veis e artefatos de madeira"
    },
    {
        "code": "775115",
        "name": "Lustrador de pe\u00e7as de madeira"
    },
    {
        "code": "775110",
        "name": "Folheador de m\u00f3veis de madeira"
    },
    {
        "code": "775105",
        "name": "Entalhador  de madeira"
    },
    {
        "code": "775120",
        "name": "Marcheteiro"
    },
    {
        "code": "776430",
        "name": "Vassoureiro"
    },
    {
        "code": "776415",
        "name": "Confeccionador de escovas, pinc\u00e9is e produtos similares (a m\u00e1quina)"
    },
    {
        "code": "776420",
        "name": "Confeccionador de m\u00f3veis de vime, junco e bambu"
    },
    {
        "code": "776410",
        "name": "Confeccionador de escovas, pinc\u00e9is e produtos similares (a m\u00e3o)"
    },
    {
        "code": "776425",
        "name": "Esteireiro"
    },
    {
        "code": "776405",
        "name": "Cesteiro"
    },
    {
        "code": "777110",
        "name": "Carpinteiro naval (embarca\u00e7\u00f5es)"
    },
    {
        "code": "777115",
        "name": "Carpinteiro naval (estaleiros)"
    },
    {
        "code": "777105",
        "name": "Carpinteiro naval (constru\u00e7\u00e3o de pequenas embarca\u00e7\u00f5es)"
    },
    {
        "code": "777205",
        "name": "Carpinteiro de carretas"
    },
    {
        "code": "777210",
        "name": "Carpinteiro de carrocerias"
    },
    {
        "code": "780105",
        "name": "Supervisor de embalagem e etiquetagem"
    },
    {
        "code": "781110",
        "name": "Condutor de processos robotizados de soldagem"
    },
    {
        "code": "781105",
        "name": "Condutor de processos robotizados de pintura"
    },
    {
        "code": "781305",
        "name": "Operador de ve\u00edculos subaqu\u00e1ticos controlados remotamente"
    },
    {
        "code": "781705",
        "name": "Mergulhador profissional (raso e profundo)"
    },
    {
        "code": "782115",
        "name": "Operador de guindaste m\u00f3vel"
    },
    {
        "code": "782110",
        "name": "Operador de guindaste (fixo)"
    },
    {
        "code": "782105",
        "name": "Operador de draga"
    },
    {
        "code": "782120",
        "name": "Operador de m\u00e1quina rodoferrovi\u00e1ria"
    },
    {
        "code": "782140",
        "name": "Operador de talha el\u00e9trica"
    },
    {
        "code": "782145",
        "name": "Sinaleiro (ponte-rolante)"
    },
    {
        "code": "782135",
        "name": "Operador de p\u00f3rtico rolante"
    },
    {
        "code": "782130",
        "name": "Operador de ponte rolante"
    },
    {
        "code": "782125",
        "name": "Operador de monta-cargas (constru\u00e7\u00e3o civil)"
    },
    {
        "code": "782205",
        "name": "Guincheiro (constru\u00e7\u00e3o civil)"
    },
    {
        "code": "782210",
        "name": "Operador de docagem"
    },
    {
        "code": "782220",
        "name": "Operador de empilhadeira"
    },
    {
        "code": "782320",
        "name": "Condutor de ambul\u00e2ncia"
    },
    {
        "code": "782305",
        "name": "Motorista de carro de passeio"
    },
    {
        "code": "782310",
        "name": "Motorista de furg\u00e3o ou ve\u00edculo similar"
    },
    {
        "code": "782315",
        "name": "Motorista de t\u00e1xi"
    },
    {
        "code": "782410",
        "name": "Motorista de \u00f4nibus urbano"
    },
    {
        "code": "782405",
        "name": "Motorista de \u00f4nibus rodovi\u00e1rio"
    },
    {
        "code": "782415",
        "name": "Motorista de tr\u00f3lebus"
    },
    {
        "code": "782505",
        "name": "Caminhoneiro aut\u00f4nomo (rotas regionais e internacionais)"
    },
    {
        "code": "782510",
        "name": "Motorista de caminh\u00e3o (rotas regionais e internacionais)"
    },
    {
        "code": "782515",
        "name": "Motorista operacional de guincho"
    },
    {
        "code": "782615",
        "name": "Maquinista de trem metropolitano"
    },
    {
        "code": "782610",
        "name": "Maquinista de trem"
    },
    {
        "code": "782630",
        "name": "Operador de telef\u00e9rico (passageiros)"
    },
    {
        "code": "782605",
        "name": "Operador de trem de metr\u00f4"
    },
    {
        "code": "782625",
        "name": "Auxiliar de maquinista de trem"
    },
    {
        "code": "782620",
        "name": "Motorneiro"
    },
    {
        "code": "782735",
        "name": "Marinheiro auxiliar de m\u00e1quinas (mar\u00edtimo e aquavi\u00e1rio)"
    },
    {
        "code": "782730",
        "name": "Marinheiro auxiliar de conv\u00e9s (mar\u00edtimo e aquaviario)"
    },
    {
        "code": "782725",
        "name": "Marinheiro de esporte e recreio"
    },
    {
        "code": "782720",
        "name": "Mo\u00e7o de m\u00e1quinas (mar\u00edtimo e fluvi\u00e1rio)"
    },
    {
        "code": "782715",
        "name": "Mo\u00e7o de conv\u00e9s (mar\u00edtimo e fluvi\u00e1rio)"
    },
    {
        "code": "782705",
        "name": "Marinheiro de conv\u00e9s (mar\u00edtimo e fluvi\u00e1rio)"
    },
    {
        "code": "782710",
        "name": "Marinheiro de m\u00e1quinas"
    },
    {
        "code": "782820",
        "name": "Condutor de ve\u00edculos a pedais"
    },
    {
        "code": "782815",
        "name": "Boiadeiro"
    },
    {
        "code": "782810",
        "name": "Tropeiro"
    },
    {
        "code": "782805",
        "name": "Condutor de ve\u00edculos de tra\u00e7\u00e3o animal (ruas e estradas)"
    },
    {
        "code": "783105",
        "name": "Agente de p\u00e1tio"
    },
    {
        "code": "783110",
        "name": "Manobrador"
    },
    {
        "code": "783205",
        "name": "Carregador (aeronaves)"
    },
    {
        "code": "783210",
        "name": "Carregador (armaz\u00e9m)"
    },
    {
        "code": "783215",
        "name": "Carregador (ve\u00edculos de transportes terrestres)"
    },
    {
        "code": "783220",
        "name": "Estivador"
    },
    {
        "code": "783235",
        "name": "Trabalhador portu\u00e1rio de capatazia"
    },
    {
        "code": "783230",
        "name": "Bloqueiro (trabalhador portu\u00e1rio)"
    },
    {
        "code": "783225",
        "name": "Ajudante de motorista"
    },
    {
        "code": "784105",
        "name": "Embalador, a m\u00e3o"
    },
    {
        "code": "784110",
        "name": "Embalador, a m\u00e1quina"
    },
    {
        "code": "784115",
        "name": "Operador de m\u00e1quina de etiquetar"
    },
    {
        "code": "784120",
        "name": "Operador de m\u00e1quina de envasar l\u00edquidos"
    },
    {
        "code": "784125",
        "name": "Operador de prensa de enfardamento"
    },
    {
        "code": "784205",
        "name": "Alimentador de linha de produ\u00e7\u00e3o"
    },
    {
        "code": "791105",
        "name": "Artes\u00e3o bordador"
    },
    {
        "code": "791110",
        "name": "Artes\u00e3o ceramista"
    },
    {
        "code": "791115",
        "name": "Artes\u00e3o com material recicl\u00e1vel"
    },
    {
        "code": "791120",
        "name": "Artes\u00e3o confeccionador de bioj\u00f3ias e ecoj\u00f3ias"
    },
    {
        "code": "791125",
        "name": "Artes\u00e3o do couro"
    },
    {
        "code": "791160",
        "name": "Artes\u00e3o rendeiro"
    },
    {
        "code": "791135",
        "name": "Artes\u00e3o moveleiro (exceto reciclado)"
    },
    {
        "code": "791140",
        "name": "Artes\u00e3o tecel\u00e3o"
    },
    {
        "code": "791145",
        "name": "Artes\u00e3o tran\u00e7ador"
    },
    {
        "code": "791150",
        "name": "Artes\u00e3o crocheteiro"
    },
    {
        "code": "791155",
        "name": "Artes\u00e3o tricoteiro"
    },
    {
        "code": "791130",
        "name": "Artes\u00e3o escultor"
    },
    {
        "code": "810110",
        "name": "Mestre de produ\u00e7\u00e3o qu\u00edmica"
    },
    {
        "code": "810105",
        "name": "Mestre (ind\u00fastria petroqu\u00edmica e carboqu\u00edmica)"
    },
    {
        "code": "810205",
        "name": "Mestre (ind\u00fastria de borracha e pl\u00e1stico)"
    },
    {
        "code": "810305",
        "name": "Mestre de produ\u00e7\u00e3o farmac\u00eautica"
    },
    {
        "code": "811005",
        "name": "Operador de processos qu\u00edmicos e petroqu\u00edmicos"
    },
    {
        "code": "811010",
        "name": "Operador de sala de controle de instala\u00e7\u00f5es qu\u00edmicas, petroqu\u00edmicas e afins"
    },
    {
        "code": "811105",
        "name": "Moleiro (tratamentos qu\u00edmicos e afins)"
    },
    {
        "code": "811115",
        "name": "Operador de britadeira (tratamentos qu\u00edmicos e afins)"
    },
    {
        "code": "811120",
        "name": "Operador de concentra\u00e7\u00e3o"
    },
    {
        "code": "811125",
        "name": "Trabalhador da fabrica\u00e7\u00e3o de resinas e vernizes"
    },
    {
        "code": "811130",
        "name": "Trabalhador de fabrica\u00e7\u00e3o de tintas"
    },
    {
        "code": "811110",
        "name": "Operador de m\u00e1quina misturadeira (tratamentos qu\u00edmicos e afins)"
    },
    {
        "code": "811215",
        "name": "Operador de tratamento qu\u00edmico de materiais radioativos"
    },
    {
        "code": "811205",
        "name": "Operador de calcina\u00e7\u00e3o (tratamento qu\u00edmico e afins)"
    },
    {
        "code": "811330",
        "name": "Operador de filtro-prensa (tratamentos qu\u00edmicos e afins)"
    },
    {
        "code": "811335",
        "name": "Operador de filtros de parafina (tratamentos qu\u00edmicos e afins)"
    },
    {
        "code": "811325",
        "name": "Operador de filtro-esteira (minera\u00e7\u00e3o)"
    },
    {
        "code": "811320",
        "name": "Operador de filtro de tambor rotativo (tratamentos qu\u00edmicos e afins)"
    },
    {
        "code": "811315",
        "name": "Operador de filtro de secagem (minera\u00e7\u00e3o)"
    },
    {
        "code": "811310",
        "name": "Operador de explora\u00e7\u00e3o de petr\u00f3leo"
    },
    {
        "code": "811305",
        "name": "Operador de centrifugadora (tratamentos qu\u00edmicos e afins)"
    },
    {
        "code": "811410",
        "name": "Destilador de produtos qu\u00edmicos (exceto petr\u00f3leo)"
    },
    {
        "code": "811405",
        "name": "Destilador de madeira"
    },
    {
        "code": "811415",
        "name": "Operador de alambique de funcionamento cont\u00ednuo (produtos qu\u00edmicos, exceto petr\u00f3leo)"
    },
    {
        "code": "811420",
        "name": "Operador de aparelho de rea\u00e7\u00e3o e convers\u00e3o (produtos qu\u00edmicos, exceto petr\u00f3leo)"
    },
    {
        "code": "811425",
        "name": "Operador de equipamento de destila\u00e7\u00e3o de \u00e1lcool"
    },
    {
        "code": "811430",
        "name": "Operador de evaporador na destila\u00e7\u00e3o"
    },
    {
        "code": "811505",
        "name": "Operador de painel de controle (refina\u00e7\u00e3o de petr\u00f3leo)"
    },
    {
        "code": "811510",
        "name": "Operador de transfer\u00eancia e estocagem - na refina\u00e7\u00e3o do petr\u00f3leo"
    },
    {
        "code": "811610",
        "name": "Operador de carro de apagamento e coque"
    },
    {
        "code": "811605",
        "name": "Operador de britador de coque"
    },
    {
        "code": "811615",
        "name": "Operador de destila\u00e7\u00e3o e subprodutos de coque"
    },
    {
        "code": "811650",
        "name": "Operador de sistema de revers\u00e3o (coqueria)"
    },
    {
        "code": "811645",
        "name": "Operador de refrigera\u00e7\u00e3o (coqueria)"
    },
    {
        "code": "811640",
        "name": "Operador de reator de coque de petr\u00f3leo"
    },
    {
        "code": "811635",
        "name": "Operador de preserva\u00e7\u00e3o e controle t\u00e9rmico"
    },
    {
        "code": "811630",
        "name": "Operador de painel de controle"
    },
    {
        "code": "811625",
        "name": "Operador de exaustor (coqueria)"
    },
    {
        "code": "811620",
        "name": "Operador de enfornamento e desenfornamento de coque"
    },
    {
        "code": "811705",
        "name": "Bamburista"
    },
    {
        "code": "811710",
        "name": "Calandrista de borracha"
    },
    {
        "code": "811715",
        "name": "Confeccionador de pneum\u00e1ticos"
    },
    {
        "code": "811725",
        "name": "Confeccionador de velas por imers\u00e3o"
    },
    {
        "code": "811775",
        "name": "Trefilador de borracha"
    },
    {
        "code": "811745",
        "name": "Laminador de pl\u00e1stico"
    },
    {
        "code": "811750",
        "name": "Moldador de borracha por compress\u00e3o"
    },
    {
        "code": "811760",
        "name": "Moldador de pl\u00e1stico por compress\u00e3o"
    },
    {
        "code": "811770",
        "name": "Moldador de pl\u00e1stico por inje\u00e7\u00e3o"
    },
    {
        "code": "811735",
        "name": "Confeccionador de velas por moldagem"
    },
    {
        "code": "811805",
        "name": "Operador de m\u00e1quina de produtos farmac\u00eauticos"
    },
    {
        "code": "811810",
        "name": "Drageador (medicamentos)"
    },
    {
        "code": "811820",
        "name": "Operador de m\u00e1quina de fabrica\u00e7\u00e3o de produtos de higiene e limpeza (sab\u00e3o, sabonete, detergente, absorvente, fraldas cotonetes e outros)"
    },
    {
        "code": "811815",
        "name": "Operador de m\u00e1quina de fabrica\u00e7\u00e3o de cosm\u00e9ticos"
    },
    {
        "code": "812105",
        "name": "Pirot\u00e9cnico"
    },
    {
        "code": "812110",
        "name": "Trabalhador da fabrica\u00e7\u00e3o de muni\u00e7\u00e3o e explosivos"
    },
    {
        "code": "813125",
        "name": "Operador de produ\u00e7\u00e3o (qu\u00edmica, petroqu\u00edmica e afins)"
    },
    {
        "code": "813110",
        "name": "Operador de calandra (qu\u00edmica, petroqu\u00edmica e afins)"
    },
    {
        "code": "813130",
        "name": "T\u00e9cnico de opera\u00e7\u00e3o (qu\u00edmica, petroqu\u00edmica e afins)"
    },
    {
        "code": "813120",
        "name": "Operador de processo (qu\u00edmica, petroqu\u00edmica e afins)"
    },
    {
        "code": "813115",
        "name": "Operador de extrusora (qu\u00edmica, petroqu\u00edmica e afins)"
    },
    {
        "code": "813105",
        "name": "Cilindrista (petroqu\u00edmica e afins)"
    },
    {
        "code": "818110",
        "name": "Auxiliar de laborat\u00f3rio de an\u00e1lises f\u00edsico-qu\u00edmicas"
    },
    {
        "code": "818105",
        "name": "Assistente de laborat\u00f3rio industrial"
    },
    {
        "code": "820105",
        "name": "Mestre de siderurgia"
    },
    {
        "code": "820110",
        "name": "Mestre de aciaria"
    },
    {
        "code": "820115",
        "name": "Mestre de alto-forno"
    },
    {
        "code": "820120",
        "name": "Mestre de forno el\u00e9trico"
    },
    {
        "code": "820125",
        "name": "Mestre de lamina\u00e7\u00e3o"
    },
    {
        "code": "820205",
        "name": "Supervisor de fabrica\u00e7\u00e3o de produtos cer\u00e2micos, porcelanatos e afins"
    },
    {
        "code": "820210",
        "name": "Supervisor de fabrica\u00e7\u00e3o de produtos de vidro"
    },
    {
        "code": "821105",
        "name": "Operador de centro de controle"
    },
    {
        "code": "821110",
        "name": "Operador de m\u00e1quina de sinterizar"
    },
    {
        "code": "821210",
        "name": "Forneiro e operador (conversor a oxig\u00eanio)"
    },
    {
        "code": "821215",
        "name": "Forneiro e operador (forno el\u00e9trico)"
    },
    {
        "code": "821220",
        "name": "Forneiro e operador (refino de metais n\u00e3o-ferrosos)"
    },
    {
        "code": "821225",
        "name": "Forneiro e operador de forno de redu\u00e7\u00e3o direta"
    },
    {
        "code": "821230",
        "name": "Operador de aciaria (basculamento de convertedor)"
    },
    {
        "code": "821235",
        "name": "Operador de aciaria (dessulfura\u00e7\u00e3o de gusa)"
    },
    {
        "code": "821240",
        "name": "Operador de aciaria (recebimento de gusa)"
    },
    {
        "code": "821245",
        "name": "Operador de \u00e1rea de corrida"
    },
    {
        "code": "821250",
        "name": "Operador de desgaseifica\u00e7\u00e3o"
    },
    {
        "code": "821255",
        "name": "Soprador de convertedor"
    },
    {
        "code": "821205",
        "name": "Forneiro e operador (alto-forno)"
    },
    {
        "code": "821315",
        "name": "Operador de laminador de barras a quente"
    },
    {
        "code": "821310",
        "name": "Operador de laminador de barras a frio"
    },
    {
        "code": "821305",
        "name": "Operador de laminador"
    },
    {
        "code": "821320",
        "name": "Operador de laminador de metais n\u00e3o-ferrosos"
    },
    {
        "code": "821325",
        "name": "Operador de laminador de tubos"
    },
    {
        "code": "821330",
        "name": "Operador de montagem de cilindros e mancais"
    },
    {
        "code": "821335",
        "name": "Recuperador de guias e cilindros"
    },
    {
        "code": "821415",
        "name": "Marcador de produtos (sider\u00fargico e metal\u00fargico)"
    },
    {
        "code": "821410",
        "name": "Escarfador"
    },
    {
        "code": "821405",
        "name": "Encarregado de acabamento de chapas e metais  (t\u00eampera)"
    },
    {
        "code": "821420",
        "name": "Operador de bobinadeira de tiras a quente, no acabamento de chapas e metais"
    },
    {
        "code": "821450",
        "name": "Rebarbador de metal"
    },
    {
        "code": "821445",
        "name": "Preparador de sucata e aparas"
    },
    {
        "code": "821440",
        "name": "Operador de tesoura mec\u00e2nica e m\u00e1quina de corte, no acabamento de chapas e metais"
    },
    {
        "code": "821435",
        "name": "Operador de jato abrasivo"
    },
    {
        "code": "821425",
        "name": "Operador de cabine de lamina\u00e7\u00e3o (fio-m\u00e1quina)"
    },
    {
        "code": "821430",
        "name": "Operador de esc\u00f3ria e sucata"
    },
    {
        "code": "822110",
        "name": "Forneiro de forno-po\u00e7o"
    },
    {
        "code": "822105",
        "name": "Forneiro de cubil\u00f4"
    },
    {
        "code": "822120",
        "name": "Forneiro de reaquecimento e tratamento t\u00e9rmico na metalurgia"
    },
    {
        "code": "822115",
        "name": "Forneiro de fundi\u00e7\u00e3o (forno de redu\u00e7\u00e3o)"
    },
    {
        "code": "822125",
        "name": "Forneiro de rev\u00e9rbero"
    },
    {
        "code": "823105",
        "name": "Preparador de massa (fabrica\u00e7\u00e3o de abrasivos)"
    },
    {
        "code": "823135",
        "name": "Operador de atomizador"
    },
    {
        "code": "823130",
        "name": "Preparador de aditivos"
    },
    {
        "code": "823125",
        "name": "Preparador de esmaltes (cer\u00e2mica)"
    },
    {
        "code": "823120",
        "name": "Preparador de barbotina"
    },
    {
        "code": "823115",
        "name": "Preparador de massa de argila"
    },
    {
        "code": "823110",
        "name": "Preparador de massa (fabrica\u00e7\u00e3o de vidro)"
    },
    {
        "code": "823210",
        "name": "Extrusor de fios ou fibras de vidro"
    },
    {
        "code": "823215",
        "name": "Forneiro na fundi\u00e7\u00e3o de vidro"
    },
    {
        "code": "823265",
        "name": "Trabalhador na fabrica\u00e7\u00e3o de produtos abrasivos"
    },
    {
        "code": "823255",
        "name": "Temperador de vidro"
    },
    {
        "code": "823250",
        "name": "Operador de prensa de moldar vidro"
    },
    {
        "code": "823245",
        "name": "Operador de m\u00e1quina extrusora de varetas e tubos de vidro"
    },
    {
        "code": "823240",
        "name": "Operador de m\u00e1quina de soprar vidro"
    },
    {
        "code": "823235",
        "name": "Operador de banho met\u00e1lico de vidro por flutua\u00e7\u00e3o"
    },
    {
        "code": "823220",
        "name": "Forneiro no recozimento de vidro"
    },
    {
        "code": "823230",
        "name": "Moldador de abrasivos na fabrica\u00e7\u00e3o de cer\u00e2mica, vidro e porcelana"
    },
    {
        "code": "823320",
        "name": "Trabalhador da elabora\u00e7\u00e3o de pr\u00e9-fabricados (cimento amianto)"
    },
    {
        "code": "823325",
        "name": "Trabalhador da elabora\u00e7\u00e3o de pr\u00e9-fabricados (concreto armado)"
    },
    {
        "code": "823330",
        "name": "Trabalhador da fabrica\u00e7\u00e3o de pedras artificiais"
    },
    {
        "code": "823305",
        "name": "Classificador e empilhador de tijolos refrat\u00e1rios"
    },
    {
        "code": "823315",
        "name": "Forneiro (materiais de constru\u00e7\u00e3o)"
    },
    {
        "code": "828105",
        "name": "Oleiro (fabrica\u00e7\u00e3o de telhas)"
    },
    {
        "code": "828110",
        "name": "Oleiro (fabrica\u00e7\u00e3o de tijolos)"
    },
    {
        "code": "830105",
        "name": "Mestre (ind\u00fastria de celulose, papel e papel\u00e3o)"
    },
    {
        "code": "831105",
        "name": "Cilindreiro na prepara\u00e7\u00e3o de pasta para fabrica\u00e7\u00e3o de papel"
    },
    {
        "code": "831110",
        "name": "Operador de branqueador de pasta para fabrica\u00e7\u00e3o de papel"
    },
    {
        "code": "831115",
        "name": "Operador de digestor de pasta para fabrica\u00e7\u00e3o de papel"
    },
    {
        "code": "831120",
        "name": "Operador de lavagem e depura\u00e7\u00e3o de pasta para fabrica\u00e7\u00e3o de papel"
    },
    {
        "code": "831125",
        "name": "Operador de m\u00e1quina de secar celulose"
    },
    {
        "code": "832110",
        "name": "Operador de cortadeira de papel"
    },
    {
        "code": "832105",
        "name": "Calandrista de papel"
    },
    {
        "code": "832115",
        "name": "Operador de m\u00e1quina de fabricar papel  (fase \u00famida)"
    },
    {
        "code": "832135",
        "name": "Operador de rebobinadeira na fabrica\u00e7\u00e3o de papel e papel\u00e3o"
    },
    {
        "code": "832125",
        "name": "Operador de m\u00e1quina de fabricar papel e papel\u00e3o"
    },
    {
        "code": "832120",
        "name": "Operador de m\u00e1quina de fabricar papel (fase seca)"
    },
    {
        "code": "833105",
        "name": "Cartonageiro, a m\u00e1quina"
    },
    {
        "code": "833110",
        "name": "Confeccionador de bolsas, sacos e sacolas e papel, a m\u00e1quina"
    },
    {
        "code": "833125",
        "name": "Operador de prensa de embutir papel\u00e3o"
    },
    {
        "code": "833120",
        "name": "Operador de m\u00e1quina de cortar e dobrar papel\u00e3o"
    },
    {
        "code": "833115",
        "name": "Confeccionador de sacos de celofane, a m\u00e1quina"
    },
    {
        "code": "833205",
        "name": "Cartonageiro, a m\u00e3o (caixas de papel\u00e3o)"
    },
    {
        "code": "840110",
        "name": "Supervisor da ind\u00fastria de bebidas"
    },
    {
        "code": "840120",
        "name": "Chefe de confeitaria"
    },
    {
        "code": "840115",
        "name": "Supervisor da ind\u00fastria de fumo"
    },
    {
        "code": "840105",
        "name": "Supervisor de produ\u00e7\u00e3o da ind\u00fastria aliment\u00edcia"
    },
    {
        "code": "841105",
        "name": "Moleiro de cereais (exceto arroz)"
    },
    {
        "code": "841110",
        "name": "Moleiro de especiarias"
    },
    {
        "code": "841115",
        "name": "Operador de processo de moagem"
    },
    {
        "code": "841210",
        "name": "Refinador de sal"
    },
    {
        "code": "841205",
        "name": "Moedor de sal"
    },
    {
        "code": "841310",
        "name": "Operador de equipamentos de refina\u00e7\u00e3o de a\u00e7\u00facar (processo cont\u00ednuo)"
    },
    {
        "code": "841305",
        "name": "Operador de cristaliza\u00e7\u00e3o na refina\u00e7\u00e3o de a\u00e7ucar"
    },
    {
        "code": "841320",
        "name": "Operador de tratamento de calda na refina\u00e7\u00e3o de a\u00e7\u00facar"
    },
    {
        "code": "841315",
        "name": "Operador de moenda na fabrica\u00e7\u00e3o de a\u00e7\u00facar"
    },
    {
        "code": "841484",
        "name": "Trabalhador de prepara\u00e7\u00e3o de pescados (limpeza)"
    },
    {
        "code": "841476",
        "name": "Trabalhador de fabrica\u00e7\u00e3o de margarina"
    },
    {
        "code": "841472",
        "name": "Refinador de \u00f3leo e gordura"
    },
    {
        "code": "841468",
        "name": "Preparador de ra\u00e7\u00f5es"
    },
    {
        "code": "841464",
        "name": "Prensador de frutas (exceto oleaginosas)"
    },
    {
        "code": "841460",
        "name": "Operador de prepara\u00e7\u00e3o de gr\u00e3os vegetais (\u00f3leos e gorduras)"
    },
    {
        "code": "841456",
        "name": "Operador de c\u00e2maras frias"
    },
    {
        "code": "841444",
        "name": "Hidrogenador de \u00f3leos e gorduras"
    },
    {
        "code": "841440",
        "name": "Esterilizador de alimentos"
    },
    {
        "code": "841432",
        "name": "Desidratador de alimentos"
    },
    {
        "code": "841428",
        "name": "Cozinhador de pescado"
    },
    {
        "code": "841420",
        "name": "Cozinhador de frutas e legumes"
    },
    {
        "code": "841416",
        "name": "Cozinhador de carnes"
    },
    {
        "code": "841408",
        "name": "Cozinhador (conserva\u00e7\u00e3o de alimentos)"
    },
    {
        "code": "841448",
        "name": "Lagareiro"
    },
    {
        "code": "841505",
        "name": "Trabalhador de tratamento do leite e fabrica\u00e7\u00e3o de latic\u00ednios e afins"
    },
    {
        "code": "841620",
        "name": "Operador de extra\u00e7\u00e3o de caf\u00e9 sol\u00favel"
    },
    {
        "code": "841630",
        "name": "Misturador de ch\u00e1 ou mate"
    },
    {
        "code": "841625",
        "name": "Torrador de cacau"
    },
    {
        "code": "841605",
        "name": "Misturador de caf\u00e9"
    },
    {
        "code": "841610",
        "name": "Torrador de caf\u00e9"
    },
    {
        "code": "841615",
        "name": "Moedor de caf\u00e9"
    },
    {
        "code": "841735",
        "name": "Dessecador de malte"
    },
    {
        "code": "841740",
        "name": "Vinagreiro"
    },
    {
        "code": "841745",
        "name": "Xaropeiro"
    },
    {
        "code": "841725",
        "name": "Malteiro (germina\u00e7\u00e3o)"
    },
    {
        "code": "841730",
        "name": "Cozinhador de malte"
    },
    {
        "code": "841720",
        "name": "Trabalhador de fabrica\u00e7\u00e3o de vinhos"
    },
    {
        "code": "841705",
        "name": "Alambiqueiro"
    },
    {
        "code": "841710",
        "name": "Filtrador de cerveja"
    },
    {
        "code": "841715",
        "name": "Fermentador"
    },
    {
        "code": "841810",
        "name": "Operador de m\u00e1quinas de fabrica\u00e7\u00e3o de doces, salgados e massas aliment\u00edcias"
    },
    {
        "code": "841805",
        "name": "Operador de forno (fabrica\u00e7\u00e3o de p\u00e3es, biscoitos e similares)"
    },
    {
        "code": "841815",
        "name": "Operador de m\u00e1quinas de fabrica\u00e7\u00e3o de chocolates e achocolatados"
    },
    {
        "code": "842135",
        "name": "Operador de m\u00e1quina de prepara\u00e7\u00e3o de mat\u00e9ria prima para produ\u00e7\u00e3o de cigarros"
    },
    {
        "code": "842125",
        "name": "Operador de m\u00e1quina (fabrica\u00e7\u00e3o de cigarros)"
    },
    {
        "code": "842120",
        "name": "Auxiliar de processamento de fumo"
    },
    {
        "code": "842115",
        "name": "Classificador de fumo"
    },
    {
        "code": "842105",
        "name": "Preparador de melado e ess\u00eancia de fumo"
    },
    {
        "code": "842110",
        "name": "Processador de fumo"
    },
    {
        "code": "842205",
        "name": "Preparador de fumo na fabrica\u00e7\u00e3o de charutos"
    },
    {
        "code": "842210",
        "name": "Operador de m\u00e1quina de fabricar charutos e cigarrilhas"
    },
    {
        "code": "842215",
        "name": "Classificador de charutos"
    },
    {
        "code": "842220",
        "name": "Cortador de charutos"
    },
    {
        "code": "842225",
        "name": "Celofanista na fabrica\u00e7\u00e3o de charutos"
    },
    {
        "code": "842235",
        "name": "Degustador de charutos"
    },
    {
        "code": "842230",
        "name": "Charuteiro a m\u00e3o"
    },
    {
        "code": "848110",
        "name": "Salgador de alimentos"
    },
    {
        "code": "848105",
        "name": "Defumador de carnes e pescados"
    },
    {
        "code": "848115",
        "name": "Salsicheiro (fabrica\u00e7\u00e3o de ling\u00fci\u00e7a, salsicha e produtos similares)"
    },
    {
        "code": "848205",
        "name": "Pasteurizador"
    },
    {
        "code": "848210",
        "name": "Queijeiro na fabrica\u00e7\u00e3o de latic\u00ednio"
    },
    {
        "code": "848215",
        "name": "Manteigueiro na fabrica\u00e7\u00e3o de latic\u00ednio"
    },
    {
        "code": "848305",
        "name": "Padeiro"
    },
    {
        "code": "848310",
        "name": "Confeiteiro"
    },
    {
        "code": "848315",
        "name": "Masseiro (massas aliment\u00edcias)"
    },
    {
        "code": "848325",
        "name": "Trabalhador de fabrica\u00e7\u00e3o de sorvete"
    },
    {
        "code": "848425",
        "name": "Classificador de gr\u00e3os"
    },
    {
        "code": "848420",
        "name": "Degustador de vinhos ou licores"
    },
    {
        "code": "848415",
        "name": "Degustador de derivados de cacau"
    },
    {
        "code": "848405",
        "name": "Degustador de caf\u00e9"
    },
    {
        "code": "848410",
        "name": "Degustador de ch\u00e1"
    },
    {
        "code": "848525",
        "name": "Retalhador de carne"
    },
    {
        "code": "848515",
        "name": "Desossador"
    },
    {
        "code": "848510",
        "name": "A\u00e7ougueiro"
    },
    {
        "code": "848505",
        "name": "Abatedor"
    },
    {
        "code": "848520",
        "name": "Magarefe"
    },
    {
        "code": "848605",
        "name": "Trabalhador do beneficiamento de fumo"
    },
    {
        "code": "860105",
        "name": "Supervisor de manuten\u00e7\u00e3o eletromec\u00e2nica (utilidades)"
    },
    {
        "code": "860110",
        "name": "Supervisor de opera\u00e7\u00e3o de fluidos (distribui\u00e7\u00e3o, capta\u00e7\u00e3o, tratamento de \u00e1gua, gases, vapor)"
    },
    {
        "code": "860115",
        "name": "Supervisor de opera\u00e7\u00e3o el\u00e9trica (gera\u00e7\u00e3o, transmiss\u00e3o e distribui\u00e7\u00e3o de energia el\u00e9trica)"
    },
    {
        "code": "861120",
        "name": "Operador de reator nuclear"
    },
    {
        "code": "861115",
        "name": "Operador de central termoel\u00e9trica"
    },
    {
        "code": "861110",
        "name": "Operador de quadro de distribui\u00e7\u00e3o de energia el\u00e9trica"
    },
    {
        "code": "861105",
        "name": "Operador de central hidrel\u00e9trica"
    },
    {
        "code": "861205",
        "name": "Operador de subesta\u00e7\u00e3o"
    },
    {
        "code": "862155",
        "name": "Operador de utilidade (produ\u00e7\u00e3o e distribui\u00e7\u00e3o de vapor, g\u00e1s, \u00f3leo, combust\u00edvel, energia, oxig\u00eanio)"
    },
    {
        "code": "862150",
        "name": "Operador de m\u00e1quinas fixas, em geral"
    },
    {
        "code": "862140",
        "name": "Operador de esta\u00e7\u00e3o de bombeamento"
    },
    {
        "code": "862130",
        "name": "Operador de compressor de ar"
    },
    {
        "code": "862120",
        "name": "Operador de caldeira"
    },
    {
        "code": "862115",
        "name": "Operador de bateria de g\u00e1s de hulha"
    },
    {
        "code": "862105",
        "name": "Foguista (locomotivas a vapor)"
    },
    {
        "code": "862160",
        "name": "Operador de abastecimento de combust\u00edvel de aeronave"
    },
    {
        "code": "862110",
        "name": "Maquinista de embarca\u00e7\u00f5es"
    },
    {
        "code": "862205",
        "name": "Operador de esta\u00e7\u00e3o de capta\u00e7\u00e3o, tratamento e distribui\u00e7\u00e3o de \u00e1gua"
    },
    {
        "code": "862305",
        "name": "Operador de esta\u00e7\u00e3o de tratamento de \u00e1gua e efluentes"
    },
    {
        "code": "862310",
        "name": "Operador de forno de incinera\u00e7\u00e3o no tratamento de \u00e1gua, efluentes e res\u00edduos industriais"
    },
    {
        "code": "862405",
        "name": "Operador de instala\u00e7\u00e3o de extra\u00e7\u00e3o, processamento, envasamento e distribui\u00e7\u00e3o de gases"
    },
    {
        "code": "862505",
        "name": "Operador de instala\u00e7\u00e3o de refrigera\u00e7\u00e3o"
    },
    {
        "code": "862510",
        "name": "Operador de refrigera\u00e7\u00e3o com am\u00f4nia"
    },
    {
        "code": "862515",
        "name": "Operador de instala\u00e7\u00e3o de ar-condicionado"
    },
    {
        "code": "910130",
        "name": "Supervisor de manuten\u00e7\u00e3o de m\u00e1quinas operatrizes e de usinagem"
    },
    {
        "code": "910110",
        "name": "Supervisor de manuten\u00e7\u00e3o de aparelhos t\u00e9rmicos, de climatiza\u00e7\u00e3o e de refrigera\u00e7\u00e3o"
    },
    {
        "code": "910105",
        "name": "Encarregado de manuten\u00e7\u00e3o mec\u00e2nica de sistemas operacionais"
    },
    {
        "code": "910115",
        "name": "Supervisor de manuten\u00e7\u00e3o de bombas, motores, compressores e equipamentos de transmiss\u00e3o"
    },
    {
        "code": "910120",
        "name": "Supervisor de manuten\u00e7\u00e3o de m\u00e1quinas gr\u00e1ficas"
    },
    {
        "code": "910125",
        "name": "Supervisor de manuten\u00e7\u00e3o de m\u00e1quinas industriais t\u00eaxteis"
    },
    {
        "code": "910205",
        "name": "Supervisor da manuten\u00e7\u00e3o e repara\u00e7\u00e3o de ve\u00edculos leves"
    },
    {
        "code": "910210",
        "name": "Supervisor da manuten\u00e7\u00e3o e repara\u00e7\u00e3o de ve\u00edculos pesados"
    },
    {
        "code": "910910",
        "name": "Supervisor de manuten\u00e7\u00e3o de vias f\u00e9rreas"
    },
    {
        "code": "910905",
        "name": "Supervisor de reparos linhas f\u00e9rreas"
    },
    {
        "code": "911125",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de redutores"
    },
    {
        "code": "911120",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de motores diesel (exceto de ve\u00edculos automotores)"
    },
    {
        "code": "911115",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de compressores de ar"
    },
    {
        "code": "911110",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de bombas"
    },
    {
        "code": "911105",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de bomba injetora (exceto de ve\u00edculos automotores)"
    },
    {
        "code": "911130",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de turbinas (exceto de aeronaves)"
    },
    {
        "code": "911135",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de turbocompressores"
    },
    {
        "code": "911205",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o e instala\u00e7\u00e3o de aparelhos de climatiza\u00e7\u00e3o e  refrigera\u00e7\u00e3o"
    },
    {
        "code": "911305",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas, em geral"
    },
    {
        "code": "911310",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas gr\u00e1ficas"
    },
    {
        "code": "911315",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas operatrizes (lavra de madeira)"
    },
    {
        "code": "911320",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas t\u00eaxteis"
    },
    {
        "code": "911325",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas-ferramentas (usinagem de metais)"
    },
    {
        "code": "913110",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de equipamento de minera\u00e7\u00e3o"
    },
    {
        "code": "913105",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de aparelhos de levantamento"
    },
    {
        "code": "913115",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas agr\u00edcolas"
    },
    {
        "code": "913120",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas de constru\u00e7\u00e3o e terraplenagem"
    },
    {
        "code": "914105",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de aeronaves, em geral"
    },
    {
        "code": "914110",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de sistema hidr\u00e1ulico de aeronaves (servi\u00e7os de pista e hangar)"
    },
    {
        "code": "914205",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de motores e equipamentos navais"
    },
    {
        "code": "914305",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de ve\u00edculos ferrovi\u00e1rios"
    },
    {
        "code": "914420",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de tratores"
    },
    {
        "code": "914415",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de motocicletas"
    },
    {
        "code": "914410",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de empilhadeiras e outros ve\u00edculos de cargas leves"
    },
    {
        "code": "914425",
        "name": "Mec\u00e2nico de ve\u00edculos automotores a diesel (exceto tratores)"
    },
    {
        "code": "914405",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de autom\u00f3veis, motocicletas e ve\u00edculos similares"
    },
    {
        "code": "915110",
        "name": "T\u00e9cnico em manuten\u00e7\u00e3o de hidr\u00f4metros"
    },
    {
        "code": "915105",
        "name": "T\u00e9cnico em manuten\u00e7\u00e3o de instrumentos de medi\u00e7\u00e3o e precis\u00e3o"
    },
    {
        "code": "915115",
        "name": "T\u00e9cnico em manuten\u00e7\u00e3o de balan\u00e7as"
    },
    {
        "code": "915205",
        "name": "Restaurador de instrumentos musicais (exceto cordas arcadas)"
    },
    {
        "code": "915210",
        "name": "Reparador de instrumentos musicais"
    },
    {
        "code": "915215",
        "name": "Luthier (restaura\u00e7\u00e3o de cordas arcadas)"
    },
    {
        "code": "915305",
        "name": "T\u00e9cnico em manuten\u00e7\u00e3o de equipamentos e instrumentos m\u00e9dico-hospitalares"
    },
    {
        "code": "915405",
        "name": "Reparador de equipamentos fotogr\u00e1ficos"
    },
    {
        "code": "919105",
        "name": "Lubrificador industrial"
    },
    {
        "code": "919115",
        "name": "Lubrificador de embarca\u00e7\u00f5es"
    },
    {
        "code": "919110",
        "name": "Lubrificador de ve\u00edculos automotores (exceto embarca\u00e7\u00f5es)"
    },
    {
        "code": "919205",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de m\u00e1quinas cortadoras de grama, ro\u00e7adeiras, motosserras e similares"
    },
    {
        "code": "919310",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de bicicletas e ve\u00edculos similares"
    },
    {
        "code": "919305",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de aparelhos esportivos e de gin\u00e1stica"
    },
    {
        "code": "919315",
        "name": "Montador de bicicletas"
    },
    {
        "code": "950105",
        "name": "Supervisor de manuten\u00e7\u00e3o el\u00e9trica de alta tens\u00e3o industrial"
    },
    {
        "code": "950110",
        "name": "Supervisor de manuten\u00e7\u00e3o eletromec\u00e2nica industrial, comercial e predial"
    },
    {
        "code": "950205",
        "name": "Encarregado de manuten\u00e7\u00e3o el\u00e9trica de ve\u00edculos"
    },
    {
        "code": "950305",
        "name": "Supervisor de manuten\u00e7\u00e3o eletromec\u00e2nica"
    },
    {
        "code": "951105",
        "name": "Eletricista de manuten\u00e7\u00e3o eletroeletr\u00f4nica"
    },
    {
        "code": "951315",
        "name": "Monitor de sistemas eletr\u00f4nicos de seguran\u00e7a interno"
    },
    {
        "code": "951320",
        "name": "Monitor de sistemas eletr\u00f4nicos de seguran\u00e7a externo"
    },
    {
        "code": "951310",
        "name": "Mantenedor de sistemas eletroeletr\u00f4nicos de seguran\u00e7a"
    },
    {
        "code": "951305",
        "name": "Instalador de sistemas eletroeletr\u00f4nicos de seguran\u00e7a"
    },
    {
        "code": "953105",
        "name": "Eletricista de instala\u00e7\u00f5es (aeronaves)"
    },
    {
        "code": "953115",
        "name": "Eletricista de instala\u00e7\u00f5es (ve\u00edculos automotores e m\u00e1quinas operatrizes, exceto aeronaves e embarca\u00e7\u00f5es)"
    },
    {
        "code": "953110",
        "name": "Eletricista de instala\u00e7\u00f5es (embarca\u00e7\u00f5es)"
    },
    {
        "code": "954105",
        "name": "Eletromec\u00e2nico de manuten\u00e7\u00e3o de elevadores"
    },
    {
        "code": "954110",
        "name": "Eletromec\u00e2nico de manuten\u00e7\u00e3o de escadas rolantes"
    },
    {
        "code": "954115",
        "name": "Eletromec\u00e2nico de manuten\u00e7\u00e3o de portas autom\u00e1ticas"
    },
    {
        "code": "954120",
        "name": "Mec\u00e2nico de manuten\u00e7\u00e3o de instala\u00e7\u00f5es mec\u00e2nicas de edif\u00edcios"
    },
    {
        "code": "954125",
        "name": "Operador eletromec\u00e2nico"
    },
    {
        "code": "954205",
        "name": "Reparador de aparelhos eletrodom\u00e9sticos (exceto imagem e som)"
    },
    {
        "code": "954210",
        "name": "Reparador de r\u00e1dio, tv e som"
    },
    {
        "code": "954305",
        "name": "Reparador de equipamentos de escrit\u00f3rio"
    },
    {
        "code": "991105",
        "name": "Conservador de via permanente (trilhos)"
    },
    {
        "code": "991110",
        "name": "Inspetor de via permanente (trilhos)"
    },
    {
        "code": "991115",
        "name": "Operador de m\u00e1quinas especiais em conserva\u00e7\u00e3o de via permanente (trilhos)"
    },
    {
        "code": "991120",
        "name": "Soldador aluminot\u00e9rmico em conserva\u00e7\u00e3o de trilhos"
    },
    {
        "code": "991205",
        "name": "Mantenedor de equipamentos de parques de divers\u00f5es e similares"
    },
    {
        "code": "991305",
        "name": "Funileiro de ve\u00edculos (repara\u00e7\u00e3o)"
    },
    {
        "code": "991310",
        "name": "Montador de ve\u00edculos (repara\u00e7\u00e3o)"
    },
    {
        "code": "991315",
        "name": "Pintor de ve\u00edculos (repara\u00e7\u00e3o)"
    },
    {
        "code": "992105",
        "name": "Alinhador de pneus"
    },
    {
        "code": "992120",
        "name": "Lavador de pe\u00e7as"
    },
    {
        "code": "992115",
        "name": "Borracheiro"
    },
    {
        "code": "992110",
        "name": "Balanceador"
    },
    {
        "code": "992205",
        "name": "Encarregado geral de opera\u00e7\u00f5es de conserva\u00e7\u00e3o de vias permanentes (exceto trilhos)"
    },
    {
        "code": "992220",
        "name": "Pedreiro de conserva\u00e7\u00e3o de vias permanentes (exceto trilhos)"
    },
    {
        "code": "992215",
        "name": "Operador de ceifadeira na conserva\u00e7\u00e3o de vias permanentes"
    },
    {
        "code": "992210",
        "name": "Encarregado de equipe de conserva\u00e7\u00e3o de vias permanentes (exceto trilhos)"
    },
    {
        "code": "992225",
        "name": "Auxiliar geral de conserva\u00e7\u00e3o de vias permanentes (exceto trilhos)"
    }
]

class CBO {
    static getCBOs() {
        return CBOs
    }
}
export default CBO;



// WEBPACK FOOTER //
// ./src/data/CBO.js